// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

/* ── Mobile overrides moved to bottom of file (must come after base styles) ── */


:root {
  /* Brand greens (--td-green, --td-dark-green, --td-accent) are now defined
     in styles/theme.css using BeHuman values. Don't redeclare them here. */
  --td-positive-green: #2ea854;
  --bg-light-gray: #f2f4f5;
  --border-color: #e6e6e6;
  --text-dark: #222222;
  --text-medium: #666666;
  --text-light: #6b6b6b; /* muted text — kept ≥4.5:1 (WCAG AA) on white/gray surfaces */
  --bg-screen: white;
  --bg-card: white;

  /* ── Fluid type scale (clamp: min, preferred, max) ── */
  --font-2xs:  clamp(0.5rem,   0.45rem + 0.2vw,  0.625rem);  /*  8-10px */
  --font-xs:   clamp(0.625rem, 0.55rem + 0.25vw, 0.75rem);   /* 10-12px */
  --font-sm:   clamp(0.75rem,  0.7rem  + 0.2vw,  0.875rem);  /* 12-14px */
  --font-base: clamp(0.875rem, 0.8rem  + 0.25vw, 1rem);      /* 14-16px */
  --font-lg:   clamp(1rem,     0.9rem  + 0.35vw, 1.25rem);   /* 16-20px */
  --font-xl:   clamp(1.25rem,  1.1rem  + 0.5vw,  1.75rem);   /* 20-28px */
  --font-2xl:  clamp(1.5rem,   1.2rem  + 0.8vw,  2.25rem);   /* 24-36px */
  --font-3xl:  clamp(2rem,     1.5rem  + 1.2vw,  3rem);       /* 32-48px */
}

/* ── Skip navigation link (a11y) ── */
.skip-link {
  position: absolute;
  top: -100%;
  left: 0;
  z-index: 9999;
  padding: 0.75rem 1rem;
  background: var(--td-green);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
}
.skip-link:focus { top: 0; }

/* ── Responsive media defaults ── */
img, video, svg { max-width: 100%; height: auto; }

/* ── Global touch-target minimum (WCAG 2.5.8) ── */
@media (pointer: coarse) {
  button, a, [role="button"], select { min-height: 2.75rem; min-width: 2.75rem; }
}

body, html {
  margin: 0;
  padding: 0;
  font-family: 'TD Graphik', 'Graphik', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: var(--bg-screen);
  min-height: 100%;
  min-height: 100dvh;
  height: 100%;
  height: 100dvh;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}

#root, .App {
  min-height: 100%;
  min-height: 100dvh;
  height: 100%;
  height: 100dvh;
}

/* --- Layout Containers (mobile-first) --- */

.app-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  height: 100dvh;
  min-height: 0;
  box-sizing: border-box;
}

.login-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(1200px 600px at 0% 0%, var(--td-green-light) 0%, transparent 60%),
    radial-gradient(900px 500px at 100% 100%, var(--td-green-light) 0%, transparent 55%),
    var(--bh-white);
  color: var(--bh-black);
  z-index: 9999;
  padding: var(--space-md);
}

.login-box {
  width: min(92vw, 400px);
  padding: var(--space-lg);
  border-radius: var(--radius-xl);
  background: var(--bh-white);
  border: 1px solid var(--bh-light-gray);
  box-shadow: var(--shadow-xl);
  text-align: left;
}

.login-brand {
  font: var(--bh-h2);
  letter-spacing: -0.02em;
  color: var(--td-green);
  margin-bottom: var(--space-md);
}

.login-box h1 {
  margin: 0 0 var(--space-2xs);
  font: var(--bh-h2);
  color: var(--bh-black);
}

.login-subtitle {
  margin: 0 0 var(--space-md);
  font: var(--bh-body);
  color: var(--bh-gray);
}

.login-box label {
  display: block;
  margin-top: var(--space-sm);
  margin-bottom: var(--space-3xs);
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--bh-dark);
}

.login-submit {
  margin-top: var(--space-md);
  width: 100%;
}

.login-error {
  margin-top: var(--space-2xs);
  color: var(--td-red);
  font: var(--bh-body-sm);
}

.login-notice {
  margin-top: var(--space-2xs);
  color: var(--td-green, #008a00);
  font: var(--bh-body-sm);
}

.login-toggle-note {
  margin-top: var(--space-md);
  font: var(--bh-caption);
  color: var(--bh-gray);
  text-align: center;
}

.login-link-btn {
  background: none;
  border: none;
  padding: 0;
  color: var(--td-green, #008a00);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

/* Mobile: phone-viewport fills the whole screen */
.phone-viewport {
  flex: 1 1;
  width: 100%;
  min-height: 0;
  background-color: var(--bg-screen);
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* ── Desktop: wrap app in a phone-frame widget ── */
@media (min-width: 601px) {
  body, html { background-color: #333; overflow: hidden; }
  .app-container {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 100dvh;
    padding: 20px;
    height: auto;
  }
  .phone-viewport {
    width: 390px;
    height: 844px;
    flex: none;
    border-radius: 30px;
    box-shadow: 0 20px 40px rgba(0,0,0,0.4);
    border: 8px solid #111;
    display: flex;
    flex-direction: column;
  }
}

/* ── Mobile demo pulldown tab: hidden by default, shown in media query below ── */
.demo-pulldown-tab {
  display: none;
}

.demo-nav-login-toggle {
  margin: 10px 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 0.82rem;
}

.demo-nav-role {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  padding: 2px 7px;
  border-radius: 4px;
  line-height: 1;
}
.demo-nav-role.admin {
  background: rgba(34,197,94,0.25);
  color: #4ade80;
}
.demo-nav-role.guest {
  background: rgba(250,204,21,0.22);
  color: #facc15;
}

.demo-nav-login-btn {
  border: 1px solid rgba(255,255,255,0.6);
  background-color: rgba(0,0,0,0.3);
  color: #fff;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  font-weight: 500;
}

.demo-nav-login-btn.active {
  background-color: #00a86b;
}


/* ── Mobile demo drawer ────────────────────────────────────────────── */
.demo-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1490;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.demo-drawer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 100%;
  height: 100dvh;
  max-height: 100dvh;
  z-index: 1500;
  border-radius: 0;
  transform: translateY(-105%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 14px max(env(safe-area-inset-bottom), 32px);
  box-sizing: border-box;
  background: rgba(18, 14, 32, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-right: none;
  border-bottom: none;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.1) transparent;
}
.demo-drawer::-webkit-scrollbar { width: 3px; }
.demo-drawer::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 3px; }

.demo-drawer.open {
  transform: translateY(0);
}

.demo-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.demo-drawer-close {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.6);
  border-radius: 6px;
  width: 44px;
  height: 44px;
  font-size: var(--font-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.demo-drawer-close:hover {
  background: rgba(255,255,255,0.15);
  color: #fff;
}

/* reuse demo-nav inner styles inside the drawer */
.demo-drawer .demo-nav-grid,
.demo-drawer .demo-nav-label,
.demo-drawer .demo-nav-btn,
.demo-drawer .demo-nav-full-btn,
.demo-drawer .demo-nav-select,
.demo-drawer .demo-nav-hr,
.demo-drawer .demo-nav-title {
  /* inherits styles from .demo-nav-* — no override needed */
}

.screen {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-screen);
  padding-bottom: 62px; /* clear the bottom nav on desktop */
  box-sizing: border-box;
}

.scroll-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(128,128,128,0.2) transparent;
}
.scroll-content::-webkit-scrollbar { width: 4px; }
.scroll-content::-webkit-scrollbar-track { background: transparent; }
.scroll-content::-webkit-scrollbar-thumb {
  background: rgba(100,100,100,0.25);
  border-radius: 4px;
}
.scroll-content::-webkit-scrollbar-thumb:hover {
  background: rgba(100,100,100,0.45);
}
.scroll-content {
  scrollbar-color: rgba(100,100,100,0.25) transparent;
}

.gray-bg { background-color: var(--bg-light-gray); }
.white-bg { background-color: var(--bg-card); }
.positive-green { color: var(--td-positive-green); font-weight: 600; }

/* --- Headers --- */

.simple-header {
  background-color: var(--td-green);
  color: white;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.new-chat-button {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: var(--font-base);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.new-chat-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.new-chat-button:active {
  background-color: rgba(255, 255, 255, 0.25);
}

.back-icon { font-size: var(--font-2xl); cursor: pointer; }
.header-title { margin: 0; font-size: var(--font-lg); font-weight: 500; color: white; }

.chat-header-outer {
  flex-direction: column;
  align-items: stretch;
  padding: 12px 16px 6px;
}

.chat-header-main-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-model-label {
  font-size: var(--font-xs);
  font-weight: 400;
  text-align: center;
  padding-top: 5px;
  opacity: 0.65;
  letter-spacing: 0.3px;
  color: white;
  line-height: 1;
}
.chat-title-text {
  font-weight: 600;
  opacity: 1;
}
.chat-title-sep {
  opacity: 0.5;
}
.main-content {
    padding: 4px 0 20px;
    flex: 1 1;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
}
.main-content::-webkit-scrollbar { display: none; }

.nav-list {
    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
}

.nav-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 20px;
    background: var(--bg-card);
    border-bottom: 1px solid var(--border-color);
    cursor: pointer;
    color: var(--text-dark);
    font-size: var(--font-lg);
}
.nav-item:last-child { border-bottom: none; }

.nav-icon {
    font-size: var(--font-xl);
    margin-right: 15px;
    color: var(--text-medium);
}

.home-promo-banner {
  position: relative;
  margin: var(--space-2xs) var(--space-sm) var(--space-md);
  border-radius: var(--radius-xl);
  overflow: hidden;
  height: 160px;
  box-shadow: var(--shadow-lg);
}

.home-promo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.home-promo-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 14px 16px 16px;
}

.home-promo-top {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.home-promo-tag {
  font-size: var(--font-xs);
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.75);
  margin-bottom: 4px;
}

.home-promo-headline {
  font-size: var(--font-base);
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
  max-width: 180px;
  text-align: right;
}

.home-promo-bottom {
  display: flex;
  justify-content: center;
}

.home-promo-btn {
  background: var(--bh-white);
  color: var(--td-green);
  border: none;
  padding: 8px 24px;
  border-radius: var(--radius-full);
  font: var(--bh-body-sm);
  font-weight: 600;
  cursor: pointer;
  min-height: 36px;
  transition: background 200ms ease-in-out, color 200ms ease-in-out, box-shadow 200ms ease-in-out;
}
.home-promo-btn:hover {
  background: var(--td-green);
  color: var(--bh-white);
  box-shadow: var(--shadow-green);
}


.bottom-links {
    display: flex;
    justify-content: space-around;
    padding: 20px;
    border-top: 1px solid var(--border-color);
    color: var(--text-medium);
}

.bottom-link-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 4px;
}
.bottom-link-item span { font-size: var(--font-sm); }
.vertical-divider { width: 1px; background-color: var(--border-color); height: 24px; }


/* --- Screen 2: Accounts Specifics --- */

.list-group-title {
    padding: 15px 20px 5px;
    font-size: var(--font-sm);
    color: var(--text-medium);
    font-weight: 500;
}
.list-group-title.compact { padding-top: 25px; padding-bottom: 10px; }

.white-container { background: var(--bg-card); border-bottom: 1px solid var(--border-color); }

.account-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid var(--border-color);
    cursor: pointer;
}
.ali-left { min-width: 0; flex: 1 1; }
.ali-name { font-weight: 500; font-size: var(--font-lg); text-align: left; color: var(--text-dark); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ali-num { color: var(--text-medium); font-size: var(--font-base); margin-top: 4px; text-align: left; }
.ali-right { display: flex; align-items: center; flex-shrink: 0; }
.ali-currency { font-size: var(--font-sm); color: var(--text-medium); margin-right: 5px; }
.ali-balance { font-size: var(--font-lg); font-weight: 500; margin-right: 10px; color: var(--text-dark); }
.ali-arrow { color: var(--text-light); font-size: var(--font-xl); }

.account-total-row {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    font-weight: 500;
    background-color: var(--bg-card);
    color: var(--text-dark);
}
.total-values { text-align: right; }
.usd-subtotal { font-size: var(--font-base); color: var(--text-medium); margin-top: 5px; }

.footer-disclaimer { padding: 20px; color: var(--text-medium); font-size: var(--font-sm); }
.footer-disclaimer p { margin: 0 0 5px 0; }
.footer-disclaimer a { display: block; color: var(--td-green); text-decoration: none; margin-bottom: 5px;}


/* --- Screen 4: Chat Specifics --- */

.chat-content-bg {
  background-color: var(--bg-light-gray); /* Light gray-blue background used in chat apps */
  padding: 20px 12px;        /* horizontal padding so user bubbles don't kiss the wall */
  display: flex;
  flex-direction: column;
}

.chat-timestamp {
  text-align: center;
  color: var(--text-medium);
  font-size: var(--font-sm);
  margin-bottom: 20px;
  font-weight: 500;
}

.chat-message-container {
  display: flex;
  margin-bottom: 10px;
  align-items: flex-end;
  gap: 8px;
}

.bot-message {
  justify-content: flex-start;
}

.user-message {
  justify-content: flex-end;
}

.bot-avatar {
  width: 28px;
  height: 28px;
  background-color: var(--bg-card);
  border: 1.5px solid var(--border-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--td-green);
  font-size: var(--font-base);
  flex-shrink: 0;
}

.chat-bubble {
  max-width: 75%;
  padding: 10px 14px;
  border-radius: 18px;
  font-size: var(--font-base);
  line-height: 1.45;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

.bot-message .chat-bubble {
  background-color: var(--bg-card);
  color: var(--text-dark);
  border-bottom-left-radius: 4px;
  text-align: left;
  max-width: 100%;          /* let bot bubbles fill the wider wrapper */
}

.user-message .chat-bubble {
  background-color: var(--td-green);
  color: white;
  border-bottom-right-radius: 4px;
  text-align: left;
}

/* Chat Carousel */
.chat-carousel-container {
  display: flex;
  justify-content: center;
  overflow-x: auto;
  gap: 15px;
  padding: 10px 16px 20px 16px;
  margin-bottom: 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.chat-carousel-container::-webkit-scrollbar { display: none; }

.chat-carousel-card {
  flex: 0 0 220px;
  background-color: var(--bg-card);
  padding: 22px 18px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.carousel-icon {
  font-size: var(--font-3xl);
  color: var(--td-green);
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
}
.chat-carousel-card h3 {
  margin: 0 0 8px 0;
  font-size: var(--font-base);
  font-weight: 600;
  color: var(--text-dark);
  text-align: center;
}
.chat-carousel-card p {
  margin: 0;
  font-size: var(--font-sm);
  line-height: 1.5;
  color: var(--text-medium);
  text-align: center;
}


/* Chat Input Area */
.chat-input-area {
  background-color: var(--bg-card);
  border-top: 1px solid var(--border-color);
  padding: 15px 16px 25px; /* Extra padding for bottom safe area */
}

.suggestions-row {
  display: flex;
  overflow-x: auto;
  gap: 8px;
  margin-bottom: 12px;
  padding: 2px 0 4px;
  /* Thin styled scrollbar so users know it's scrollable */
  scrollbar-width: thin;
  scrollbar-color: var(--border-color) transparent;
}
.suggestions-row::-webkit-scrollbar {
  height: 3px;
}
.suggestions-row::-webkit-scrollbar-track {
  background: transparent;
}
.suggestions-row::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.chat-suggestion-chip {
  flex: 0 0 auto;
  background-color: var(--bg-card);
  border: 1px solid var(--td-green);
  color: var(--td-green);
  padding: 10px 18px;
  border-radius: 25px;
  font-size: var(--font-base);
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.chat-suggestion-chip:hover { background-color: #f0f9f4; }

.input-row {
  display: flex;
  align-items: center;
  background-color: var(--bg-light-gray);
  border-radius: 30px;
  padding: 6px 6px 6px 20px;
}

.input-row input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: var(--font-lg);
  outline: none;
  color: var(--text-dark);
}
.input-row input::placeholder { color: var(--text-light); }

.send-button {
  width: 44px;
  height: 44px;
  background-color: var(--td-green);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xl);
  cursor: pointer;
  margin-left: 10px;
  transition: background-color 0.2s;
}
.send-button:hover { background-color: var(--td-dark-green); }
.send-button.stop-button:hover { background-color: var(--td-dark-green); }

/* Thinking animation on stop button */
.send-button.stop-button--thinking {
  position: relative;
}

.send-button.stop-button--thinking .thinking-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 28px;
  height: 28px;
  border: 2px solid transparent;
  border-top-color: white;
  border-radius: 50%;
  animation: thinking-spin 1.5s linear infinite;
  pointer-events: none;
}

@keyframes thinking-spin {
  0%   { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}

/* --- Demo Nav (Liquid Glass) --- */

.demo-nav {
  position: fixed;
  bottom: 12px;
  left: 12px;
  width: 188px;
  max-height: 92vh;
  overflow-y: auto;
  background: rgba(10, 10, 18, 0.22);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.05);
  padding: 10px 9px;
  z-index: 1000;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.10) transparent;
}
.demo-nav::-webkit-scrollbar { width: 3px; }
.demo-nav::-webkit-scrollbar-track { background: transparent; }
.demo-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.14); border-radius: 3px; }

.demo-nav-title {
  margin: 0 0 7px;
  font-size: var(--font-2xs);
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.38);
}
.demo-nav-build-info {
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: rgba(255,255,255,0.22);
  margin-bottom: 4px;
}

.demo-nav-label {
  margin: 0 0 4px;
  font-size: var(--font-2xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.38);
}

/* Sub-tier label (e.g. "Free", "Paid", "Local" under "AI Backend"). Sits
   inline to the left of its row of buttons via .demo-nav-tier-row. */
.demo-nav-sublabel {
  margin: 0;
  font-size: var(--font-2xs);
  font-weight: 600;
  color: rgba(255,255,255,0.55);
  min-width: 38px;
  flex-shrink: 0;
}

/* Horizontal sub-tier row: [label] [button-grid] in one line. Compact
   vertical footprint vs. stacking label above buttons. */
.demo-nav-tier-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 3px;
}
.demo-nav-tier-row .demo-nav-grid-2 {
  flex: 1 1;
  margin-bottom: 0;
}

.demo-nav hr {
  border: none;
  border-top: 1px solid rgba(255,255,255,0.08);
  margin: 7px 0;
}

.demo-nav-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
  margin-bottom: 0;
}

.demo-nav-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
}

.demo-nav-btn {
  background: rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.65);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 7px;
  padding: 4px 2px;
  font-size: var(--font-2xs);
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: inherit;
}
.demo-nav-btn:hover {
  background: rgba(255,255,255,0.14);
  color: rgba(255,255,255,0.9);
}
.demo-nav-btn.active {
  background: rgba(255,255,255,0.2);
  color: #fff;
  border-color: rgba(255,255,255,0.22);
  font-weight: 600;
}

.demo-nav-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
}

.demo-nav-select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  font-size: var(--font-2xs);
  padding: 3px 5px;
  border-radius: 7px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  font-family: inherit;
}

.demo-nav-select option,
.demo-nav-select optgroup {
  background: #1e1e2e;
  color: #f0f0f0;
}

.demo-nav-full-btn {
  width: 100%;
  padding: 5px 6px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
  font-size: var(--font-2xs);
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.03em;
  font-family: inherit;
  transition: opacity 0.12s;
}
.demo-nav-full-btn:hover { opacity: 0.85; }

/* --- Theme Toggle (top-right float) --- */

.theme-toggle-float {
  position: fixed;
  top: 14px;
  right: 14px;
  z-index: 1001;
  display: flex;
  align-items: center;
  background: rgba(10, 10, 18, 0.55);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50px;
  padding: 3px 5px;
  gap: 2px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.35);
}

.theme-toggle-btn {
  width: 28px;
  height: 24px;
  border-radius: 40px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-sm);
  transition: background 0.18s;
  background: transparent;
}
.theme-toggle-btn.active {
  background: rgba(255,255,255,0.16);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.2);
}

.profile-picker-float {
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(10, 10, 18, 0.55);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50px;
  padding: 5px 11px 5px 8px;
  box-shadow: 0 4px 18px rgba(0,0,0,0.35);
  cursor: pointer;
  font-size: var(--font-xs);
  font-weight: 500;
  color: rgba(255,255,255,0.75);
  transition: background 0.15s, color 0.15s;
  max-width: 140px;
}
.profile-picker-float:hover { background: rgba(10,10,18,0.75); color: #fff; }
.profile-picker-float.loaded { color: #fff; border-color: rgba(255,255,255,0.18); }
.profile-picker-float span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* --- Global Save Button --- */
.global-save-btn {
  position: fixed;
  top: 86px; /* sits below the profile picker pill (~52 + pill height ~28 + 6px gap) */
  right: 14px;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: rgba(10, 10, 18, 0.55);
  backdrop-filter: blur(20px) saturate(160%);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50%;
  box-shadow: 0 4px 18px rgba(0,0,0,0.35);
  cursor: pointer;
  color: rgba(255,255,255,0.75);
  transition: background 0.15s, color 0.15s;
}
.global-save-btn:hover { background: rgba(10,10,18,0.75); color: #fff; }
.global-save-btn.saving { opacity: 0.5; cursor: default; }
.global-save-btn.saved { background: rgba(0,180,80,0.6); border-color: rgba(0,220,100,0.4); color: #fff; }
.global-save-btn.error { background: rgba(220,50,50,0.6); border-color: rgba(255,80,80,0.4); color: #fff; }

/* --- Profile Dropdown --- */
.profile-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 180px;
  background: rgba(18, 18, 28, 0.92);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.45);
  overflow: hidden;
  z-index: 1201;
}
.profile-dropdown-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 9px 14px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  transition: background 0.12s;
}
.profile-dropdown-item:last-child { border-bottom: none; }
.profile-dropdown-item:hover { background: rgba(255,255,255,0.08); }
.profile-dropdown-item.active { background: rgba(255,255,255,0.12); }
.profile-dropdown-label {
  font-size: var(--font-sm);
  font-weight: 600;
  color: rgba(255,255,255,0.9);
  line-height: 1.3;
}
.profile-dropdown-sub {
  font-size: var(--font-xs);
  color: rgba(255,255,255,0.45);
  margin-top: 1px;
}

/* --- Sidebar Styling --- */
.sidebar-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
}

.sidebar-content {
  width: 80%;
  height: 100%;
  background: var(--bg-card);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

.sidebar-scroll { flex: 1 1; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(128,128,128,0.2) transparent; }
.sidebar-scroll::-webkit-scrollbar { width: 4px; }
.sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
.sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }
.sidebar-scroll::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }

.sidebar-item {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  color: var(--text-dark);
  font-size: var(--font-base);
  border-bottom: 0.5px solid var(--border-color);
}

.logout-item { background: var(--bg-light-gray); color: var(--text-light); border-bottom: 2px solid var(--border-color); }
.sidebar-icon { font-size: var(--font-xl); margin-right: 15px; color: var(--text-medium); }
.sidebar-divider { height: 20px; background: var(--bg-light-gray); border-bottom: 1px solid var(--border-color); }

/* --- Locations Screen --- */
.search-bar-container { background: var(--td-green); padding: 10px 15px; }
.search-bar {
  background: var(--bg-card);
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
}
.search-icon { color: var(--text-light); margin-right: 10px; }
.search-bar input { border: none; outline: none; width: 100%; font-size: var(--font-base); background: transparent; color: var(--text-dark); }

.map-container {
  height: 250px;
  background: var(--bg-light-gray);
  overflow: hidden;
  border-radius: 8px;
  margin: 0 20px;
}

.map-container iframe,
.map-container .leaflet-container {
  width: 100%;
  height: 100% !important;
  border-radius: 8px;
}

.location-list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border-color);
}
.loc-info { flex: 1 1; display: flex; flex-direction: column; text-align: left; }
.loc-address { font-weight: 600; font-size: var(--font-base); color: var(--text-dark); }
.loc-city, .loc-status { font-size: var(--font-sm); color: var(--text-medium); margin-top: 2px; }
.loc-status { color: var(--td-green); font-weight: 500; }
.loc-dist { display: flex; align-items: center; color: var(--td-green); font-weight: 600; font-size: var(--font-base); margin-left: 15px; white-space: nowrap; }

/* --- Receipt Screen --- */
.receipt-header { background: var(--td-dark-green); color: white; padding: 15px 20px; display: flex; justify-content: space-between; align-items: center; }
.receipt-success-block { background: var(--td-green); color: white; padding: 30px 20px; text-align: center; }
.success-title { font-size: var(--font-2xl); margin: 0; font-weight: 400; }
.success-subtitle { font-size: var(--font-lg); margin: 5px 0 15px 0; }
.confirmation-num { font-size: var(--font-xs); opacity: 0.8; line-height: 1.4; }

.receipt-details { padding: 20px; border-bottom: 1px solid var(--border-color); }
.receipt-row { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 0.5px solid var(--border-color); font-size: var(--font-base); color: var(--text-dark); }
.receipt-row:last-child { border-bottom: none; }
.receipt-row span { color: var(--text-light); }

.receipt-actions { display: flex; justify-content: space-around; padding: 20px 10px; }
.receipt-action-btn { display: flex; flex-direction: column; align-items: center; text-align: center; max-width: 80px; cursor: pointer; }
.ra-icon { width: 50px; height: 50px; border-radius: 50%; border: 1px solid var(--td-green); display: flex; align-items: center; justify-content: center; color: var(--td-green); font-size: var(--font-xl); margin-bottom: 8px; }
.receipt-action-btn span { font-size: var(--font-xs); color: var(--text-medium); font-weight: 600; }

/* --- Card Management Styling --- */
.card-display-container {
  padding: 40px 20px;
  display: flex;
  justify-content: center;
}

.aeroplan-card {
  width: 280px;
  height: 170px;
  border-radius: 12px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.card-top { display: flex; justify-content: space-between; font-weight: bold; }
.card-chip { width: 40px; height: 30px; background: #c0c0c0; border-radius: 4px; }
.card-bottom { display: flex; flex-direction: column; gap: 5px; }
.card-number { letter-spacing: 2px; font-size: var(--font-lg); }

.card-quick-actions {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}

.cqa-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.cqa-icon {
  width: 60px;
  height: 60px;
  background: var(--bg-card);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xl);
  color: var(--text-dark);
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.cqa-item span { font-size: var(--font-sm); color: var(--text-medium); }

.pin-display {
  text-align: center;
  font-size: var(--font-3xl);
  font-weight: bold;
  letter-spacing: 15px;
  margin-top: 50px;
  color: var(--text-dark);
}

/* --- Security Screen Styling --- */
.security-header { padding-bottom: 80px; }

.security-quick-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.sqa-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  width: 80px;
}

.sqa-icon {
  width: 50px;
  height: 50px;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xl);
  margin-bottom: 8px;
}

.sqa-item span { font-size: var(--font-xs); text-align: center; line-height: 1.2; }

/* --- Toggle Switch & Frozen States --- */

.toggle-btn {
  transition: all 0.3s ease;
  cursor: pointer;
}

/* When the freeze button is active */
.active-frozen {
  background-color: #e3f2fd !important; /* Light blue background */
  color: #1976d2 !important; /* Blue icon color */
  border: 2px solid #1976d2;
  transform: scale(1.05);
}

/* Visual overlay for the card when frozen */
.frozen-overlay {
  position: relative;
  opacity: 0.6;
  filter: grayscale(80%);
  transition: all 0.4s ease;
}

.frozen-overlay::after {
  content: 'FROZEN';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-15deg);
  border: 3px solid white;
  padding: 5px 15px;
  font-weight: 900;
  letter-spacing: 4px;
  font-size: var(--font-xl);
  border-radius: 8px;
  pointer-events: none;
}

.frozen-status-msg {
  margin: 20px;
  padding: 15px;
  background-color: #fff3f3;
  border: 1px solid #ffcdd2;
  color: #d32f2f;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-sm);
  font-weight: 500;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* --- In-App Call Styling --- */
.call-header {
  background: var(--td-green);
  color: white;
}

.call-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-left: 20px;
  padding-right: 20px;
}

.call-hero {
  text-align: center;
  margin-bottom: 40px;
}

.call-avatar-container {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
}

.call-avatar {
  width: 100%;
  height: 100%;
  background: var(--td-green);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.call-ripple {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  border-radius: 50%;
  background: var(--td-green);
  z-index: 1;
  opacity: 0;
}

.call-ripple.animate {
  animation: rippleEffect 2s infinite;
}

@keyframes rippleEffect {
  0% { transform: scale(1); opacity: 0.4; }
  100% { transform: scale(1.8); opacity: 0; }
}

.call-status { font-size: var(--font-xl); margin: 10px 0 5px; color: var(--text-dark); font-weight: 500; }
.call-timer { color: var(--text-light); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell'; font-size: var(--font-lg); }

.call-pre-check {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.check-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--font-lg);
  color: var(--text-medium);
  font-weight: 400;
}

.call-primary-btn {
  background: var(--td-green);
  color: white;
  border: none;
  padding: 15px;
  border-radius: 30px;
  font-weight: bold;
  margin-top: 20px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

.call-disclaimer {
  font-size: var(--font-sm);
  color: var(--text-medium);
  text-align: center;
  margin-top: 15px;
  line-height: 1.5;
}

.call-controls {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.control-row {
  display: flex;
  gap: 40px;
}

.control-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  color: var(--text-medium);
  font-size: var(--font-sm);
}

.end-call-btn {
  background: #d32f2f;
  color: white;
  border: none;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  font-weight: bold;
  font-size: var(--font-sm);
  box-shadow: 0 4px 10px rgba(211,47,47,0.3);
}

/* --- Call Verification Styling --- */

.security-status-hero {
  padding: 40px 20px;
  text-align: center;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.status-icon-ring {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid var(--border-color);
}

.safe-ring { color: var(--td-green); border-color: var(--td-green); background: var(--bg-card); }
.scam-ring { color: #d32f2f; border-color: #d32f2f; background: var(--bg-card); animation: pulseRed 2s infinite; }

@keyframes pulseRed {
  0% { box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.4); }
  70% { box-shadow: 0 0 0 15px rgba(211, 47, 47, 0); }
  100% { box-shadow: 0 0 0 0 rgba(211, 47, 47, 0); }
}

.status-main-text { font-size: var(--font-xl); font-weight: 700; margin-bottom: 10px; color: var(--text-dark); }
.status-sub-text { font-size: var(--font-base); color: var(--text-medium); line-height: 1.5; padding: 0 20px; }

.status-details-card { margin: 20px; padding: 20px; position: relative; }

.status-badge {
  position: absolute;
  top: -12px;
  right: 20px;
  padding: 4px 12px;
  border-radius: 20px;
  color: white;
  font-size: var(--font-xs);
  font-weight: 800;
  letter-spacing: 0.5px;
}

.bg-safe { background: var(--td-green); }
.bg-scam { background: #d32f2f; }

.status-info-row { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 0.5px solid var(--border-color); font-size: var(--font-base); color: var(--text-dark); }
.text-danger { color: #d32f2f; }

.scam-action-box { padding: 20px; }
.scam-action-box h3 { font-size: var(--font-lg); color: var(--text-dark); margin-bottom: 10px; }
.scam-action-box ul { padding-left: 20px; font-size: var(--font-sm); color: var(--text-medium); }
.scam-action-box li { margin-bottom: 8px; }

.report-scam-btn {
  width: 100%;
  background: var(--td-dark-green);
  color: white;
  border: none;
  padding: 15px;
  border-radius: 8px;
  font-weight: bold;
  margin-top: 15px;
}

.demo-toggle-container { margin: 40px 20px; padding: 15px; border: 1px dashed var(--border-color); border-radius: 8px; text-align: center; }
.demo-toggle-container p { font-size: var(--font-xs); color: var(--text-light); margin-bottom: 8px; }

/* --- Home Screen Call Banner --- */
.home-banner-wrapper {
  padding: 0 15px;
  margin-top: 10px;
  z-index: 10;
}

.call-status-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  animation: slideDown 0.4s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.csb-left { display: flex; align-items: center; gap: 15px; }

/* Active State (Monzo/Starling Inspired) */
.active-call-bg { background: white; border-left: 5px solid #008a0d; }
.csb-avatar-pulse {
  width: 40px; height: 40px; background: #008a0d; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  animation: rippleGreen 2s infinite;
}

@keyframes rippleGreen {
  0% { box-shadow: 0 0 0 0 rgba(0, 138, 13, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(0, 138, 13, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 138, 13, 0); }
}

/* Recent State */
.recent-call-bg { background: var(--bg-card); border-left: 5px solid var(--text-light); }

/* Safe/None State */
.safe-call-bg { background: var(--bg-card); border: 1px solid var(--border-color); }
.csb-icon-circle { width: 40px; height: 40px; background: var(--bg-light-gray); border-radius: 50%; display: flex; align-items: center; justify-content: center; }

.csb-title { font-size: var(--font-base); font-weight: 700; color: var(--td-green); }
.csb-title.dark-text { color: var(--text-dark); }
.csb-subtitle { font-size: var(--font-xs); color: var(--text-medium); }
.gray-text { color: var(--text-light); }

/* --- Sidebar Toggle UI --- */
.sidebar-toggle-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 15px 20px; border-bottom: 1px solid #eee;
}
.switch { position: relative; display: inline-block; width: 40px; height: 22px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc; transition: .4s; border-radius: 34px;
}
.slider:before {
  position: absolute; content: ""; height: 16px; width: 16px; left: 3px; bottom: 3px;
  background-color: white; transition: .4s; border-radius: 50%;
}
input:checked + .slider { background-color: #008a0d; }
input:checked + .slider:before { transform: translateX(18px); }

/* --- Emergency Hang Up Button --- */

.emergency-hangup-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #d32f2f; /* Standard emergency red */
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s active;
  gap: 2px;
  min-width: 70px;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3);
}

.emergency-hangup-btn:active {
  transform: scale(0.95);
  background-color: #b71c1c;
}

.emergency-hangup-btn span {
  font-size: var(--font-2xs);
  font-weight: 900;
  letter-spacing: 0.5px;
}

/* Ensure the banner content spreads out to make room for the button */
.active-call-bg {
  justify-content: space-between;
  padding-right: 10px !important;
}

/* Subtle border to make the active state feel "urgent" */
.active-call-bg {
  border: 2px solid var(--td-green);
  background: var(--bg-card);
}

/* --- Direct Deposit Details Styling --- */

.deposit-hero-section {
  background: var(--bg-card);
  padding: 40px 20px;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}

.deposit-status-pill {
  display: inline-block;
  background: var(--bg-light-gray);
  color: var(--td-green);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: var(--font-xs);
  font-weight: 800;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.deposit-hero-section h1 {
  font-size: var(--font-3xl);
  margin: 0;
  font-weight: 700;
}

.deposit-sender-name {
  font-size: var(--font-lg);
  font-weight: 600;
  color: var(--text-dark);
  margin: 5px 0;
}

.deposit-timestamp {
  font-size: var(--font-sm);
  color: var(--text-light);
}

.detail-list-group {
  margin-top: 20px;
  padding: 0 20px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
  border-bottom: 0.5px solid var(--border-color);
  font-size: var(--font-base);
}

.detail-row:last-child { border-bottom: none; }
.detail-row span { color: var(--text-medium); }
.detail-row strong { color: var(--text-dark); text-align: right; max-width: 60%; }
.text-small { font-size: var(--font-sm); font-family: monospace; }

/* Ancillary Insights Card */
.ancillary-info-card {
  margin: 20px;
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 15px;
}

.aic-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: var(--font-base);
  margin-bottom: 10px;
  color: var(--td-green);
}

.ancillary-info-card p {
  font-size: var(--font-sm);
  color: var(--text-medium);
  margin: 0 0 10px 0;
}

.next-deposit-alert {
  display: flex;
  justify-content: space-between;
  background: var(--bg-card);
  padding: 10px;
  border-radius: 8px;
  font-size: var(--font-sm);
  color: var(--text-dark);
}

.deposit-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.secondary-action-btn {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  color: var(--text-dark);
  font-size: var(--font-base);
}

/* --- Spending Analysis Styling --- */

.spending-summary-card {
  background: var(--bg-card);
  padding: 30px 20px 20px;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
}

.total-spend-amount {
  font-size: var(--font-3xl);
  font-weight: 700;
  margin: 0;
  color: var(--text-dark);
}

.spend-subtitle {
  color: var(--text-medium);
  margin: 5px 0 25px;
}

.frequency-toggle-container {
  display: flex;
  background: var(--bg-light-gray);
  padding: 4px;
  border-radius: 20px;
  margin: 0 auto;
  max-width: 300px;
}

.freq-toggle-btn {
  flex: 1 1;
  border: none;
  background: none;
  padding: 8px;
  border-radius: 16px;
  font-size: var(--font-sm);
  font-weight: 500;
  color: var(--text-medium);
  cursor: pointer;
  transition: all 0.2s;
}

.freq-toggle-btn.active {
  background: var(--bg-card);
  color: var(--td-green);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.chart-container {
  padding: 25px 20px;
  margin-top: 20px;
}

.chart-title {
  margin: 0 0 30px;
  font-size: var(--font-lg);
  color: var(--text-dark);
}

.bar-chart {
  display: flex;
  justify-content: space-around;
  height: 200px;
  align-items: flex-end;
}

.chart-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.bar-track {
  width: 16px;
  height: 150px;
  background: var(--bg-light-gray);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.bar-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--td-green);
  border-radius: 8px;
  transition: height 0.5s ease-out;
}

.bar-label-top {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--td-green);
  margin-bottom: 8px;
}

.bar-label-bottom {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 12px;
}

.insights-container {
  padding: 25px 20px;
  margin-top: 20px;
  margin-bottom: 30px;
}

.insight-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.insight-title {
  font-size: var(--font-lg);
  font-weight: 600;
}

.insight-body {
  color: var(--text-medium);
  line-height: 1.5;
  margin-bottom: 20px;
}

.insight-tip-box {
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  padding: 15px;
  border-radius: 8px;
  font-size: var(--font-sm);
  color: var(--td-green);
}

/* --- Stacked Chart UI --- */
.chart-card {
  margin: 15px;
  padding: 20px;
  border-radius: 12px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.chart-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: var(--font-xs);
  color: var(--text-medium);
  gap: 4px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.stacked-bar-chart {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 200px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-color);
}

.bar-track-stacked {
  width: 12px;
  height: 100%;
  display: flex;
  flex-direction: column-reverse; /* Stacks categories from bottom up */
  background: var(--bg-light-gray);
  border-radius: 6px;
  overflow: hidden;
}

.bar-segment {
  width: 100%;
  transition: height 0.3s ease;
}

/* --- Bottom Toggles --- */
.frequency-toggle-container-bottom {
  display: flex;
  background: var(--bg-light-gray);
  padding: 4px;
  border-radius: 12px;
  margin-top: 25px;
}


.insight-text {
  font-size: var(--font-base);
  color: var(--text-dark);
  margin-bottom: 8px;
}

.status-indicator-row {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-sm);
  font-weight: 500;
}

/* Navigation Bar */
/* --- Bottom Nav (Instagram-style tab bar) --- */

.bottom-nav {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
  background: var(--bg-card);
  border-top: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 4px;
  z-index: 100;
}

.bottom-nav .nav-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: var(--text-light);
  font-size: var(--font-xs);
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 0;
  transition: color 0.15s;
  -webkit-tap-highlight-color: transparent;
}

.bottom-nav .nav-item:hover { color: var(--text-medium); }

.bottom-nav .nav-item.active {
  color: var(--td-green);
  font-weight: 600;
}


.bottom-nav .nav-item { position: relative; }

/* Pulsing dot on a nav tab whose background work (IVA agent pipeline) is in flight. */
.nav-busy-dot {
  position: absolute;
  top: -2px;
  right: -5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--td-green, #2FBF00);
  box-shadow: 0 0 0 2px var(--bg-card, #fff);
  animation: nav-busy-pulse 1.2s ease-in-out infinite;
}
@keyframes nav-busy-pulse {
  0%, 100% { opacity: 1;   transform: scale(1);   }
  50%      { opacity: 0.4; transform: scale(0.7); }
}

/* --- Chat FAB (Floating Action Button) ---
   Drawer-tab pattern: idle is a thin green sliver flush with the right edge;
   on hover it expands to a full clickable button revealing the icon. */
.chat-fab {
  position: absolute;
  bottom: 74px;
  right: 0;                                         /* flush against right edge */
  width: 18px;                                      /* slim sliver in idle state */
  height: 56px;
  background: linear-gradient(135deg, var(--td-green), var(--td-dark-green));
  border: none;
  color: var(--bh-black);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  z-index: 200;
  box-shadow: -3px 3px 12px rgba(0,0,0,0.25);       /* shadow biased to the left */
  overflow: hidden;
  transition:
    width 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),
    padding 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),
    box-shadow 0.2s,
    background 0.2s;
  animation: chat-fab-slide-in 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.chat-fab:hover {
  width: 64px;                                      /* expand to reveal full button */
  padding-left: 12px;
  box-shadow: -6px 4px 22px rgba(0,0,0,0.42);
}

.chat-fab:active { transform: scale(0.96); }

@keyframes chat-fab-slide-in {
  0%   { transform: translateX(80px); opacity: 0; }
  60%  { transform: translateX(-4px); opacity: 1; }
  100% { transform: translateX(0);    opacity: 1; }
}

.chat-fab--open {
  background: linear-gradient(135deg, #e53935, #b71c1c);
}

.chat-fab-icon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;                              /* hidden in slim idle state */
  transition: opacity 0.18s ease, transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.chat-fab:hover .chat-fab-icon { opacity: 1; }

.chat-fab--open .chat-fab-icon {
  transform: rotate(90deg);
}

/* Pulse ring on idle */
.chat-fab-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: var(--td-green);
  opacity: 0;
  animation: chat-fab-pulse 2.8s ease-out infinite;
  pointer-events: none;
}

@keyframes chat-fab-pulse {
  0%   { transform: scale(1);   opacity: 0.55; }
  65%  { transform: scale(1.7); opacity: 0;    }
  100% { transform: scale(1.7); opacity: 0;    }
}

/* --- Chat Modal Overlay ---
   Slides in from the right edge of the viewport (drawer pattern) instead
   of up from the bottom (sheet pattern). The chat header back button still
   navigates; the slim left-edge drag handle is a tap-to-close affordance
   that maps to the slide-out direction. */
.chat-modal-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: var(--bg-screen);
  z-index: 190;
  overflow: hidden;
  display: none;
  flex-direction: row;          /* row layout: handle on left, chat fills rest */
  transform: translateX(102%);  /* off-screen right when closed */
  visibility: hidden;
  box-shadow: -8px 0 32px rgba(0,0,0,0.28);  /* shadow on the left edge */
}
/* Keep in DOM for slide animation after first toggle */
.chat-modal-overlay.chat-modal--shown {
  display: flex;
}
/* Animate slide; delay visibility on close so slide-out completes first */
.chat-modal-overlay.chat-modal--ready {
  transition: transform 0.38s cubic-bezier(0.4,0,0.2,1), visibility 0s 0.38s;
}
/* Open state: visible + slid in; visibility is instant on open */
.chat-modal-overlay.chat-modal--open {
  transform: translateX(0);
  visibility: visible;
  transition: transform 0.38s cubic-bezier(0.4,0,0.2,1), visibility 0s 0s;
}

/* Slim left-edge drag handle — tap to close, mirroring the slide-in
   direction. Vertical bar sits flush against the left edge. */
.chat-modal-drag-handle {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 100%;
  background: var(--bg-card);
  border-right: 1px solid var(--border-color);
  cursor: pointer;
  padding: 0;
}

.chat-modal-handle-bar {
  width: 4px;
  height: 36px;
  background: var(--border-color);
  transition: background 0.15s;
}

.chat-modal-drag-handle:hover .chat-modal-handle-bar {
  background: var(--text-light);
}

/* Modal chat screen fills the overlay — remove nav padding since modal covers nav */
.chat-screen--modal {
  flex: 1 1;
  overflow: hidden;
  border-radius: 0;
  padding-bottom: 0 !important;
}

/* Screens that use bottom nav need bottom padding so content isn't hidden */
.screen-with-nav {
  padding-bottom: 62px;
}

/* --- Profile Screen --- */

.profile-hero {
  position: relative;
  background: linear-gradient(145deg, var(--td-green), var(--td-dark-green));
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 24px;
  flex-shrink: 0;
}

.profile-hero-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
}
.profile-hero-action {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.18);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 150ms ease;
}
.profile-hero-action:hover  { background: rgba(255,255,255,0.30); }
.profile-hero-action:active { background: rgba(255,255,255,0.38); }

/* Settings screen: use themed tokens so the cards follow light/dark theme.
   The base .bh-* tokens are hardcoded white/black and never switch, which
   left the dark (purple) theme with white boxes + washed-out text. These
   scoped overrides beat the base .bh-form-card rule on specificity. */
.settings-screen.bh-flow { background: var(--bg-light-gray); }
.settings-screen .bh-form-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
}
.settings-screen .bh-info-box {
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  color: var(--text-medium);
}

.profile-avatar-ring {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  border: 3px solid rgba(255,255,255,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xl);
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.profile-hero-name  { font-size: var(--font-xl); font-weight: 700; color: #fff; margin-bottom: 3px; text-align: center; }
.profile-hero-sub   { font-size: var(--font-sm); color: rgba(255,255,255,0.8); margin-bottom: 2px; text-align: center; }
.profile-hero-email { font-size: var(--font-xs); color: rgba(255,255,255,0.65); margin-bottom: 2px; }
.profile-hero-since { font-size: var(--font-xs); color: rgba(255,255,255,0.5); margin-top: 4px; }

.profile-section { padding: 16px 14px 0; }

.profile-section-title {
  font-size: var(--font-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-medium);
  margin-bottom: 8px;
  padding-left: 2px;
}

.profile-section-label {
  font-size: var(--font-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-light);
  padding: 0 0 6px;
}

.profile-card {
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.profile-balance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-color);
}
.profile-balance-row:last-child { border-bottom: none; }
.profile-balance-label { font-size: var(--font-sm); color: var(--text-dark); }
.profile-balance-val   { font-size: var(--font-sm); font-weight: 600; }

.profile-net-worth {
  border-radius: 0;
  margin: 0;
}

.profile-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 1px solid var(--border-color);
  gap: 8px;
}
.profile-settings-row:last-child { border-bottom: none; }

.profile-contact-cta {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);
  border-radius: 10px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: opacity 0.15s;
}
.profile-contact-cta:active { opacity: 0.85; }
.profile-contact-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}
.profile-contact-text { flex: 1 1; min-width: 0; }
.profile-contact-label { font-size: var(--font-sm); font-weight: 700; color: #fff; }
.profile-contact-sub   { font-size: var(--font-xs); color: rgba(255,255,255,0.8); margin-top: 2px; }

.profile-settings-row-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.profile-settings-icon { color: var(--td-green); flex-shrink: 0; display: flex; }
.profile-settings-label { font-size: var(--font-sm); color: var(--text-dark); }

.profile-settings-row-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.profile-settings-value { font-size: var(--font-sm); color: var(--text-medium); max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.profile-backend-chips {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.profile-chip {
  padding: 3px 9px;
  border-radius: 20px;
  border: 1px solid var(--chip-color, var(--td-green));
  background: transparent;
  color: var(--chip-color, var(--td-green));
  font-size: var(--font-xs);
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s, color 0.15s;
}
.profile-chip.active {
  background: var(--chip-color, var(--td-green));
  color: #fff;
}

/* Progress bar — used by DashboardScreen for pinned-goal progress */
.progress-bar-bg { height: 8px; background: var(--border-color); border-radius: 4px; margin: 15px 0; overflow: hidden; }
.progress-fill { height: 100%; background: var(--td-green); transition: width 1s ease-in-out; }

/* --- Insights Screen Styling --- */

.ins-scroll { padding: 12px 14px 80px; gap: 12px; display: flex; flex-direction: column; }

.ins-card {
  background: var(--bg-card);
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}


.ins-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}
.ins-card-title { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); flex: 1 1; }
.ins-card-sub   { font-size: var(--font-xs); color: var(--text-light); }

.ins-donut-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
}

.ins-legend { flex: 1 1; display: flex; flex-direction: column; gap: 5px; }
.ins-legend-row { display: flex; align-items: center; gap: 6px; }
.ins-legend-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.ins-legend-label { font-size: var(--font-sm); color: var(--text-medium); flex: 1 1; }
.ins-legend-val   { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }

.ins-chips-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.ins-chip {
  background: var(--bg-card);
  border-radius: 14px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.ins-chip-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.ins-chip-icon {
  width: 30px; height: 30px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.ins-chip-label { font-size: var(--font-xs); color: var(--text-light); text-transform: uppercase; letter-spacing: 0.4px; line-height: 1.3; }
.ins-chip-value { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }
.ins-chip-sub   { font-size: var(--font-xs); color: var(--text-medium); }

/* On desktop the phone-viewport is a fixed 844px frame; flex: 1 handles height */
/* --- CHART STYLES (recharts) --- */
.rchart-container {
  margin-top: 12px;
  padding: 10px 4px 6px;
  background: var(--bg-light-gray);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.rchart-title {
  font-size: var(--font-xs);
  font-weight: 700;
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 8px 6px;
}

/* --- CSV EXPORT ICON --- */
/* Compact icon button — uses FaFileCsv with a "Download as CSV" tooltip.
   Inside .chart-with-export the icon is absolutely positioned in the
   chart container's top-left padding area so it sits inline with the
   chart canvas (below the title) WITHOUT pushing the chart sideways.
   In the table-only case (no chart) the rule defaults apply and the
   icon flows above the markdown table. */
.chart-with-export {
  position: relative;
  margin-top: 8px;
}
.chart-with-export-body { width: 100%; }

.chart-export-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--td-green);
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.78;
  transition: opacity 150ms ease-in-out, color 150ms ease-in-out, background 150ms ease-in-out;
}
.chart-export-btn:hover {
  opacity: 1;
  color: var(--td-dark-green);
  background: var(--td-green-light);
}
.chart-export-btn:focus-visible {
  outline: 2px solid var(--td-green);
  outline-offset: 2px;
}

/* Float the icon at the chart container's top-right corner, vertically
   centered on the chart title row — gives the chart a clean header row
   (title on the left, action on the right) instead of stealing space
   from the canvas. */
.chart-with-export .chart-export-btn {
  position: absolute;
  top: 16px;     /* centers the 28px button on the ~16px title at top of container */
  right: 4px;    /* inside the chart container's right padding */
  z-index: 2;
}

/* --- RETRY STYLES --- */
.failed-bubble {
  border: 1px solid #ffcccc !important;
  background: #fff8f8 !important;
}

.retry-button {
  display: inline-block;
  margin-top: 8px;
  padding: 4px 12px;
  background: none;
  border: 1px solid #008a0d;
  color: #008a0d;
  border-radius: 12px;
  font-size: var(--font-sm);
  cursor: pointer;
  line-height: 1.4;
}

.retry-button:hover {
  background: #f0faf0;
}

/* --- CHAT PIN BUTTON --- */
.chat-pin-btn {
  display: inline-flex;
  align-items: center;
  margin-top: 5px;
  padding: 3px 10px;
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: var(--font-xs);
  color: var(--text-light);
  cursor: pointer;
  align-self: flex-start;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.chat-pin-btn:hover {
  background: var(--bg-light-gray);
  color: var(--text-medium);
}

.chat-pin-btn.pinned {
  background: var(--td-green);
  border-color: var(--td-green);
  color: white;
}

/* --- ADVISOR CTA (in-chat escalation banner) --- */
.advisor-cta-card {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  margin-top: 8px;
  padding: 10px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-left: 3px solid #448889;
  border-radius: 12px;
}

.advisor-cta-icon {
  color: #448889;
  flex-shrink: 0;
}

.advisor-cta-text {
  flex: 1 1;
  min-width: 0;
  font-size: var(--font-sm);
  color: var(--text-medium);
  line-height: 1.4;
}

.advisor-cta-connect {
  flex-shrink: 0;
  padding: 5px 14px;
  border: none;
  border-radius: 14px;
  background: #448889;
  color: #fff;
  font-size: var(--font-xs);
  font-weight: 600;
  cursor: pointer;
}

.advisor-cta-connect:hover {
  filter: brightness(1.08);
}

.advisor-cta-dismiss {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: none;
  color: var(--text-light);
  cursor: pointer;
}

.advisor-cta-dismiss:hover {
  color: var(--text-medium);
}

/* --- DASHBOARD SCREEN --- */
.dashboard-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-screen);
}

.dashboard-header {
  padding: 20px 20px 14px;
  background: var(--td-green);
  color: white;
}

.dashboard-header h2 {
  margin: 0;
  font-size: var(--font-xl);
  font-weight: 700;
}

.dashboard-header p {
  margin: 4px 0 0;
  font-size: var(--font-sm);
  opacity: 0.85;
}

.dashboard-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  scrollbar-width: thin;
  scrollbar-color: rgba(128,128,128,0.2) transparent;
}
.dashboard-scroll::-webkit-scrollbar { width: 4px; }
.dashboard-scroll::-webkit-scrollbar-track { background: transparent; }
.dashboard-scroll::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }
.dashboard-scroll::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }

.dashboard-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  padding: 40px 24px;
  text-align: center;
  color: var(--text-light);
}

.dashboard-empty-icon {
  font-size: var(--font-3xl);
  margin-bottom: 14px;
  opacity: 0.5;
}

.dashboard-empty h3 {
  margin: 0 0 8px;
  font-size: var(--font-lg);
  color: var(--text-medium);
}

.dashboard-empty p {
  margin: 0;
  font-size: var(--font-base);
  line-height: 1.5;
}

/* Dashboard cards */
.dashboard-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  overflow: hidden;
  color: var(--text-dark);
}

.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-color);
}

.dashboard-card-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dashboard-card-timestamp {
  font-size: var(--font-xs);
  color: var(--text-light);
}

.dashboard-card-label {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.dashboard-card-unpin {
  background: none;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 4px 8px;
  font-size: var(--font-xs);
  color: var(--text-light);
  cursor: pointer;
}

.dashboard-card-unpin:hover {
  background: var(--bg-light-gray);
  color: var(--text-medium);
}

.dashboard-card-body {
  padding: 12px 14px;
}

/* Goal widget inside dashboard card */
.goal-widget {
  margin-top: 10px;
  padding: 12px;
  background: var(--bg-light-gray);
  border-radius: 10px;
  border: 1px solid var(--border-color);
}

.goal-widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.goal-widget-name {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
}

.goal-widget-target-label {
  font-size: var(--font-xs);
  color: var(--text-light);
  margin-top: 2px;
}

.goal-widget-badge {
  font-size: var(--font-xs);
  font-weight: 600;
  background: var(--td-green);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
}

.goal-widget-bar-track {
  height: 10px;
  background: var(--border-color);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 6px;
}

.goal-widget-bar-fill {
  height: 100%;
  background: var(--td-green);
  border-radius: 6px;
  transition: width 0.6s ease;
}

.goal-widget-amounts {
  display: flex;
  justify-content: space-between;
  font-size: var(--font-sm);
  color: var(--text-medium);
}

.goal-widget-current {
  font-weight: 700;
  color: var(--td-green);
}

.goal-widget-footer {
  margin-top: 6px;
  font-size: var(--font-xs);
  color: var(--text-light);
  text-align: center;
}

/* --- CHAT HISTORY SCREEN --- */
.chat-history-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  text-align: center;
  color: var(--text-light);
}

.chat-history-empty-icon {
  font-size: var(--font-3xl);
  margin-bottom: 14px;
  opacity: 0.45;
}

.chat-history-empty h3 {
  margin: 0 0 8px;
  font-size: var(--font-lg);
  color: var(--text-medium);
}

.chat-history-empty p {
  margin: 0;
  font-size: var(--font-base);
  line-height: 1.5;
}

.chat-history-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  margin-bottom: 10px;
  overflow: hidden;
}

.chat-history-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  cursor: pointer;
}

.chat-history-card-header:hover {
  background: var(--bg-light-gray);
}

.chat-history-card-meta {
  flex: 1 1;
  min-width: 0;
}

.chat-history-preview {
  font-size: var(--font-base);
  font-weight: 500;
  color: var(--text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 3px;
}

.chat-history-info {
  font-size: var(--font-xs);
  color: var(--text-light);
}

.chat-history-resume-btn {
  background: var(--td-green);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: var(--font-sm);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.chat-history-resume-btn:hover {
  opacity: 0.85;
}

.chat-history-chevron {
  color: var(--text-light);
  font-size: var(--font-xl);
  flex-shrink: 0;
}

.chat-history-thread {
  border-top: 1px solid var(--border-color);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 400px;
  overflow-y: auto;
  background: var(--bg-light-gray);
}

.chat-history-msg {
  display: flex;
}

.chat-history-msg.user {
  justify-content: flex-end;
}

.chat-history-msg.bot {
  justify-content: flex-start;
}

.chat-history-bubble {
  max-width: 78%;
  padding: 8px 12px;
  border-radius: 14px;
  font-size: var(--font-sm);
  line-height: 1.45;
  color: var(--text-dark);
}

.chat-history-msg.user .chat-history-bubble {
  background: var(--td-green);
  color: white;
  border-bottom-right-radius: 4px;
}

.chat-history-msg.bot .chat-history-bubble {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-bottom-left-radius: 4px;
}

.chat-history-msg.bot .chat-history-bubble p {
  margin: 0 0 6px;
}

.chat-history-msg.bot .chat-history-bubble p:last-child {
  margin: 0;
}

.chat-history-subtitle {
  font-size: var(--font-xs);
  color: var(--text-light);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* --- CHAT SUMMARY DIVIDER --- */
.chat-summary-divider {
  margin: 16px 12px;
  border: 1px dashed var(--border-color);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-light-gray);
}

.chat-summary-label {
  font-size: var(--font-2xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-medium);
  padding: 5px 12px;
  background: var(--border-color);
  display: block;
}

.chat-summary-content {
  padding: 10px 14px;
  font-size: var(--font-sm);
  color: var(--text-dark);
}

.chat-summary-content p { margin: 0 0 4px; }
.chat-summary-content p:last-child { margin: 0; }
.chat-summary-content ul, .chat-summary-content ol { margin: 4px 0; padding-left: 18px; }
.chat-summary-content li { margin-bottom: 3px; }

/* --- SPENDING TRENDS SCREEN --- */
.st-hero {
  background: var(--td-green);
  padding: 20px 20px 16px;
  text-align: center;
  color: white;
}
.st-period-label { margin: 0 0 4px; font-size: var(--font-sm); opacity: 0.8; text-transform: uppercase; letter-spacing: 0.5px; }
.st-total { margin: 0 0 4px; font-size: var(--font-3xl); font-weight: 700; line-height: 1.1; }
.st-delta { margin: 0; font-size: var(--font-sm); }
.st-delta.pos { color: #a8f0c6; }
.st-delta.neg { color: #ffd0c0; }

.st-toggle-row {
  display: flex;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  padding: 10px 16px;
  gap: 8px;
}
.st-toggle-btn {
  flex: 1 1;
  padding: 7px 0;
  border: 1px solid var(--border-color);
  border-radius: 20px;
  background: none;
  color: var(--text-medium);
  font-size: var(--font-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}
.st-toggle-btn.active {
  background: var(--td-green);
  border-color: var(--td-green);
  color: white;
}

.st-chart-card {
  background: var(--bg-card);
  padding: 16px 12px 8px;
  margin: 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
}
.st-chart {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 140px;
}
.st-bar-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
  gap: 4px;
}
.st-bar-track {
  flex: 1 1;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.st-bar-stack {
  width: 70%;
  min-width: 8px;
  display: flex;
  flex-direction: column;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  transition: height 0.4s ease;
}
.st-bar-seg { min-height: 2px; }
.st-bar-label {
  font-size: var(--font-2xs);
  color: var(--text-light);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: center;
}

.st-breakdown-card {
  background: var(--bg-card);
  padding: 14px 16px;
  margin: 0 12px 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
}
.st-breakdown-title {
  font-size: var(--font-xs);
  font-weight: 700;
  color: var(--text-light);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px;
}
.st-breakdown-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.st-cat-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.st-cat-label { width: 62px; font-size: var(--font-sm); color: var(--text-dark); flex-shrink: 0; }
.st-cat-bar-bg { flex: 1 1; height: 6px; background: var(--bg-light-gray); border-radius: 3px; overflow: hidden; }
.st-cat-bar-fill { height: 100%; border-radius: 3px; transition: width 0.4s ease; }
.st-cat-pct { width: 28px; font-size: var(--font-sm); color: var(--text-medium); text-align: right; flex-shrink: 0; }
.st-cat-amt { width: 52px; font-size: var(--font-sm); color: var(--text-medium); text-align: right; flex-shrink: 0; }


/* --- ICON BUTTON TOOLTIPS --- */
.new-chat-button {
  position: relative;
}
.new-chat-button[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.78);
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: var(--font-xs);
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  z-index: 200;
}

/* --- MARKDOWN TABLE STYLES --- */
.chat-bubble table,
.dashboard-card-body table {
  border-collapse: collapse;
  width: 100%;
  font-size: var(--font-sm);
  margin: 8px 0;
}
.chat-bubble table th,
.chat-bubble table td,
.dashboard-card-body table th,
.dashboard-card-body table td {
  border: 1px solid var(--border-color);
  padding: 5px 8px;
  text-align: left;
}
.chat-bubble table th,
.dashboard-card-body table th {
  background: var(--bg-light-gray);
  font-weight: 600;
  color: var(--text-dark);
}
.chat-bubble table tr:nth-child(even),
.dashboard-card-body table tr:nth-child(even) {
  background: var(--bg-light-gray);
}


/* --- VISUALIZATION SCREEN --- */
.viz-screen { background: #0f0f11; }

.viz-header { background: #17171a !important; border-bottom: 1px solid #2a2a2f; }
.viz-header .back-icon,
.viz-header .header-title { color: #f0ede8 !important; }

.viz-content { background: #0f0f11; }

.viz-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 16px 16px;
  border-bottom: 1px solid #2a2a2f;
  gap: 12px;
}

.viz-label {
  font-size: var(--font-2xs);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #7a7a82;
  margin-bottom: 4px;
}

.viz-name {
  font-size: var(--font-2xl);
  font-weight: 700;
  color: #f0ede8;
  line-height: 1.1;
}

.viz-subtitle { font-size: var(--font-xs); color: #7a7a82; margin-top: 5px; }

.viz-period { font-size: var(--font-xs); color: #f0ede8; letter-spacing: 0.05em; }
.viz-txn-count { font-size: var(--font-xs); color: #7a7a82; margin-top: 3px; }

.viz-stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 16px;
}

.viz-stat-card {
  background: #17171a;
  border: 1px solid #2a2a2f;
  border-radius: 6px;
  padding: 14px 12px;
  position: relative;
  overflow: hidden;
}
.viz-stat-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
}
.viz-yellow::before { background: #e8c547; }
.viz-green::before  { background: #7ec8a4; }
.viz-red::before    { background: #e87c6a; }
.viz-blue::before   { background: #7aaee8; }

.viz-stat-label {
  font-size: var(--font-2xs);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7a7a82;
  margin-bottom: 6px;
}
.viz-stat-value { font-size: var(--font-xl); font-weight: 700; color: #f0ede8; line-height: 1; }
.viz-stat-sub { font-size: var(--font-xs); color: #7a7a82; margin-top: 5px; line-height: 1.3; }

.viz-chart-card {
  background: #17171a;
  border: 1px solid #2a2a2f;
  border-radius: 6px;
  padding: 16px;
  margin: 0 16px 12px;
}
.viz-chart-title { font-size: var(--font-base); font-weight: 600; color: #f0ede8; margin-bottom: 2px; }
.viz-chart-sub {
  font-size: var(--font-2xs);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #7a7a82;
  margin-bottom: 14px;
}

.viz-insights {
  padding: 4px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.viz-insight {
  background: #17171a;
  border: 1px solid #2a2a2f;
  border-radius: 6px;
  padding: 14px;
}
.viz-insight-icon { font-size: var(--font-lg); margin-bottom: 6px; }
.viz-insight-title {
  font-size: var(--font-xs);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #e8c547;
  margin-bottom: 6px;
}
.viz-insight-body { font-size: var(--font-sm); color: #7a7a82; line-height: 1.65; }
.viz-insight-body strong { color: #f0ede8; }

.viz-footer {
  margin: 0 16px 28px;
  padding-top: 14px;
  border-top: 1px solid #2a2a2f;
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: var(--font-2xs);
  letter-spacing: 0.08em;
  color: #7a7a82;
}

/* BUDGET RULE SCREEN (70-20-10) */

.budget-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 14px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}
.budget-banner-name { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }
.budget-banner-sub  { font-size: var(--font-xs); color: var(--text-medium); margin-top: 3px; text-transform: uppercase; letter-spacing: 0.06em; }
.budget-banner-income { font-size: var(--font-2xl); font-weight: 700; color: var(--td-green); white-space: nowrap; }
.budget-banner-mo { font-size: var(--font-sm); font-weight: 400; color: var(--text-medium); }

.budget-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-medium);
  margin-bottom: 6px;
}

.budget-rule-card {
  background: var(--bg-card);
  border-radius: 10px;
  margin: 0 12px 10px;
  padding: 14px 15px;
  border-left: 3px solid var(--border-color);
}
.budget-rule-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}
.budget-rule-label { font-size: var(--font-sm); font-weight: 700; }
.budget-rule-target-pct { font-size: var(--font-xs); font-weight: 400; color: var(--text-medium); }
.budget-rule-desc { font-size: var(--font-xs); color: var(--text-medium); margin-top: 3px; line-height: 1.4; }
.budget-rule-status {
  font-size: var(--font-xs);
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

.budget-bar-track {
  position: relative;
  height: 10px;
  background: var(--border-color);
  border-radius: 5px;
  overflow: visible;
  margin-bottom: 6px;
}
.budget-bar-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.8s ease-in-out;
}
.budget-bar-marker {
  position: absolute;
  top: -5px;
  bottom: -5px;
  width: 2px;
  background: var(--text-dark);
  border-radius: 2px;
  opacity: 0.45;
}
.budget-bar-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-sm);
}

.budget-insight {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: var(--bg-card);
  border-radius: 8px;
  padding: 11px 13px;
  margin-bottom: 8px;
  border-left: 3px solid var(--border-color);
}
.budget-insight-icon { font-size: var(--font-lg); flex-shrink: 0; margin-top: 1px; }
.budget-insight-text { font-size: var(--font-sm); color: var(--text-medium); line-height: 1.55; }

/* ── Voice Bot Screen ─────────────────────────────────────────────────────── */
@keyframes vb-pulse {
  0%   { transform: scale(1);    opacity: 0.6; }
  50%  { transform: scale(1.18); opacity: 0.15; }
  100% { transform: scale(1);    opacity: 0; }
}
@keyframes vb-ring {
  0%   { transform: scale(0.95); opacity: 0.7; }
  100% { transform: scale(1.6);  opacity: 0; }
}
@keyframes vb-wave {
  0%, 100% { height: 6px;  }
  50%       { height: 22px; }
}
@keyframes vb-thinking {
  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }
  40%           { transform: scale(1); opacity: 1;   }
}
@keyframes vb-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0);   }
}

.vb-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-screen);
  overflow: hidden;
  padding-bottom: 0 !important;
}
.vb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
  background: var(--td-green);
  flex-shrink: 0;
}
.vb-header-title {
  font-size: var(--font-lg);
  font-weight: 700;
  color: #fff;
  flex: 1 1;
  text-align: center;
}
.vb-header-action {
  background: none;
  border: none;
  color: rgba(255,255,255,0.85);
  font-size: var(--font-xs);
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  white-space: nowrap;
}
.vb-header-action.active { color: #fff; font-weight: 700; }

.vb-history {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(128,128,128,0.2) transparent;
}
.vb-history::-webkit-scrollbar { width: 4px; }
.vb-history::-webkit-scrollbar-track { background: transparent; }
.vb-history::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }
.vb-history::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }
.vb-bubble {
  max-width: 82%;
  padding: 9px 13px;
  border-radius: 16px;
  font-size: var(--font-sm);
  line-height: 1.5;
  animation: vb-fade-in 0.25s ease;
  flex-shrink: 0;
}
.vb-bubble.user {
  align-self: flex-end;
  background: var(--td-green);
  color: #fff;
  border-bottom-right-radius: 4px;
}
.vb-bubble.bot {
  align-self: flex-start;
  background: var(--bg-card);
  color: var(--text-dark);
  border: 1px solid var(--border-color);
  border-bottom-left-radius: 4px;
  text-align: left;
}
.vb-bubble.vb-bubble-wide {
  max-width: 100%;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ── Agent Flow Card ─────────────────────────────────────── */
.agent-card {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: var(--bg-card);
  border: 2px solid var(--td-green);
  box-shadow: 0 4px 20px rgba(0,0,0,0.25);
  animation: vb-fade-in 0.3s ease;
}
.agent-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: var(--td-green);
  color: #fff;
}
.agent-robot-icon {
  font-size: var(--font-2xl);
  line-height: 1;
  flex-shrink: 0;
}
@keyframes agent-pulse {
  0%,100% { transform: scale(1); }
  50%      { transform: scale(1.2); filter: brightness(1.4); }
}
.agent-robot-pulse { animation: agent-pulse 1s ease-in-out infinite; }
.agent-card-title {
  font-size: var(--font-xs);
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 2px;
}
.agent-card-command {
  font-size: var(--font-sm);
  color: rgba(255,255,255,0.85);
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agent-badge {
  margin-left: auto;
  flex-shrink: 0;
  font-size: var(--font-xs);
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  letter-spacing: 0.3px;
}
.agent-badge-running { background: rgba(255,255,255,0.25); color: #fff; }
.agent-badge-done    { background: rgba(255,255,255,0.25); color: #fff; }

.agent-steps {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
/* Steps are only added to DOM when revealed — vb-fade-in fires automatically */
.agent-step {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--font-sm);
  color: var(--text-dark);
  animation: vb-fade-in 0.3s ease;
}
.agent-step-status {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--td-green);
  color: #fff;
  font-size: var(--font-xs);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.agent-step-emoji { font-size: var(--font-base); flex-shrink: 0; }

@keyframes agent-spin { to { transform: rotate(360deg); } }
.agent-step-spinner {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  animation: agent-spin 0.6s linear infinite;
}

.agent-stub-footer {
  padding: 8px 14px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-light-gray);
  font-size: var(--font-xs);
  color: var(--text-medium);
  text-align: center;
  animation: vb-fade-in 0.3s ease;
}
.vb-bubble-label {
  font-size: var(--font-xs);
  opacity: 0.55;
  margin-bottom: 3px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.vb-orb-area {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 0 12px;
  background: var(--bg-screen);
  border-top: 1px solid var(--border-color);
}
.vb-status {
  font-size: var(--font-sm);
  color: var(--text-medium);
  margin-bottom: 16px;
  letter-spacing: 0.3px;
  min-height: 18px;
}
.vb-status.listening { color: #ef4444; font-weight: 600; }
.vb-status.thinking  { color: var(--td-green); font-weight: 600; }
.vb-status.speaking  { color: #f59e0b; font-weight: 600; }

/* Mic button + rings */
.vb-mic-wrap {
  position: relative;
  width: 88px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.vb-ring {
  position: absolute;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid var(--td-green);
  animation: vb-ring 1.4s ease-out infinite;
  pointer-events: none;
}
.vb-ring:nth-child(2) { animation-delay: 0.35s; }
.vb-ring:nth-child(3) { animation-delay: 0.70s; }

.vb-mic-btn {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-2xl);
  transition: transform 0.15s, box-shadow 0.15s;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
}
.vb-mic-btn:active { transform: scale(0.94); }
.vb-stop-btn {
  position: absolute;
  bottom: -10px;
  right: -10px;
  background: var(--text-medium);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  z-index: 2;
}
.vb-stop-btn:hover { background: var(--text-dark); }
.vb-mic-btn.idle      { background: var(--td-green); color: #fff; }
.vb-mic-btn.vb-mic-stop { background: var(--td-green); color: #fff; }
.vb-mic-btn.listening { background: #ef4444; color: #fff; box-shadow: 0 4px 20px rgba(239,68,68,0.4); }
.vb-mic-btn.thinking  { background: var(--bg-card); color: var(--text-medium); cursor: default; }
.vb-mic-btn.speaking  { background: #f59e0b; color: #fff; }

/* Thinking dots */
.vb-dots { display: flex; gap: 5px; align-items: center; }
.vb-thinking-row { display: flex; gap: 6px; align-items: center; padding: 4px 0; }
.vb-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--text-medium);
  animation: vb-thinking 1.2s infinite ease-in-out;
}
.vb-dot:nth-child(1) { animation-delay: 0s;    }
.vb-dot:nth-child(2) { animation-delay: 0.2s;  }
.vb-dot:nth-child(3) { animation-delay: 0.4s;  }

/* Speaker wave bars */
.vb-wave { display: flex; gap: 3px; align-items: center; height: 24px; }
.vb-bar {
  width: 4px; border-radius: 3px;
  background: #f59e0b;
  animation: vb-wave 0.7s ease-in-out infinite;
}
.vb-bar:nth-child(1) { animation-delay: 0s;    }
.vb-bar:nth-child(2) { animation-delay: 0.1s;  }
.vb-bar:nth-child(3) { animation-delay: 0.2s;  }
.vb-bar:nth-child(4) { animation-delay: 0.1s;  }
.vb-bar:nth-child(5) { animation-delay: 0s;    }

.vb-transcript {
  font-size: var(--font-sm);
  color: var(--text-medium);
  font-style: italic;
  margin-top: 12px;
  min-height: 18px;
  text-align: center;
  padding: 0 20px;
  max-width: 280px;
}
.vb-hint {
  font-size: var(--font-xs);
  color: var(--text-light, #aaa);
  margin-top: 8px;
  text-align: center;
}
.vb-no-support {
  text-align: center;
  padding: 40px 24px;
  color: var(--text-medium);
  font-size: var(--font-sm);
  line-height: 1.6;
}

/* ============================================================
   EMAIL MONEY TRANSFER + BILL PAYMENT — shared & screen styles
   ============================================================ */

/* Shared section card */
.emt-section {
  background: var(--bg-card);
  border-radius: 12px;
  margin: 0 14px 12px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}
.emt-section-title {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-light);
  padding: 10px 14px 6px;
}

/* Account selector rows (used by AccountTransferScreen radio list) */
.emt-account-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  cursor: pointer;
  box-sizing: border-box;
  border-top: 1px solid var(--border-color);
  transition: background 160ms ease;
}
.emt-account-row:first-of-type { border-top: none; }
/* Translucent tint (not the solid light-green token) so the row text stays
   readable in both light and dark themes. */
.emt-account-row.selected { background: rgba(47, 191, 0, 0.14); }
.emt-account-info { flex: 1 1; min-width: 0; }
.emt-account-name { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }
.emt-account-num  { font-size: var(--font-xs); color: var(--text-light); margin-top: 2px; }
.emt-account-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.emt-account-balance { font-size: var(--font-sm); font-weight: 600; color: var(--td-green); white-space: nowrap; }
.emt-radio {
  width: 20px; height: 20px; border-radius: 50%;
  border: 2px solid var(--border-color); flex-shrink: 0;
  box-sizing: border-box; transition: border-color 160ms ease;
}
.emt-radio.on {
  border-color: var(--td-green);
  background: radial-gradient(circle, var(--td-green) 0 5px, transparent 6px);
}

/* Field label (legacy uppercase-overline used inside emt-section) */
.emt-field { padding: 0 14px 12px; border-top: 1px solid var(--border-color); padding-top: 10px; }
.emt-field:first-of-type { border-top: none; }
.emt-label {
  display: flex; align-items: center;
  font-size: var(--font-xs); font-weight: 600; color: var(--text-medium);
  margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.05em;
}
.emt-error { font-size: var(--font-xs); color: #ef4444; margin-top: 4px; }

/* Amount input */
.emt-amount-wrapper {
  display: flex; align-items: center; gap: 8px;
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 8px 14px;
  margin: 0 14px;
  transition: border-color 0.15s;
}
.emt-amount-wrapper:focus-within { border-color: var(--td-green); }
.emt-amount-wrapper.error { border-color: #ef4444; }
.emt-currency-symbol { font-size: var(--font-xl); font-weight: 700; color: var(--text-medium); }
.emt-amount-input {
  flex: 1 1; background: none; border: none; outline: none;
  font-size: var(--font-2xl); font-weight: 700; color: var(--text-dark);
  font-family: inherit; min-width: 0;
}
.emt-amount-input::placeholder { color: var(--text-light); }
.emt-currency-code { font-size: var(--font-sm); font-weight: 600; color: var(--text-light); align-self: flex-end; padding-bottom: 4px; }

/* Quick amount pills (legacy — new EMT uses .bh-quick-amounts) */
.emt-quick-amounts { display: flex; gap: 6px; padding: 10px 14px 14px; flex-wrap: wrap; }

/* Textarea */
.emt-textarea {
  width: 100%; box-sizing: border-box;
  background: var(--bg-light-gray); border: 1px solid var(--border-color);
  border-radius: 8px; padding: 10px 12px; font-size: var(--font-sm);
  color: var(--text-dark); font-family: inherit; outline: none; resize: none;
  margin: 0 0 4px;
}
.emt-textarea:focus { border-color: var(--td-green); }
.emt-textarea::placeholder { color: var(--text-light); }

/* Primary & ghost buttons */
.emt-primary-btn {
  display: flex; align-items: center; justify-content: center;
  width: calc(100% - 28px); margin: 8px 14px 4px;
  padding: 14px; border-radius: 10px; border: none;
  background: var(--td-green); color: #fff;
  font-size: var(--font-base); font-weight: 700; cursor: pointer; font-family: inherit;
  transition: opacity 0.15s;
}
.emt-primary-btn:hover { opacity: 0.88; }
.emt-ghost-btn {
  display: block; width: calc(100% - 28px); margin: 0 14px 16px;
  padding: 12px; border-radius: 10px;
  border: 1px solid var(--border-color); background: transparent;
  color: var(--text-medium); font-size: var(--font-base); font-weight: 600;
  cursor: pointer; font-family: inherit; transition: border-color 0.12s;
}
.emt-ghost-btn:hover { border-color: var(--text-medium); }

/* Review screen */
.emt-review-amount {
  font-size: var(--font-3xl); font-weight: 800; text-align: center;
  color: var(--text-dark); padding: 28px 0 16px;
}
.emt-review-row {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 11px 14px; border-top: 1px solid var(--border-color);
}
.emt-review-row:first-of-type { border-top: none; }
.emt-review-label { font-size: var(--font-sm); color: var(--text-light); flex-shrink: 0; width: 70px; padding-top: 1px; }
.emt-review-value { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); text-align: right; line-height: 1.4; }
.emt-notice {
  margin: 0 14px 14px; padding: 10px 12px;
  background: var(--bg-light-gray); border-radius: 8px;
  border-left: 3px solid var(--td-green);
  font-size: var(--font-xs); color: var(--text-medium); line-height: 1.5;
}

/* Success state */
.emt-success-body {
  flex: 1 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  padding: 32px 24px; text-align: center;
}
.emt-success-circle {
  width: 80px; height: 80px; border-radius: 50%;
  background: rgba(106,85,247,0.1);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 18px;
}
.emt-success-title { font-size: var(--font-xl); font-weight: 800; color: var(--text-dark); margin-bottom: 8px; }
.emt-success-amount { font-size: var(--font-3xl); font-weight: 800; color: var(--td-green); }
.emt-success-sub { font-size: var(--font-base); color: var(--text-medium); margin-top: 4px; }
.emt-success-eta {
  margin-top: 16px; padding: 8px 16px; border-radius: 20px;
  background: var(--bg-light-gray); border: 1px solid var(--border-color);
  font-size: var(--font-sm); color: var(--text-medium);
}

/* ---- Bill Payment specific ---- */

.bp-search-bar {
  display: flex; align-items: center; gap: 8px;
  background: var(--bg-card); border-bottom: 1px solid var(--border-color);
  padding: 8px 14px; flex-shrink: 0;
}
.bp-search-input {
  flex: 1 1; background: var(--bg-light-gray); border: 1px solid var(--border-color);
  border-radius: 8px; padding: 8px 12px; font-size: var(--font-sm);
  color: var(--text-dark); font-family: inherit; outline: none;
}
.bp-search-input::placeholder { color: var(--text-light); }
.bp-search-input:focus { border-color: var(--td-green); }

.bp-payee-row {
  display: flex; align-items: center; gap: 12px;
  padding: 13px 16px; background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  cursor: pointer; transition: background 0.1s;
}
.bp-payee-row:hover { background: var(--bg-light-gray); }
.bp-payee-logo-sm { font-size: var(--font-xl); flex-shrink: 0; width: 28px; text-align: center; }
.bp-payee-row-name { flex: 1 1; font-size: var(--font-base); font-weight: 500; color: var(--text-dark); }

.bp-payee-banner {
  display: flex; align-items: center; gap: 12px;
  background: var(--bg-card); border-bottom: 1px solid var(--border-color);
  border-radius: 12px; margin: 14px 14px 0;
  padding: 14px; border: 1px solid var(--border-color);
}
.bp-payee-logo { font-size: var(--font-2xl); flex-shrink: 0; }
.bp-payee-banner-name { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }
.bp-payee-banner-cat  { font-size: var(--font-xs); color: var(--text-light); margin-top: 2px; }
.bp-change-btn {
  margin-left: auto; padding: 5px 12px; border-radius: 6px;
  background: var(--bg-light-gray); border: 1px solid var(--border-color);
  font-size: var(--font-sm); font-weight: 600; color: var(--td-green); cursor: pointer; font-family: inherit;
}

.bp-date-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 14px;
}
.bp-date-label { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }
.bp-date-value { font-size: var(--font-sm); color: var(--text-medium); }

/* --- Services Hub Screen --- */
.services-screen .simple-header { justify-content: flex-start; }

.services-icon-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 8px;
  padding: 16px 12px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.services-icon-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
  font-family: inherit;
}

.services-icon-tile:disabled { opacity: 0.45; cursor: default; }

.services-icon-circle {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  transition: transform 0.15s;
}

.services-icon-tile:not(:disabled):active .services-icon-circle { transform: scale(0.92); }

.services-icon-tile span {
  font-size: var(--font-xs);
  font-weight: 500;
  color: var(--text-dark);
  text-align: center;
  line-height: 1.3;
}

.services-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-light);
  padding: 16px 16px 8px;
}

.services-featured-list {
  background: var(--bg-card);
  border-radius: 12px;
  margin: 0 12px 16px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.services-featured-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-color);
  transition: background 0.1s;
}

.services-featured-item:last-child { border-bottom: none; }
.services-featured-item:hover { background: var(--bg-light-gray); }

.services-featured-text { flex: 1 1; }
.services-featured-title { font-size: var(--font-base); font-weight: 600; color: var(--text-dark); }
.services-featured-sub   { font-size: var(--font-sm); color: var(--text-medium); margin-top: 2px; }

/* ============================================================
   ACCOUNT TRANSFER SCREEN  (.acct-transfer-)
   ============================================================ */
.acct-transfer-ref {
  font-size: var(--font-sm);
  color: var(--text-light);
  margin-top: 8px;
  letter-spacing: 0.04em;
}

/* ============================================================
   MOBILE DEPOSIT SCREEN  (.mob-deposit-)
   ============================================================ */
.mob-deposit-capture-row {
  display: flex;
  gap: 12px;
  padding: 0 14px 14px;
}
.mob-deposit-capture-box {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 2px dashed var(--border-color);
  border-radius: 12px;
  padding: 20px 8px;
  cursor: pointer;
  background: var(--bg-light-gray);
  transition: border-color 0.15s, background 0.15s;
}
.mob-deposit-capture-box.done {
  border-color: var(--td-green);
  background: rgba(0,138,62,0.06);
}
.mob-deposit-capture-box.error { border-color: #e53e3e; }
.mob-deposit-capture-label {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-dark);
  text-align: center;
}
.mob-deposit-capture-sub {
  font-size: var(--font-xs);
  color: var(--text-light);
  text-align: center;
}
.mob-deposit-availability {
  font-size: var(--font-sm);
  color: var(--text-medium);
  margin-top: 6px;
  background: var(--bg-light-gray);
  border-radius: 8px;
  padding: 8px 16px;
}

/* ============================================================
   CROSS-BORDER SCREEN  (.cross-border-)
   ============================================================ */
.cross-border-rate-banner {
  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 100%);
  color: white;
  padding: 18px 20px;
  text-align: center;
}
.cross-border-rate-label {
  font-size: var(--font-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.85;
  margin-bottom: 4px;
}
.cross-border-rate-value {
  font-size: var(--font-xl);
  font-weight: 700;
  margin-bottom: 4px;
}
.cross-border-rate-time {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xs);
  opacity: 0.75;
}
.cross-border-balances {
  display: flex;
  gap: 12px;
  padding: 14px 14px 4px;
}
.cross-border-balance-card {
  flex: 1 1;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 14px;
  text-align: center;
}
.cross-border-balance-cur {
  font-size: var(--font-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--td-green);
  text-transform: uppercase;
}
.cross-border-balance-name {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin: 3px 0;
}
.cross-border-balance-amt {
  font-size: var(--font-lg);
  font-weight: 700;
  color: var(--text-dark);
}
.cross-border-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-light);
  padding: 14px 14px 6px;
}
.cross-border-service-row {
  display: flex;
  align-items: center;
  padding: 13px 14px;
  border-top: 1px solid var(--border-color);
  cursor: pointer;
}
.cross-border-service-row:first-child { border-top: none; }
.cross-border-service-name {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-dark);
}
.cross-border-service-sub {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 2px;
}
.cross-border-soon-badge {
  font-size: var(--font-xs);
  font-weight: 600;
  color: var(--text-medium);
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 3px 8px;
  white-space: nowrap;
}
.cross-border-swap-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 16px 14px 12px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 4px;
}
.cross-border-cur-pill {
  background: var(--bg-light-gray);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px 20px;
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
  min-width: 60px;
  text-align: center;
}
.cross-border-swap-btn {
  background: var(--td-green);
  border: none;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  flex-shrink: 0;
}
.cross-border-quote-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 10px 16px 8px;
  background: rgba(0,138,62,0.06);
  margin: 0 16px 10px;
  border-radius: 10px;
  border: 1px solid rgba(0,138,62,0.2);
}
.cross-border-quote-label {
  font-size: var(--font-xs);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-medium);
}
.cross-border-quote-value {
  font-size: var(--font-xl);
  font-weight: 700;
  color: var(--td-green);
}
.cross-border-quote-note {
  font-size: var(--font-xs);
  color: var(--text-light);
  text-align: center;
}

/* ============================================================
   AUTO SERVICES SCREEN  (.auto-svc-)
   ============================================================ */
.auto-svc-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-light);
  padding: 14px 14px 6px;
}
.auto-svc-vehicle-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px 12px 0 0;
  margin: 0 14px;
  padding: 16px 14px;
  border-bottom: none;
}
.auto-svc-vehicle-icon {
  width: 48px;
  height: 48px;
  background: rgba(0,138,62,0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.auto-svc-vehicle-name {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
}
.auto-svc-vehicle-sub {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 3px;
}
.auto-svc-insurer-row {
  display: flex;
  align-items: center;
  padding: 14px 14px 10px;
  border-bottom: 1px solid var(--border-color);
}
.auto-svc-insurer-name {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
}
.auto-svc-insurer-sub {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 2px;
}
.auto-svc-outline-btn {
  display: block;
  width: calc(100% - 28px);
  margin: 4px 14px 14px;
  padding: 11px;
  background: transparent;
  border: 1.5px solid var(--td-green);
  border-radius: 10px;
  color: var(--td-green);
  font-size: var(--font-base);
  font-weight: 600;
  cursor: pointer;
  text-align: center;
}
.auto-svc-contact-row {
  display: flex;
  align-items: flex-start;
  padding: 14px;
}
.auto-svc-finance-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 100%);
  border-radius: 12px;
  margin: 6px 14px 0;
  padding: 18px 16px;
  cursor: pointer;
}
.auto-svc-finance-title {
  font-size: var(--font-base);
  font-weight: 700;
  color: white;
}
.auto-svc-finance-sub {
  font-size: var(--font-sm);
  color: rgba(255,255,255,0.8);
  margin-top: 3px;
}

/* ============================================================
   PRE-AUTHORIZED PAYMENTS SCREEN  (.pre-auth-)
   ============================================================ */
.pre-auth-summary-bar {
  display: flex;
  align-items: center;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  padding: 14px 0;
  margin-bottom: 8px;
}
.pre-auth-summary-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.pre-auth-summary-val {
  font-size: var(--font-lg);
  font-weight: 700;
  color: var(--text-dark);
}
.pre-auth-summary-label {
  font-size: var(--font-xs);
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.pre-auth-summary-divider {
  width: 1px;
  height: 30px;
  background: var(--border-color);
}
.pre-auth-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-light);
  padding: 10px 14px 6px;
}
.pre-auth-row {
  display: flex;
  align-items: center;
  padding: 13px 14px;
  border-top: 1px solid var(--border-color);
  gap: 12px;
}
.pre-auth-row:first-child { border-top: none; }
.pre-auth-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pre-auth-info { flex: 1 1; min-width: 0; }
.pre-auth-merchant {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pre-auth-meta {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pre-auth-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  flex-shrink: 0;
}
.pre-auth-amount {
  font-size: var(--font-sm);
  font-weight: 700;
  color: var(--text-dark);
}
.pre-auth-manage-chip {
  display: flex;
  align-items: center;
  font-size: var(--font-xs);
  font-weight: 600;
  color: var(--td-green);
  background: rgba(0,138,62,0.1);
  border: 1px solid rgba(0,138,62,0.25);
  border-radius: 12px;
  padding: 3px 9px;
  cursor: pointer;
  white-space: nowrap;
}
.pre-auth-manage-chip.pending {
  color: #f5a623;
  background: rgba(245,166,35,0.1);
  border-color: rgba(245,166,35,0.3);
}
.pre-auth-popover {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.14);
  z-index: 10;
  overflow: hidden;
  min-width: 120px;
}
.pre-auth-popover-item {
  display: block;
  width: 100%;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-top: 1px solid var(--border-color);
  font-size: var(--font-sm);
  font-weight: 500;
  color: var(--text-dark);
  text-align: left;
  cursor: pointer;
}
.pre-auth-popover-item:first-child { border-top: none; }
.pre-auth-popover-item.danger { color: #e53e3e; }
.pre-auth-popover-item:hover { background: var(--bg-light-gray); }
.pre-auth-add-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 28px);
  margin: 14px 14px 4px;
  padding: 13px;
  background: transparent;
  border: 1.5px dashed var(--border-color);
  border-radius: 12px;
  font-size: var(--font-base);
  font-weight: 600;
  color: var(--td-green);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.pre-auth-add-btn:hover {
  background: rgba(0,138,62,0.05);
  border-color: var(--td-green);
}

/* ============================================================
   PORTFOLIO SCREEN  (.port-)
   ============================================================ */

/* Hero value banner */
.port-hero {
  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 60%, var(--td-accent) 100%);
  padding: 12px 16px 14px;
  text-align: center;
}
.port-hero-label {
  font-size: var(--font-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.7);
  margin-bottom: 4px;
}
.port-hero-value {
  font-size: var(--font-2xl);
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
  margin-bottom: 6px;
}
.port-hero-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}
.port-daily-badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: var(--font-sm);
  font-weight: 600;
}
.port-daily-badge.badge-up   { background: rgba(255,255,255,0.22); color: #c8ffd8; }
.port-daily-badge.badge-down { background: rgba(255,80,80,0.25);   color: #ffc8c8; }
.port-alltime-badge {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: var(--font-xs);
  font-weight: 500;
  background: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.8);
}
.port-hero-profile {
  font-size: var(--font-xs);
  color: rgba(255,255,255,0.6);
  margin-top: 8px;
}

/* Range selector */
.port-range-row {
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
}
.port-range-btn {
  flex: 1 1;
  padding: 4px 0;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--text-medium);
  font-size: var(--font-xs);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.port-range-btn.active {
  background: var(--td-green);
  color: #fff;
  border-color: var(--td-green);
}

/* Section label */
.port-section-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-light);
  padding: 12px 14px 6px;
}

/* Account cards — horizontal scroll */
.port-acct-scroll {
  display: flex;
  gap: 10px;
  padding: 0 14px 14px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.port-acct-scroll::-webkit-scrollbar { display: none; }
.port-acct-card {
  flex: 0 0 130px;
  background: var(--bg-card);
  border-radius: 10px;
  border-top: 3px solid var(--td-green);
  padding: 12px 12px 10px;
}
.port-acct-label {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 5px;
}
.port-acct-value {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 6px;
}
.port-acct-room {
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-top: 1px solid var(--border-color);
  padding-top: 6px;
}
.port-acct-room-label {
  font-size: var(--font-2xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-light);
}
.port-acct-room-val {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-medium);
}
.port-acct-strategy {
  font-size: var(--font-xs);
  color: var(--text-light);
  margin-top: 6px;
  line-height: 1.3;
}

/* Holdings list */
.port-holding-row {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-top: 1px solid var(--border-color);
  gap: 10px;
}
.port-holding-row:first-child { border-top: none; }
.port-holding-ticker-wrap { flex: 1 1; min-width: 0; }
.port-holding-ticker {
  font-size: var(--font-sm);
  font-weight: 700;
  color: var(--text-dark);
}
.port-holding-name {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.port-holding-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  flex-shrink: 0;
}
.port-holding-value {
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--text-dark);
}
.port-holding-gain {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: var(--font-xs);
  font-weight: 600;
  border-radius: 4px;
  padding: 1px 5px;
}
.port-holding-gain.gain-up   { color: #4caf7d; background: rgba(76,175,80,0.12); }
.port-holding-gain.gain-down { color: #e57373; background: rgba(229,115,115,0.12); }

/* Section label row with "View details" link */
.port-section-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 6px;
}
.port-section-link {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: var(--font-xs);
  font-weight: 600;
  color: var(--td-green);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

/* ============================================================
   REGISTERED ACCOUNTS SCREEN  (.ra-)
   ============================================================ */

/* Summary banner */
.ra-summary-banner {
  display: flex;
  align-items: center;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
  padding: 14px 0;
}
.ra-summary-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.ra-summary-val {
  font-size: var(--font-lg);
  font-weight: 700;
  color: var(--text-dark);
}
.ra-summary-lbl {
  font-size: var(--font-xs);
  color: var(--text-medium);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.ra-summary-divider {
  width: 1px;
  height: 30px;
  background: var(--border-color);
}

/* Tax callout strip */
.ra-tax-callout {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: rgba(126,200,164,0.1);
  border: 1px solid rgba(126,200,164,0.25);
  border-radius: 10px;
  margin: 10px 12px;
  padding: 11px 12px;
  font-size: var(--font-sm);
  color: var(--text-medium);
  line-height: 1.5;
}

/* Account card */
.ra-card {
  background: var(--bg-card);
  border-radius: 12px;
  margin: 0 12px 10px;
  border-top: 3px solid var(--td-green);
  overflow: hidden;
}
.ra-card-header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 13px 14px 10px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  gap: 8px;
}
.ra-card-left { flex: 1 1; min-width: 0; }
.ra-card-label {
  font-size: var(--font-base);
  font-weight: 700;
  letter-spacing: 0.03em;
}
.ra-card-full-label {
  font-size: var(--font-xs);
  color: var(--text-medium);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ra-card-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.ra-card-value {
  font-size: var(--font-base);
  font-weight: 700;
  color: var(--text-dark);
}
.ra-card-gain {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: var(--font-xs);
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
}
.ra-card-gain.gain-up   { color: #4caf7d; background: rgba(76,175,80,0.12); }
.ra-card-gain.gain-down { color: #e57373; background: rgba(229,115,115,0.12); }

/* Tax benefit badge (below header, always visible) */
.ra-tax-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-xs);
  font-weight: 600;
  padding: 4px 14px 10px;
}

/* Card expanded body */
.ra-card-body {
  padding: 0 14px 14px;
  border-top: 1px solid var(--border-color);
}

/* Contribution room bar */
.ra-room-wrap { margin-top: 12px; margin-bottom: 10px; }
.ra-room-labels {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;
}
.ra-room-track {
  height: 8px;
  border-radius: 4px;
  background: var(--bg-light-gray);
  display: flex;
  overflow: hidden;
}
.ra-room-fill-used, .ra-room-fill-ytd, .ra-room-fill-avail {
  height: 100%;
  transition: width 0.4s ease;
}
.ra-room-legend {
  display: flex;
  gap: 10px;
  margin-top: 5px;
  flex-wrap: wrap;
}
.ra-room-legend span {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-xs);
  color: var(--text-medium);
}
.ra-legend-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex-shrink: 0;
}

/* Annual / lifetime limits chips */
.ra-limits-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}
.ra-limit-chip {
  flex: 1 1;
  background: var(--bg-light-gray);
  border-radius: 8px;
  padding: 7px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.ra-limit-lbl { font-size: var(--font-xs); color: var(--text-medium); text-transform: uppercase; letter-spacing: 0.04em; }
.ra-limit-val { font-size: var(--font-sm); font-weight: 700; color: var(--text-dark); }

/* Deadline */
.ra-deadline {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  background: rgba(122,174,232,0.1);
  border: 1px solid rgba(122,174,232,0.25);
  border-radius: 8px;
  padding: 9px 11px;
  font-size: var(--font-sm);
  color: var(--text-medium);
  margin-bottom: 10px;
  line-height: 1.4;
}
.ra-deadline.urgent {
  background: rgba(232,124,106,0.1);
  border-color: rgba(232,124,106,0.3);
  color: #e87c6a;
}

/* Tax detail */
.ra-tax-detail {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: var(--font-sm);
  color: var(--text-medium);
  line-height: 1.5;
  margin-bottom: 12px;
}

/* Holdings within account */
.ra-holdings-title {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-light);
  margin-bottom: 6px;
}
.ra-holding-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
}
.ra-holding-ticker {
  font-size: var(--font-xs);
  font-weight: 700;
  color: var(--text-dark);
  width: 52px;
  flex-shrink: 0;
}
.ra-holding-name {
  font-size: var(--font-xs);
  color: var(--text-medium);
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ra-holding-bar-wrap {
  width: 60px;
  height: 5px;
  background: var(--bg-light-gray);
  border-radius: 3px;
  overflow: hidden;
  flex-shrink: 0;
}
.ra-holding-bar {
  height: 100%;
  border-radius: 3px;
  transition: width 0.4s ease;
}
.ra-holding-pct {
  font-size: var(--font-xs);
  font-weight: 600;
  color: var(--text-medium);
  width: 30px;
  text-align: right;
  flex-shrink: 0;
}

/* Key facts */
.ra-facts-title {
  font-size: var(--font-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-light);
  margin: 10px 0 6px;
}
.ra-fact-row {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 5px;
}
.ra-fact-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}
.ra-fact-text {
  font-size: var(--font-xs);
  color: var(--text-medium);
  line-height: 1.5;
}

/* CTA row */
.ra-cta-row {
  display: flex;
  justify-content: center;
  padding: 10px 12px 4px;
}
.ra-cta-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--font-sm);
  font-weight: 600;
  color: var(--td-green);
  background: none;
  border: 1px solid var(--td-green);
  border-radius: 20px;
  padding: 8px 20px;
  cursor: pointer;
  transition: background 0.15s;
}
.ra-cta-btn:hover { background: rgba(0,138,62,0.08); }

/* ═══════════════════════════════════════════════════════════════════
   MOBILE OVERRIDES — must stay at end of file to win cascade battles
   ═══════════════════════════════════════════════════════════════════ */
@media (max-width: 600px) {

  /* iOS: prevent body bounce scroll, fill dynamic viewport */
  html, body { overflow: hidden; height: 100dvh; }

  /* Safe area insets for notched iPhones (viewport-fit=cover) */
  .phone-viewport {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: border-box;
  }
  .bottom-nav {
    padding-bottom: max(env(safe-area-inset-bottom), 8px);
  }

  /* Hide all desktop-only floating chrome */
  .demo-nav, .theme-toggle-float, .global-save-btn, .version-label { display: none !important; }

  /* Demo pulldown tab: TOP-CENTER, small tab pinned to the top edge */
  .demo-pulldown-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    height: 16px;
    padding: 0 10px;
    border-radius: 0 0 8px 8px;
    background: rgba(30, 20, 60, 0.92);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.15);
    border-top: none;
    color: rgba(255,255,255,0.75);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    cursor: grab;
    touch-action: none;      /* let pointer-drag work on touch without scrolling */
    -webkit-user-select: none;
            user-select: none;
  }
  .demo-pulldown-tab:active { background: rgba(30,20,60,0.75); cursor: grabbing; }
  /* Double-tap collapses it to a small line handle hugging the top edge — a
     minimal footprint, but still large enough to find and tap to restore. */
  .demo-pulldown-tab.collapsed {
    height: 8px;
    padding: 0;
    width: 60px;
    min-height: 0;
    border: none;
    border-radius: 0 0 4px 4px;
    background: rgba(30, 20, 60, 0.6);
    opacity: 0.7;
  }

  .scroll-content { padding: 0 12px; }

  /* Screen: bottom padding clears the 62px nav */
  .screen { padding-bottom: 62px; }

  /* ── Headers ── */
  .simple-header { height: 52px; padding: 0 16px; flex-shrink: 0; }
  .back-icon     { font-size: var(--font-xl); width: 22px; height: 22px; }

  /* ── Bottom nav ── */
  .bottom-nav { height: 62px; }

  /* ── Account list items ── */
  .account-list-item { padding: 14px 16px; }
  .ali-name    { font-size: var(--font-base); white-space: normal; overflow: visible; text-overflow: clip; }
  .ali-num     { font-size: var(--font-sm); }
  .ali-balance { font-size: var(--font-base); }
  .list-group-title { font-size: var(--font-sm); padding: 12px 16px 6px; }
  .account-total-row { padding: 14px 16px; }

  /* ── Services hub: 4-column grid ── */
  .services-icon-grid { grid-template-columns: repeat(4, 1fr); gap: 12px 6px; padding: 12px 8px; }
  .services-icon-tile { width: 100%; }
  .services-icon-circle { width: 52px; height: 52px; border-radius: 14px; }
  .services-icon-tile span { font-size: var(--font-xs); margin-top: 4px; }
  .services-section-label { font-size: var(--font-xs); padding: 12px 12px 6px; }
  .services-featured-title { font-size: var(--font-base); }
  .services-featured-sub   { font-size: var(--font-sm); }

  /* ── Transaction items ── */
  .transaction-item { padding: 12px 16px; }
  .ti-merchant { font-size: var(--font-base); white-space: normal; overflow: visible; text-overflow: clip; }
  .ti-amount   { font-size: var(--font-base); }

  /* ── Account/Credit hero header ── */
  .hero-balance h1  { font-size: var(--font-2xl); }
  .hero-balance p   { font-size: var(--font-sm); }
  .tabs-container .tab { font-size: var(--font-sm); padding: 10px 14px; }

  /* ── Credit / Security quick actions ── */
  .cqa-icon { width: 44px; height: 44px; font-size: var(--font-xl); }
  .sqa-icon { width: 40px; height: 40px; font-size: var(--font-lg); }

  /* ── Chat FAB ── */
  .chat-fab { width: 52px; height: 52px; bottom: 74px; right: 12px; }

  /* ── Prevent iOS input zoom (must be ≥16px) ── */
  input, select, textarea { font-size: 16px !important; }

  /* ── Portfolio ── */
  .port-hero-value { font-size: var(--font-2xl); }
  .port-holding-ticker { font-size: var(--font-sm); }
  .port-holding-name  { font-size: var(--font-xs); white-space: normal; }
  .port-holding-value { font-size: var(--font-sm); }

  /* ── Registered accounts ── */
  .ra-card-value  { font-size: var(--font-lg); }
  .ra-card-label  { font-size: var(--font-sm); }

  /* ── Goals / cards ── */
  .goal-card h3 { font-size: var(--font-base); }
  .goal-stats strong { font-size: var(--font-base); }

  /* ── Profile screen ── */
  .profile-hero-name  { font-size: var(--font-xl); }
  .profile-hero-sub   { font-size: var(--font-sm); }
  .profile-hero-email { font-size: var(--font-sm); }
  .profile-section-title  { font-size: var(--font-xs); }
  .profile-balance-label  { font-size: var(--font-sm); }
  .profile-balance-val    { font-size: var(--font-sm); }
  .profile-settings-label { font-size: var(--font-sm); }
  .profile-settings-value { font-size: var(--font-sm); }

  /* ── Chat / Swipe suggestion chips ── */
  /* Keep single-row horizontal scroll on mobile — wrapping fills the screen. */
  .suggestions-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 6px;
  }

  /* ── SwipeScreen advisor card ── */
  .swipe-card { width: calc(100% - 32px); max-width: 340px; }

  /* ── Budget banner ── */
  /* Large income figures with white-space:nowrap can push past 375px. */
  .budget-banner-income { white-space: normal; font-size: var(--font-xl); }

  /* ── Admin screen ── */
  /* Ensure any wide content in admin panels scrolls rather than overflows. */
  .admin-screen .bh-form-card { overflow-x: auto; }

  /* ── EMT / Transfer ── */
  /* Account balance badge: allow wrapping to second line on very narrow screens. */
  .emt-account-balance { white-space: normal; }
}

/* ── ChatScreen BeHuman reskin (CSS-only, no JSX changes) ─────────────
   Targets .chat-screen so other screens that use .simple-header etc.
   are not affected. */
.chat-screen .simple-header {
  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);
  color: var(--bh-white);
  box-shadow: var(--shadow-md);
}
.chat-screen .new-chat-button {
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(0, 0, 0, 0.18);
  color: var(--bh-white);
  border-radius: var(--radius-md);
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;
}
.chat-screen .new-chat-button:hover {
  background: rgba(0, 0, 0, 0.28);
  border-color: rgba(0, 0, 0, 0.28);
}
.chat-screen .chat-model-label { color: rgba(255,255,255,0.85); }
.chat-screen .chat-title-text  { color: var(--bh-white); font-weight: 700; }

/* Suggestion pills — closer to BeHuman QuickReply style */
.chat-screen .chat-suggestion-chip {
  background: var(--bh-white);
  border: 1.5px solid var(--bh-light-gray);
  color: var(--bh-black);
  font-weight: 600;
  font-size: var(--font-sm);
  border-radius: var(--radius-full);
  padding: 8px 16px;
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out, color 200ms ease-in-out;
}
.chat-screen .chat-suggestion-chip:hover {
  background: var(--td-green-light);
  border-color: var(--td-green);
  color: var(--td-green);
}

/* Input bar — clean white pill with light border */
.chat-screen .chat-input-area {
  /* Match the scroll-content gray above so the surfaces flow, but add a
     clear divider line + a soft shadow so the functional bar (suggestions
     and textbox) reads as its own region rather than a continuation. */
  background: var(--bg-light-gray);
  border-top: 1px solid var(--border-color);
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
}
.chat-screen .input-row {
  /* Flip the textbox pill to white so it floats on top of the gray
     surround — opposite of the original (gray pill on white). */
  background: var(--bh-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  padding: 6px 6px 6px 18px;
}
.chat-screen .input-row input { font-size: var(--font-base); color: var(--bh-black); }
.chat-screen .input-row input::placeholder { color: var(--bh-gray); }
.chat-screen .send-button {
  background: var(--td-green);
  color: var(--bh-black);
  width: 44px;
  height: 44px;
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-sm);
  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out;
}
.chat-screen .send-button:hover { background: var(--td-dark-green); box-shadow: var(--shadow-green); }

/* Voice mode UI inside ChatScreen (Option A merger) */
.chat-screen .new-chat-button.active {
  background: var(--bh-black);
  border-color: var(--bh-black);
  color: var(--bh-white);
}

.chat-screen .mic-button {
  width: 44px;
  height: 44px;
  background: var(--bh-light-gray);
  color: var(--bh-black);
  border: none;
  border-radius: var(--radius-md);   /* buttons rounded per May 2026 rule */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-xl);
  cursor: pointer;
  margin-right: 6px;
  transition: background 200ms ease-in-out, color 200ms ease-in-out;
  flex-shrink: 0;
}
.chat-screen .mic-button:hover { background: var(--td-green-light); }
.chat-screen .mic-button.active {
  background: var(--td-red);
  color: var(--bh-white);
  animation: chat-mic-pulse 1.6s ease-out infinite;
}
/* Visual cue while the user is holding the mic — a circular green ring
   closes in over ~600ms, telegraphing conversation mode is about to open.
   Rendered via a ::before pseudo so the ring is a true circle even though
   the mic button itself is a (potentially squared) tile. */
.chat-screen .mic-button { position: relative; }
.chat-screen .mic-button.long-pressing {
  background: var(--td-green-light);
  color: var(--td-green);
}
.chat-screen .mic-button.long-pressing::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 2px solid var(--td-green);
  transform: translate(-50%, -50%);
  pointer-events: none;
  /* Ring starts at 600 ms into the hold; conversation mode fires at 3000 ms.
     That leaves 2400 ms for the animation to run — set duration to match. */
  animation: chat-mic-longpress-ring 2.4s ease-out forwards;
}
@keyframes chat-mic-pulse {
  0%   { box-shadow: 0 0 0 0   rgba(211, 47, 47, 0.55); }
  70%  { box-shadow: 0 0 0 10px rgba(211, 47, 47, 0);    }
  100% { box-shadow: 0 0 0 0   rgba(211, 47, 47, 0);    }
}
@keyframes chat-mic-longpress-ring {
  /* Circle starts large and faint, contracts to wrap the button as the
     hold completes — visual countdown toward conversation mode. */
  0%   { width: 84px; height: 84px; opacity: 0.25; border-width: 2px; }
  100% { width: 50px; height: 50px; opacity: 0.95; border-width: 3px; }
}

.chat-voice-status {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2xs);
  font: var(--bh-body-sm);
  color: var(--td-red);
  padding: 0 var(--space-2xs) var(--space-2xs);
  background: transparent;
}
.chat-voice-status.speaking {
  color: var(--td-amber);
  background: rgba(245, 158, 11, 0.08);
  padding: var(--space-3xs) var(--space-2xs);
  border-radius: var(--radius-full);
  transition: background 0.15s ease;
}
.chat-voice-status.speaking:hover { background: rgba(245, 158, 11, 0.16); }
.chat-voice-dot {
  width: 8px;
  height: 8px;
  background: currentColor;
  display: inline-block;
  animation: chat-voice-dot-pulse 1.2s ease-in-out infinite;
}
@keyframes chat-voice-dot-pulse {
  0%, 100% { opacity: 0.45; transform: scale(0.85); }
  50%      { opacity: 1;    transform: scale(1.15); }
}

/* Per-message timestamp under each bubble (kit pattern). */
.chat-message-time {
  display: block;
  margin-top: 4px;
  font: var(--bh-caption);
  color: var(--bh-gray);
  letter-spacing: 0;
}
.bot-message  .chat-message-time { text-align: left; }
.user-message .chat-message-time { text-align: right; }

/* ── Bot reply: flat (no bubble fill) so long answers feel document-like.
   User messages keep the green bubble defined earlier.
   align-self: stretch overrides the wrapper's flex-start so the bubble
   gets full wrapper width — required for ChartWrapper's recharts
   container to have a defined width to render into. Without it, charts
   collapse to 0×0 and the table-replacement vanishes silently. */
.chat-bubble.chat-bubble--flat {
  background: transparent !important;
  color: var(--text-dark);
  border: none;
  box-shadow: none;
  padding: 4px 0;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  border-bottom-left-radius: 0;
}

/* ── Per-bot-message action toolbar — copy / thumbs up / thumbs down.
   ChatGPT-style: subtle gray icons, lights up on hover, active state for
   the current feedback choice. Sits flush-left under the reply. */
.chat-msg-actions {
  display: inline-flex;
  align-items: center;
  gap: 0;                  /* tight cluster — no gap between buttons */
  margin-top: 2px;
  margin-left: -4px;       /* visually align icons with the message left edge */
}
.chat-msg-action {
  background: transparent;
  border: none;
  color: var(--bh-gray);
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 150ms ease-in-out, background 150ms ease-in-out;
}
.chat-msg-action:hover {
  color: var(--bh-black);
  background: var(--bh-light-gray);
}
.chat-msg-action.is-active        { color: var(--td-green); }
.chat-msg-action.is-active.is-danger { color: var(--td-red); }
.chat-msg-action.is-success       { color: var(--td-green); }

/* ── Conversation Mode (full-screen voice surface) ─────────────────────
   On-brand BeHuman rebuild: Premium Green base (matches the Investing
   high-net-worth aesthetic), bh-* typography tokens throughout, hero
   pattern using bh-flow-hero conventions, BH primitive-style controls.
   Lives over the chat surface; voice hooks are shared with ChatScreen so
   exit returns to chat with all turns preserved in history. */
.conv-mode {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(800px 500px at 50% 30%, rgba(47, 191, 0, 0.06) 0%, transparent 70%),
    linear-gradient(180deg, var(--td-premium) 0%, var(--bh-black) 65%, #0a0a0a 100%);
  color: var(--bh-white);
  display: flex;
  flex-direction: column;
  z-index: 200;
}

/* Hero row — borrows the bh-flow-hero pattern (back button + centered
   eyebrow title) but transparent over the premium dark background. */
.conv-mode-header {
  display: flex;
  align-items: center;
  padding: var(--space-md) var(--space-md) var(--space-sm);
  flex-shrink: 0;
}
.conv-mode-back {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: var(--bh-white);
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;
}
.conv-mode-back:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.32);
}
.conv-mode-title {
  flex: 1 1;
  text-align: center;
  font: var(--bh-overline);     /* BH eyebrow — uppercase + weighted */
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--td-gold);         /* premium accent — pairs with td-premium bg */
  opacity: 0.85;
}
.conv-mode-spacer { width: 40px; }

.conv-mode-stage {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  padding: var(--space-md);
  text-align: center;
}

.conv-mode-orb {
  position: relative;
  width: 220px;
  height: 220px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.conv-mode-orb:disabled { cursor: not-allowed; }

.conv-mode-orb-core {
  position: absolute;
  inset: 30px;
  border-radius: 50%;
  /* Defaults are overridden by state variants below. */
  background: radial-gradient(circle at 30% 30%, var(--td-green) 0%, var(--td-dark-green) 70%, var(--td-premium) 100%);
  box-shadow: 0 0 60px rgba(47, 191, 0, 0.35), inset 0 0 40px rgba(0, 0, 0, 0.25);
  transition: transform 600ms ease-in-out, box-shadow 600ms ease-in-out, background 600ms ease-in-out;
}
.conv-mode-orb-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: rgba(47, 191, 0, 0.18);
  pointer-events: none;
  opacity: 0;
}

/* State variants — orb mood matches the BH accent palette per phase. */
.conv-mode.is-idle .conv-mode-orb-core {
  /* Premium dim — feels in-tier with the background */
  background: radial-gradient(circle at 30% 30%, rgba(207, 189, 145, 0.35) 0%, rgba(0, 43, 26, 0.6) 80%);
  box-shadow: 0 0 30px rgba(207, 189, 145, 0.08);
  transform: scale(0.92);
}
.conv-mode.is-listening .conv-mode-orb-core {
  /* Shield green — the chart-1 accent, signals "active" */
  background: radial-gradient(circle at 30% 30%, #66e02b 0%, var(--td-shield) 60%, var(--td-premium) 100%);
  animation: conv-pulse 1.4s ease-in-out infinite;
}
.conv-mode.is-listening .conv-mode-orb-pulse {
  animation: conv-ring-pulse 1.4s ease-out infinite;
}
.conv-mode.is-thinking .conv-mode-orb-core {
  /* Lavender → purple — accent palette, calm but processing */
  background: radial-gradient(circle at 30% 30%, var(--td-lavender) 0%, var(--td-purple) 70%, #1a0c2e 100%);
  animation: conv-spin 3s linear infinite;
}
.conv-mode.is-speaking .conv-mode-orb-core {
  background: radial-gradient(circle at 30% 30%, #66e02b 0%, var(--td-shield) 60%, var(--td-premium) 100%);
  animation: conv-wave 0.9s ease-in-out infinite;
}

@keyframes conv-pulse {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.06); }
}
@keyframes conv-ring-pulse {
  0%   { opacity: 0.55; transform: scale(0.85); }
  70%  { opacity: 0;    transform: scale(1.15); }
  100% { opacity: 0;    transform: scale(1.15); }
}
@keyframes conv-spin {
  0%   { transform: rotate(0deg)   scale(0.98); }
  50%  { transform: rotate(180deg) scale(1.02); }
  100% { transform: rotate(360deg) scale(0.98); }
}
@keyframes conv-wave {
  0%, 100% { transform: scale(1);    box-shadow: 0 0 60px rgba(47, 191, 0, 0.35); }
  50%      { transform: scale(1.04); box-shadow: 0 0 90px rgba(47, 191, 0, 0.55); }
}

.conv-mode-status {
  font: var(--bh-h2);            /* hero-card-title size — prominent on the surface */
  color: var(--bh-white);
  letter-spacing: -0.01em;
  margin-top: var(--space-sm);
}

.conv-mode-transcript {
  max-width: 480px;
  font: var(--bh-body-lg);       /* readable body across the empty stage */
  color: rgba(255, 255, 255, 0.7);
  font-style: italic;
  line-height: 1.5;
}

.conv-mode-hint {
  max-width: 380px;
  padding: var(--space-sm) var(--space-md);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.14);
  font: var(--bh-body-sm);
  color: rgba(255, 255, 255, 0.78);
}

.conv-mode-controls {
  display: flex;
  gap: var(--space-2xs);
  justify-content: center;
  padding: var(--space-md);
  flex-shrink: 0;
}
/* Outline-on-dark — sibling spirit to bh-btn-outline-dark, but inverted
   colors so the buttons read on the premium dark surface. */
.conv-mode-control {
  background: transparent;
  color: var(--bh-white);
  border: 1.5px solid rgba(255, 255, 255, 0.22);
  padding: 12px 20px;
  font: var(--bh-body);
  font-weight: 700;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2xs);
  cursor: pointer;
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out, color 200ms ease-in-out;
}
.conv-mode-control:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.4);
}
.conv-mode-control--primary {
  /* Pulls --btn-primary so it matches every other primary CTA app-wide */
  background: var(--btn-primary);
  color: var(--bh-black);
  border-color: var(--btn-primary);
}
.conv-mode-control--primary:hover {
  background: var(--btn-primary-hover);
  border-color: var(--btn-primary-hover);
  box-shadow: var(--shadow-green);
}

/* The orb is a deliberate circle — exempt from the global sharp-corner rule. */
.phone-viewport .conv-mode-orb,
.phone-viewport .conv-mode-orb-core,
.phone-viewport .conv-mode-orb-pulse { border-radius: 50% !important; }

/* ── VoiceBot BeHuman reskin (CSS-only) ─────────────────────────────── */
.vb-screen { background: var(--bh-light-gray); }

.vb-screen .vb-header {
  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);
  box-shadow: var(--shadow-md);
  padding: var(--space-2xs) var(--space-sm);
}
.vb-screen .vb-header-title {
  font: var(--bh-h3);
  color: var(--bh-white);
  letter-spacing: -0.01em;
}
.vb-screen .vb-header-action {
  background: rgba(0,0,0,0.18);
  border: 1px solid rgba(0,0,0,0.18);
  color: var(--bh-white);
  border-radius: var(--radius-md);
  padding: 6px 10px;
  font: var(--bh-caption);
  font-weight: 600;
  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;
}
.vb-screen .vb-header-action:hover {
  background: rgba(0,0,0,0.28);
  border-color: rgba(0,0,0,0.28);
}
.vb-screen .vb-header-action.active {
  background: var(--bh-black);
  border-color: var(--bh-black);
  color: var(--bh-white);
}
.vb-screen .vb-header .back-icon { color: var(--bh-white); }

.vb-screen .vb-bubble {
  font: var(--bh-body-sm);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}
.vb-screen .vb-bubble.user {
  background: var(--td-green);
  color: var(--bh-black);
}
.vb-screen .vb-bubble.bot {
  background: var(--bh-white);
  color: var(--bh-black);
  border: 1px solid var(--bh-light-gray);
}

.vb-screen .vb-orb-area {
  background: var(--bh-white);
  border-top: 1px solid var(--bh-light-gray);
}
.vb-screen .vb-status.listening { color: var(--td-red); }
.vb-screen .vb-status.thinking  { color: var(--td-green); }
.vb-screen .vb-status.speaking  { color: var(--td-amber); }

/* ── BeHuman radius rules (May 2026) ───────────────────────────────────
   Updated guideline:
   - Rounded edges OK for: buttons, input fields, checkboxes, cards, tab items.
   - Sharp edges REQUIRED for: component surfaces, navigation items, dividers,
     holding shapes, image containers.
   See styles/Guidelines.md for the full rules. The bh-* primitive tokens
   handle the "rounded" categories automatically (radius-md/lg/xl). The rules
   below force "sharp" categories to 0 since many of them inherited rounded
   styling from legacy CSS or shared tokens. */

/* Component surfaces / heroes / holding shapes — never rounded */
.phone-viewport .bh-flow-hero,
.phone-viewport .bh-flow-hero.dark,
.phone-viewport .bh-flow-hero.tall,
.phone-viewport .bh-balance-hero,
.phone-viewport .bh-flow-body,
.phone-viewport .scroll-content,
.phone-viewport .home-scroll,
.phone-viewport .account-details-scroll,
.phone-viewport .account-details-content,
.phone-viewport .simple-header,
.phone-viewport .chat-header-outer,
.phone-viewport .vb-screen .vb-header,
.phone-viewport .profile-hero { border-radius: 0 !important; }

/* Navigation items — bottom nav, sidebar */
.phone-viewport .bottom-nav,
.phone-viewport .bottom-nav .nav-item,
.phone-viewport .sidebar-overlay,
.phone-viewport .sidebar-content,
.phone-viewport .sidebar-item,
.phone-viewport .sidebar-divider,
.phone-viewport .nav-list,
.phone-viewport .nav-item,
.phone-viewport .bh-home-topbar,
.phone-viewport .bh-home-banner-wrapper { border-radius: 0 !important; }

/* Image containers — promo banners, card images, photo wells */
.phone-viewport .home-promo-banner,
.phone-viewport .home-promo-img,
.phone-viewport .home-promo-overlay,
.phone-viewport .card-display-container,
.phone-viewport .aeroplan-card,
.phone-viewport .card-image,
.phone-viewport .card-chip { border-radius: 0 !important; }

/* Dividers and hairlines */
.phone-viewport .vertical-divider,
.phone-viewport .list-group-title { border-radius: 0 !important; }

/* Focal-point icons that intentionally stay circular (status ring, avatars,
   success checkmark — kit allows "items that don't fit" to be circles). */
.phone-viewport .status-icon-ring,
.phone-viewport .profile-avatar,
.phone-viewport .csb-avatar-pulse,
.phone-viewport .call-avatar,
.phone-viewport .call-avatar-container,
.phone-viewport .bh-success-icon { border-radius: 50% !important; }

/* Chat FAB drawer-tab: rounded on the LEFT only, flat right edge */
.phone-viewport .chat-fab,
.phone-viewport .chat-fab-pulse { border-radius: 28px 0 0 28px !important; }

/* App-icon squircle on the Services screen tiles — iOS app-icon convention */
.phone-viewport .services-icon-circle { border-radius: 14px !important; }

/* High-net-worth Investing screen — recolor green-themed legacy classes */
.port-screen .port-range-btn.active {
  background: var(--td-gold);
  color: var(--bh-black);
  border-color: var(--td-gold);
}
.port-screen .port-acct-card { border-top-width: 3px; }

/* ── Admin panel ──────────────────────────────────────────────────────────── */
/* Out-of-card descriptive text sits on the dark screen background → keep it
   light. Text INSIDE the cards is on a white .bh-form-card in every theme, so
   it must be a fixed dark colour (in dark mode --text-dark resolves to a light
   colour, which was illegible on the white card). */
.admin-screen .bh-muted { color: var(--text-light); }
.admin-screen .bh-row { color: #1c1c28; }
.admin-screen .bh-form-card,
.admin-screen .bh-form-card .bh-row { color: #1c1c28; }
.admin-screen .bh-form-card .bh-muted { color: #5a5f6a; }
.admin-screen .bh-pill-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px; border-radius: 999px;
  background: var(--bg-light-gray); color: var(--text-dark);
  border: 1px solid var(--border-color); cursor: pointer;
  font-size: 13px; font-weight: 600; white-space: nowrap;
  transition: filter .12s ease, opacity .12s ease;
}
.admin-screen .bh-pill-btn svg { font-size: 15px; }
.admin-screen .bh-pill-btn:hover:not(:disabled) { filter: brightness(0.96); }
.admin-screen .bh-pill-btn:disabled { opacity: 0.5; cursor: default; }
.admin-screen .bh-pill-btn.danger {
  background: transparent; color: var(--td-red); border-color: var(--td-red);
}

/* ── Change-password screen ─────────────────────────────────────────── */

.change-password-screen .bh-flow-body {
  padding: var(--space-md);
}

.change-password-screen .cp-subtitle {
  display: block;
  text-align: left;
  font: var(--bh-body-sm);
  color: var(--text-light);
  margin: 0 0 var(--space-md);
}

.change-password-screen label {
  display: block;
  text-align: left;
  font: var(--bh-body-sm);
  font-weight: 600;
  color: var(--text-dark);
  margin-top: var(--space-md);
  margin-bottom: var(--space-3xs);
}

/* Remove top margin from the first label so the form starts cleanly */
.change-password-screen form label:first-child {
  margin-top: 0;
}

.change-password-screen .bh-btn-primary,
.change-password-screen .bh-btn-secondary {
  width: 100%;
}

.change-password-screen .bh-btn-primary {
  margin-top: var(--space-md);
}

.change-password-screen .bh-btn-secondary {
  margin-top: var(--space-sm);
  color: var(--btn-secondary-outline);
  border-color: var(--btn-secondary-outline);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,iFAAiF;;;AAGjF;EACE;2EACyE;EACzE,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB,EAAE,8DAA8D;EACrF,kBAAkB;EAClB,gBAAgB;;EAEhB,wDAAwD;EACxD,wDAAwD,GAAG,YAAY;EACvE,uDAAuD,IAAI,YAAY;EACvE,wDAAwD,GAAG,YAAY;EACvE,oDAAoD,OAAO,YAAY;EACvE,uDAAuD,IAAI,YAAY;EACvE,uDAAuD,IAAI,YAAY;EACvE,uDAAuD,IAAI,YAAY;EACvE,oDAAoD,QAAQ,YAAY;AAC1E;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;AACA,mBAAmB,MAAM,EAAE;;AAE3B,oCAAoC;AACpC,kBAAkB,eAAe,EAAE,YAAY,EAAE;;AAEjD,mDAAmD;AACnD;EACE,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE;AAChF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kIAAkI;EAClI,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;mBAGiB;EACjB,sBAAsB;EACtB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,aAAa,sBAAsB,EAAE,gBAAgB,EAAE;EACvD;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,kFAAkF;AAClF;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,yEAAyE;AACzE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;EACzD,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kDAAkD;AACpD;AACA,kCAAkC,UAAU,EAAE;AAC9C,wCAAwC,kCAAkC,EAAE,kBAAkB,EAAE;;AAEhG;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA,kDAAkD;AAClD;;;;;;;EAOE,0DAA0D;AAC5D;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB,EAAE,oCAAoC;EAC1D,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;AACpD;AACA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mDAAmD;AACrD;;AAEA,WAAW,sCAAsC,EAAE;AACnD,YAAY,gCAAgC,EAAE;AAC9C,kBAAkB,+BAA+B,EAAE,gBAAgB,EAAE;;AAErE,oBAAoB;;AAEpB;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,aAAa,0BAA0B,EAAE,eAAe,EAAE;AAC1D,gBAAgB,SAAS,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAEtF;EACE,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;IACI,mBAAmB;IACnB,SAAO;IACP,gBAAgB;IAChB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,GAAG,WAAW;AAC1C;AACA,mCAAmC,aAAa,EAAE;;AAElD;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,4CAA4C;IAC5C,eAAe;IACf,uBAAuB;IACvB,yBAAyB;AAC7B;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;EACxD,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;EAC/E,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+FAA+F;AACjG;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;AACjC;;;AAGA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;AACA,yBAAyB,yBAAyB,EAAE;AACpD,oBAAoB,UAAU,EAAE,qCAAqC,EAAE,YAAY,EAAE;;;AAGrF,yCAAyC;;AAEzC;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;AACA,4BAA4B,iBAAiB,EAAE,oBAAoB,EAAE;;AAErE,mBAAmB,0BAA0B,EAAE,4CAA4C,EAAE;;AAE7F;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,4CAA4C;IAC5C,eAAe;AACnB;AACA,YAAY,YAAY,EAAE,SAAO,EAAE;AACnC,YAAY,gBAAgB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACpK,WAAW,yBAAyB,EAAE,2BAA2B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACtG,aAAa,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACjE,gBAAgB,yBAAyB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACzF,eAAe,yBAAyB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,uBAAuB,EAAE;AACzG,aAAa,wBAAwB,EAAE,yBAAyB,EAAE;;AAElE;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,uBAAuB;AAC3B;AACA,gBAAgB,iBAAiB,EAAE;AACnC,gBAAgB,2BAA2B,EAAE,yBAAyB,EAAE,eAAe,EAAE;;AAEzF,qBAAqB,aAAa,EAAE,yBAAyB,EAAE,yBAAyB,EAAE;AAC1F,uBAAuB,iBAAiB,EAAE;AAC1C,uBAAuB,cAAc,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,kBAAkB,CAAC;;;AAGzG,qCAAqC;;AAErC;EACE,sCAAsC,EAAE,iDAAiD;EACzF,kBAAkB,SAAS,2DAA2D;EACtF,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe,WAAW,2CAA2C;AACvE;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,8CAA8C,aAAa,EAAE;;AAE7D;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,yCAAyC;EACzC,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;EACxD,qBAAqB;EACrB,gDAAgD;AAClD;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA,8BAA8B,yBAAyB,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;AACA,gCAAgC,wBAAwB,EAAE;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;AACA,qBAAqB,sCAAsC,EAAE;AAC7D,iCAAiC,sCAAsC,EAAE;;AAEzE,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,OAAO,6CAA6C,EAAE;EACtD,OAAO,+CAA+C,EAAE;AAC1D;;AAEA,oCAAoC;;AAEpC;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,wCAAwC;EACxC,mBAAmB;EACnB,6EAA6E;EAC7E,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mDAAmD;AACrD;AACA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,kCAAkC,EAAE,kBAAkB,EAAE;;AAE7F;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;qEACqE;AACrE;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;yDACyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA,2BAA2B,aAAa,EAAE;;AAE1C,2CAA2C;;AAE3C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;EACzB,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,yCAAyC;EACzC,gBAAgB;AAClB;AACA,8BAA8B,+BAA+B,EAAE,WAAW,EAAE;AAC5E,+BAA+B,WAAW,EAAE,oCAAoC,EAAE;AAClF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,SAAS,EAAE,yEAAyE;EACpF,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,uCAAuC;EACvC,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA,yBAAyB,+BAA+B,EAAE,WAAW,EAAE;AACvE,0BAA0B,YAAY,EAAE,eAAe,EAAE;AACzD,yBAAyB,8BAA8B,EAAE,iCAAiC,EAAE,WAAW,EAAE;AACzG,yBAAyB,+BAA+B,EAAE,iCAAiC,EAAE,WAAW,EAAE;;AAE1G,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;EAClD,wCAAwC;EACxC,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,4BAA4B;AAC9B;AACA,oCAAoC,mBAAmB,EAAE;AACzD,+BAA+B,kCAAkC,EAAE;AACnE,gCAAgC,kCAAkC,EAAE;AACpE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,kBAAkB,SAAO,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kDAAkD,EAAE;AACxH,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,iCAAiC,EAAE,kBAAkB,EAAE;AAClG,iDAAiD,iCAAiC,EAAE;;AAEpF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,eAAe,gCAAgC,EAAE,wBAAwB,EAAE,4CAA4C,EAAE;AACzH,gBAAgB,yBAAyB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAC1F,mBAAmB,YAAY,EAAE,gCAAgC,EAAE,4CAA4C,EAAE;;AAEjH,6BAA6B;AAC7B,wBAAwB,2BAA2B,EAAE,kBAAkB,EAAE;AACzE;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,eAAe,wBAAwB,EAAE,kBAAkB,EAAE;AAC7D,oBAAoB,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,2BAA2B,EAAE,uBAAuB,EAAE,uBAAuB,EAAE;;AAE7I;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA,YAAY,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC9E,eAAe,gBAAgB,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACvF,yBAAyB,yBAAyB,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAChG,cAAc,sBAAsB,EAAE,gBAAgB,EAAE;AACxD,YAAY,aAAa,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;;AAE/J,2BAA2B;AAC3B,kBAAkB,gCAAgC,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AAC1J,yBAAyB,2BAA2B,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC5G,iBAAiB,0BAA0B,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC1E,oBAAoB,yBAAyB,EAAE,oBAAoB,EAAE;AACrE,oBAAoB,yBAAyB,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAE/E,mBAAmB,aAAa,EAAE,4CAA4C,EAAE;AAChF,eAAe,aAAa,EAAE,8BAA8B,EAAE,eAAe,EAAE,8CAA8C,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACrL,0BAA0B,mBAAmB,EAAE;AAC/C,oBAAoB,wBAAwB,EAAE;;AAE9C,mBAAmB,aAAa,EAAE,6BAA6B,EAAE,kBAAkB,EAAE;AACrF,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;AACxI,WAAW,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AACjO,2BAA2B,yBAAyB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAEnG,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,YAAY,aAAa,EAAE,8BAA8B,EAAE,iBAAiB,EAAE;AAC9E,aAAa,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACjF,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE,eAAe,mBAAmB,EAAE,yBAAyB,EAAE;;AAE/D;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA,iBAAiB,yBAAyB,EAAE,yBAAyB,EAAE;;AAEvE;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC,mBAAmB,oBAAoB,EAAE;;AAEzC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iBAAiB,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAElF,0CAA0C;;AAE1C;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,oCAAoC,EAAE,0BAA0B;EAChE,yBAAyB,EAAE,oBAAoB;EAC/C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;;AAEA,eAAe,yBAAyB,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACzG,cAAc,wBAAwB,EAAE,qGAAqG,EAAE,yBAAyB,EAAE;;AAE1K;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,aAAa,sBAAsB,EAAE,6BAA6B,EAAE,0BAA0B,EAAE;AAChG,aAAa,cAAc,EAAE,qBAAqB,EAAE,0BAA0B,EAAE,+BAA+B,EAAE;;AAEjH;EACE,KAAK,0CAA0C,EAAE;EACjD,MAAM,2CAA2C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC/G,mBAAmB,2BAA2B,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAE9G,uBAAuB,YAAY,EAAE,aAAa,EAAE,kBAAkB,EAAE;;AAExE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,WAAW,2BAA2B,EAAE;AACxC,WAAW,mBAAmB,EAAE;;AAEhC,mBAAmB,aAAa,EAAE,8BAA8B,EAAE,eAAe,EAAE,8CAA8C,EAAE,2BAA2B,EAAE,uBAAuB,EAAE;AACzL,eAAe,cAAc,EAAE;;AAE/B,mBAAmB,aAAa,EAAE;AAClC,sBAAsB,yBAAyB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC/F,sBAAsB,kBAAkB,EAAE,yBAAyB,EAAE,yBAAyB,EAAE;AAChG,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB,iBAAiB,EAAE,aAAa,EAAE,sCAAsC,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3I,2BAA2B,yBAAyB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAEpG,oCAAoC;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,YAAY,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAE3D,2CAA2C;AAC3C,kBAAkB,iBAAiB,EAAE,8BAA8B,EAAE;AACrE;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB;EAClE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kCAAkC;AACpC;;AAEA;EACE,KAAK,yCAAyC,EAAE;EAChD,MAAM,0CAA0C,EAAE;EAClD,OAAO,uCAAuC,EAAE;AAClD;;AAEA,iBAAiB;AACjB,kBAAkB,0BAA0B,EAAE,wCAAwC,EAAE;;AAExF,oBAAoB;AACpB,gBAAgB,0BAA0B,EAAE,qCAAqC,EAAE;AACnF,mBAAmB,WAAW,EAAE,YAAY,EAAE,gCAAgC,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;;AAEjK,aAAa,2BAA2B,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACpF,uBAAuB,uBAAuB,EAAE;AAChD,gBAAgB,yBAAyB,EAAE,yBAAyB,EAAE;AACtE,aAAa,wBAAwB,EAAE;;AAEvC,8BAA8B;AAC9B;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,kBAAkB,EAAE,6BAA6B;AACnD;AACA,UAAU,kBAAkB,EAAE,qBAAqB,EAAE,WAAW,EAAE,YAAY,EAAE;AAChF,gBAAgB,UAAU,EAAE,QAAQ,EAAE,SAAS,EAAE;AACjD;EACE,kBAAkB,EAAE,eAAe,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACzE,sBAAsB,EAAE,eAAe,EAAE,mBAAmB;AAC9D;AACA;EACE,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,SAAS,EAAE,WAAW;EAClF,uBAAuB,EAAE,eAAe,EAAE,kBAAkB;AAC9D;AACA,0BAA0B,yBAAyB,EAAE;AACrD,iCAAiC,2BAA2B,EAAE;;AAE9D,qCAAqC;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,QAAQ;EACR,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,2CAA2C;;AAE3C;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,mBAAmB,yBAAyB,EAAE;AAC9C,qBAAqB,uBAAuB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjF,cAAc,yBAAyB,EAAE,sBAAsB,EAAE;;AAEjE,4BAA4B;AAC5B;EACE,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,sCAAsC;;AAEtC;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B,EAAE,qCAAqC;EACrE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB,iDAAiD;;AAEjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,8BAA8B,yBAAyB,EAAE;;AAEzD;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA,wBAAwB,kBAAkB,EAAE;;AAE5C,sFAAsF;AACtF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mDAAmD;AACrD;AACA;EACE,WAAW,UAAU,IAAI,mBAAmB,IAAI;EAChD,WAAW,YAAY,EAAE,qBAAqB,EAAE;AAClD;;AAEA;;uEAEuE;AACvE;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ,0CAA0C,6BAA6B;EAC/E,WAAW,uCAAuC,8BAA8B;EAChF,YAAY;EACZ,0EAA0E;EAC1E,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,0CAA0C,QAAQ,8BAA8B;EAChF,gBAAgB;EAChB;;;;mBAIiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,WAAW,uCAAuC,iCAAiC;EACnF,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,mBAAmB,sBAAsB,EAAE;;AAE3C;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU,+BAA+B,8BAA8B;EACvE,iFAAiF;AACnF;AACA,iCAAiC,UAAU,EAAE;;AAE7C;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,OAAO,mBAAmB,IAAI,aAAa,EAAE;EAC7C,OAAO,qBAAqB,EAAE,UAAU,KAAK;EAC7C,OAAO,qBAAqB,EAAE,UAAU,KAAK;AAC/C;;AAEA;;;;0CAI0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB,WAAW,gDAAgD;EAC9E,2BAA2B,GAAG,iCAAiC;EAC/D,kBAAkB;EAClB,wCAAwC,GAAG,4BAA4B;AACzE;AACA,uDAAuD;AACvD;EACE,aAAa;AACf;AACA,0EAA0E;AAC1E;EACE,0EAA0E;AAC5E;AACA,iEAAiE;AACjE;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;8DAC8D;AAC9D;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,2CAA2C;EAC3C,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,oFAAoF;AACpF;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;AACA,8BAA8B,kCAAkC,EAAE;AAClE,8BAA8B,kCAAkC,EAAE;;AAElE;;;sEAGsE;AACtE,2BAA2B,gCAAgC,EAAE;AAC7D;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA,sBAAsB,yBAAyB,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACxH,sBAAsB,yBAAyB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACvH,sBAAsB,yBAAyB,EAAE,6BAA6B,EAAE,kBAAkB,EAAE;AACpG,sBAAsB,yBAAyB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAEhG,mBAAmB,oBAAoB,EAAE;;AAEzC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA,kCAAkC,mBAAmB,EAAE;AACvD,yBAAyB,yBAAyB,EAAE,uBAAuB,EAAE;AAC7E,yBAAyB,yBAAyB,EAAE,gBAAgB,EAAE;;AAEtE;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,QAAQ;AACV;AACA,mCAAmC,mBAAmB,EAAE;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kFAAkF;EAClF,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AACA,8BAA8B,aAAa,EAAE;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA,wBAAwB,SAAO,EAAE,YAAY,EAAE;AAC/C,yBAAyB,yBAAyB,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACnF,yBAAyB,yBAAyB,EAAE,4BAA4B,EAAE,eAAe,EAAE;;AAEnG;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA,yBAAyB,sBAAsB,EAAE,cAAc,EAAE,aAAa,EAAE;AAChF,0BAA0B,yBAAyB,EAAE,uBAAuB,EAAE;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA,0BAA0B,yBAAyB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAElK;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,WAAW;AACb;;AAEA,oEAAoE;AACpE,mBAAmB,WAAW,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvH,iBAAiB,YAAY,EAAE,2BAA2B,EAAE,gCAAgC,EAAE;;AAE9F,oCAAoC;;AAEpC,cAAc,uBAAuB,EAAE,SAAS,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAEzF;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,SAAO,EAAE;AACjG,kBAAkB,yBAAyB,EAAE,wBAAwB,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,cAAc,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACxE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC/E,oBAAoB,yBAAyB,EAAE,yBAAyB,EAAE,SAAO,EAAE;AACnF,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAE1F;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,cAAc;AAChB;AACA,kBAAkB,yBAAyB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC3I,kBAAkB,2BAA2B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1F,kBAAkB,yBAAyB,EAAE,yBAAyB,EAAE;;AAExE,iFAAiF;AACjF,oCAAoC;AACpC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;;;;;yCAKyC;AACzC;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA,0BAA0B,WAAW,EAAE;;AAEvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,4FAA4F;AAC9F;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;;;qBAGqB;AACrB;EACE,kBAAkB;EAClB,SAAS,MAAM,mEAAmE;EAClF,UAAU,KAAK,+CAA+C;EAC9D,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,kDAAkD;AACpD;AACA,uCAAuC,UAAU,EAAE;AACnD,6CAA6C,uBAAuB,EAAE;AACtE,6CAA6C,iCAAiC,EAAE,kBAAkB,EAAE;AACpG,mDAAmD,iCAAiC,EAAE;;AAEtF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,0BAA0B,eAAe,EAAE;AAC3C,qCAAqC,SAAS,EAAE;AAChD,qDAAqD,aAAa,EAAE,kBAAkB,EAAE;AACxF,2BAA2B,kBAAkB,EAAE;;AAE/C,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA,mBAAmB,eAAe,EAAE,yBAAyB,EAAE,YAAY,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC/H,YAAY,eAAe,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC7F,YAAY,SAAS,EAAE,yBAAyB,EAAE;AAClD,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;;AAEhC;EACE,aAAa;EACb,0BAA0B;EAC1B,4CAA4C;EAC5C,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,SAAO;EACP,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;AACf;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,cAAc,eAAe,EAAE;AAC/B;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,cAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC7E,gBAAgB,WAAW,EAAE,yBAAyB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACjG,iBAAiB,SAAO,EAAE,WAAW,EAAE,gCAAgC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/G,mBAAmB,YAAY,EAAE,kBAAkB,EAAE,2BAA2B,EAAE;AAClF,cAAc,WAAW,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACpH,cAAc,WAAW,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,cAAc,EAAE;;;AAGpH,iCAAiC;AACjC;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA,kCAAkC;AAClC;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;AACA;;;;EAIE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,gCAAgC;AAClC;;;AAGA,iCAAiC;AACjC,cAAc,mBAAmB,EAAE;;AAEnC,cAAc,8BAA8B,EAAE,gCAAgC,EAAE;AAChF;4BAC4B,yBAAyB,EAAE;;AAEvD,eAAe,mBAAmB,EAAE;;AAEpC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE5E,cAAc,yBAAyB,EAAE,cAAc,EAAE,sBAAsB,EAAE;AACjF,iBAAiB,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE7E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;AACb;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA,kBAAkB,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AAC/F,gBAAgB,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE9F;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA,mBAAmB,2BAA2B,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACtG;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA,oBAAoB,yBAAyB,EAAE,kBAAkB,EAAE;AACnE;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA,oBAAoB,yBAAyB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAClF,2BAA2B,cAAc,EAAE;;AAE3C;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;AAChB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA,sBAAsB,2BAA2B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC9F,sBAAsB,yBAAyB,EAAE,yBAAyB,EAAE,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAChJ,wBAAwB,0BAA0B,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACnH,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;;AAE5F;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA,qBAAqB,yBAAyB,EAAE,gBAAgB,EAAE;AAClE,0BAA0B,yBAAyB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAClG,oBAAoB,yBAAyB,EAAE,yBAAyB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7G;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA,uBAAuB,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;AACnF,uBAAuB,yBAAyB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;;AAEhG,gFAAgF;AAChF;EACE,OAAO,mBAAmB,KAAK,YAAY,EAAE;EAC7C,OAAO,sBAAsB,EAAE,aAAa,EAAE;EAC9C,OAAO,mBAAmB,KAAK,UAAU,EAAE;AAC7C;AACA;EACE,OAAO,sBAAsB,EAAE,YAAY,EAAE;EAC7C,OAAO,qBAAqB,GAAG,UAAU,EAAE;AAC7C;AACA;EACE,WAAW,WAAW,GAAG;EACzB,YAAY,YAAY,EAAE;AAC5B;AACA;EACE,gBAAgB,mBAAmB,EAAE,YAAY,EAAE;EACnD,gBAAgB,mBAAmB,EAAE,UAAU,IAAI;AACrD;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,2BAA2B,WAAW,EAAE,gBAAgB,EAAE;;AAE1D;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,kDAAkD;AACpD;AACA,iCAAiC,UAAU,EAAE;AAC7C,uCAAuC,uBAAuB,EAAE;AAChE,uCAAuC,iCAAiC,EAAE,kBAAkB,EAAE;AAC9F,6CAA6C,iCAAiC,EAAE;AAChF;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU,mBAAmB,EAAE;EAC/B,WAAW,qBAAqB,EAAE,uBAAuB,EAAE;AAC7D;AACA,qBAAqB,8CAA8C,EAAE;AACrE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA,uBAAuB,kCAAkC,EAAE,WAAW,EAAE;AACxE,uBAAuB,kCAAkC,EAAE,WAAW,EAAE;;AAExE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,oBAAoB,2BAA2B,EAAE,cAAc,EAAE;;AAEjE,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;AAC1D;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,uBAAuB,sBAAsB,EAAE,gBAAgB,EAAE;AACjE,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;;AAEzD,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,yCAAyC;EACzC,oBAAoB;AACtB;AACA,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6CAA6C;EAC7C,kBAAkB;EAClB,UAAU;EACV,uCAAuC;AACzC;AACA,qBAAqB,sBAAsB,EAAE;AAC7C;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,UAAU;AACZ;AACA,qBAAqB,4BAA4B,EAAE;AACnD,wBAAwB,2BAA2B,EAAE,WAAW,EAAE;AAClE,0BAA0B,2BAA2B,EAAE,WAAW,EAAE;AACpE,wBAAwB,mBAAmB,EAAE,WAAW,EAAE,0CAA0C,EAAE;AACtG,wBAAwB,0BAA0B,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAChG,wBAAwB,mBAAmB,EAAE,WAAW,EAAE;;AAE1D,kBAAkB;AAClB,WAAW,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACzD,mBAAmB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACjF;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,8BAA8B;EAC9B,gDAAgD;AAClD;AACA,uBAAuB,mBAAmB,KAAK;AAC/C,uBAAuB,qBAAqB,GAAG;AAC/C,uBAAuB,qBAAqB,GAAG;;AAE/C,sBAAsB;AACtB,WAAW,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,YAAY,EAAE;AACvE;EACE,UAAU,EAAE,kBAAkB;EAC9B,mBAAmB;EACnB,4CAA4C;AAC9C;AACA,uBAAuB,mBAAmB,KAAK;AAC/C,uBAAuB,qBAAqB,GAAG;AAC/C,uBAAuB,qBAAqB,GAAG;AAC/C,uBAAuB,qBAAqB,GAAG;AAC/C,uBAAuB,mBAAmB,KAAK;;AAE/C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;iEAEiE;;AAEjE,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;AACnC;AACA,iCAAiC,gBAAgB,EAAE;AACnD;4CAC4C;AAC5C,4BAA4B,kCAAkC,EAAE;AAChE,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1F,oBAAoB,yBAAyB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AAC1F,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AACpF,uBAAuB,yBAAyB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACjH;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,qCAAqC,EAAE,cAAc;EACrD,sBAAsB,EAAE,mCAAmC;AAC7D;AACA;EACE,6BAA6B;EAC7B,2EAA2E;AAC7E;;AAEA,oEAAoE;AACpE,aAAa,oBAAoB,EAAE,yCAAyC,EAAE,iBAAiB,EAAE;AACjG,2BAA2B,gBAAgB,EAAE;AAC7C;EACE,aAAa,EAAE,mBAAmB;EAClC,yBAAyB,EAAE,gBAAgB,EAAE,yBAAyB;EACtE,kBAAkB,EAAE,yBAAyB,EAAE,sBAAsB;AACvE;AACA,aAAa,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEzE,iBAAiB;AACjB;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;AACA,mCAAmC,6BAA6B,EAAE;AAClE,4BAA4B,qBAAqB,EAAE;AACnD,uBAAuB,yBAAyB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC/F;EACE,SAAO,EAAE,gBAAgB,EAAE,YAAY,EAAE,aAAa;EACtD,0BAA0B,EAAE,gBAAgB,EAAE,uBAAuB;EACrE,oBAAoB,EAAE,YAAY;AACpC;AACA,iCAAiC,wBAAwB,EAAE;AAC3D,qBAAqB,yBAAyB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;;AAEvI,iEAAiE;AACjE,qBAAqB,aAAa,EAAE,QAAQ,EAAE,uBAAuB,EAAE,eAAe,EAAE;;AAExF,aAAa;AACb;EACE,WAAW,EAAE,sBAAsB;EACnC,gCAAgC,EAAE,qCAAqC;EACvE,kBAAkB,EAAE,kBAAkB,EAAE,yBAAyB;EACjE,uBAAuB,EAAE,oBAAoB,EAAE,aAAa,EAAE,YAAY;EAC1E,eAAe;AACjB;AACA,sBAAsB,6BAA6B,EAAE;AACrD,6BAA6B,wBAAwB,EAAE;;AAEvD,4BAA4B;AAC5B;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,wBAAwB,EAAE,oBAAoB;EAC9C,aAAa,EAAE,mBAAmB,EAAE,YAAY;EAChD,2BAA2B,EAAE,WAAW;EACxC,2BAA2B,EAAE,gBAAgB,EAAE,eAAe,EAAE,oBAAoB;EACpF,yBAAyB;AAC3B;AACA,yBAAyB,aAAa,EAAE;AACxC;EACE,cAAc,EAAE,wBAAwB,EAAE,mBAAmB;EAC7D,aAAa,EAAE,mBAAmB;EAClC,qCAAqC,EAAE,uBAAuB;EAC9D,yBAAyB,EAAE,2BAA2B,EAAE,gBAAgB;EACxE,eAAe,EAAE,oBAAoB,EAAE,8BAA8B;AACvE;AACA,uBAAuB,gCAAgC,EAAE;;AAEzD,kBAAkB;AAClB;EACE,0BAA0B,EAAE,gBAAgB,EAAE,kBAAkB;EAChE,uBAAuB,EAAE,oBAAoB;AAC/C;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,8BAA8B;EACtE,kBAAkB,EAAE,yCAAyC;AAC/D;AACA,gCAAgC,gBAAgB,EAAE;AAClD,oBAAoB,yBAAyB,EAAE,wBAAwB,EAAE,cAAc,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACxH,oBAAoB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/H;EACE,mBAAmB,EAAE,kBAAkB;EACvC,gCAAgC,EAAE,kBAAkB;EACpD,sCAAsC;EACtC,yBAAyB,EAAE,yBAAyB,EAAE,gBAAgB;AACxE;;AAEA,kBAAkB;AAClB;EACE,SAAO,EAAE,aAAa,EAAE,sBAAsB;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,kBAAkB,EAAE,kBAAkB;AACxC;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,gCAAgC;EAChC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB;AACrB;AACA,qBAAqB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC/G,sBAAsB,0BAA0B,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC5F,mBAAmB,2BAA2B,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAC5F;EACE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB;EACxD,gCAAgC,EAAE,qCAAqC;EACvE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA,oCAAoC;;AAEpC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,0BAA0B,EAAE,4CAA4C;EACxE,iBAAiB,EAAE,cAAc;AACnC;AACA;EACE,SAAO,EAAE,gCAAgC,EAAE,qCAAqC;EAChF,kBAAkB,EAAE,iBAAiB,EAAE,yBAAyB;EAChE,uBAAuB,EAAE,oBAAoB,EAAE,aAAa;AAC9D;AACA,gCAAgC,wBAAwB,EAAE;AAC1D,yBAAyB,6BAA6B,EAAE;;AAExD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,0BAA0B;EAC9C,4CAA4C;EAC5C,eAAe,EAAE,2BAA2B;AAC9C;AACA,sBAAsB,gCAAgC,EAAE;AACxD,oBAAoB,yBAAyB,EAAE,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAChG,qBAAqB,SAAO,EAAE,2BAA2B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAEtG;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,0BAA0B,EAAE,4CAA4C;EACxE,mBAAmB,EAAE,mBAAmB;EACxC,aAAa,EAAE,qCAAqC;AACtD;AACA,iBAAiB,0BAA0B,EAAE,cAAc,EAAE;AAC7D,wBAAwB,2BAA2B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAChG,wBAAwB,yBAAyB,EAAE,wBAAwB,EAAE,eAAe,EAAE;AAC9F;EACE,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB;EACxD,gCAAgC,EAAE,qCAAqC;EACvE,yBAAyB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE,oBAAoB;AAC5G;;AAEA;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,kBAAkB;AACpB;AACA,iBAAiB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACvF,iBAAiB,yBAAyB,EAAE,yBAAyB,EAAE;;AAEvE,gCAAgC;AAChC,kCAAkC,2BAA2B,EAAE;;AAE/D;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,+BAA+B,aAAa,EAAE,eAAe,EAAE;;AAE/D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,kEAAkE,sBAAsB,EAAE;;AAE1F;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,qCAAqC,mBAAmB,EAAE;AAC1D,gCAAgC,gCAAgC,EAAE;;AAElE,0BAA0B,SAAO,EAAE;AACnC,2BAA2B,2BAA2B,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACnG,2BAA2B,yBAAyB,EAAE,yBAAyB,EAAE,eAAe,EAAE;;AAElG;;iEAEiE;AACjE;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gDAAgD;AAClD;AACA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA,iCAAiC,qBAAqB,EAAE;AACxD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;iEAEiE;AACjE;EACE,kFAAkF;EAClF,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AACA,wCAAwC,gBAAgB,EAAE;AAC1D;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;iEAEiE;AACjE;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,qCAAqC;EACrC,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kFAAkF;EAClF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;AACX;AACA,4BAA4B,gBAAgB,EAAE;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA,qCAAqC,gBAAgB,EAAE;AACvD,gCAAgC,cAAc,EAAE;AAChD,+BAA+B,gCAAgC,EAAE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;;iEAEiE;;AAEjE,sBAAsB;AACtB;EACE,wGAAwG;EACxG,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA,+BAA+B,kCAAkC,EAAE,cAAc,EAAE;AACnF,+BAA+B,gCAAgC,IAAI,cAAc,EAAE;AACnF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;AACA,uCAAuC,aAAa,EAAE;AACtD;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;AACX;AACA,gCAAgC,gBAAgB,EAAE;AAClD,4BAA4B,SAAO,EAAE,YAAY,EAAE;AACnD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,+BAA+B,cAAc,EAAE,gCAAgC,EAAE;AACjF,+BAA+B,cAAc,EAAE,kCAAkC,EAAE;;AAEnF,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;;iEAEiE;;AAEjE,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;AACA,gBAAgB,SAAO,EAAE,YAAY,EAAE;AACvC;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,0BAA0B,cAAc,EAAE,gCAAgC,EAAE;AAC5E,0BAA0B,cAAc,EAAE,kCAAkC,EAAE;;AAE9E,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B,gBAAgB,gBAAgB,EAAE,mBAAmB,EAAE;AACvD;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA,gBAAgB,yBAAyB,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACzH,gBAAgB,yBAAyB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAEtF,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;AACA,oBAAoB,+BAA+B,EAAE;;AAErD;;wEAEwE;AACxE;;EAEE,2DAA2D;EAC3D,aAAa,gBAAgB,EAAE,cAAc,EAAE;;EAE/C,8DAA8D;EAC9D;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,sBAAsB;EACxB;EACA;IACE,qDAAqD;EACvD;;EAEA,0CAA0C;EAC1C,mEAAmE,wBAAwB,EAAE;;EAE7F,oEAAoE;EACpE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,kCAAkC;IAClC,0BAA0B;IAC1B,kCAAkC;IAClC,wCAAwC;IACxC,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB,OAAO,qDAAqD;IAC9E,yBAAiB;YAAjB,iBAAiB;EACnB;EACA,4BAA4B,+BAA+B,EAAE,gBAAgB,EAAE;EAC/E;4EAC0E;EAC1E;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,YAAY;EACd;;EAEA,kBAAkB,eAAe,EAAE;;EAEnC,+CAA+C;EAC/C,UAAU,oBAAoB,EAAE;;EAEhC,kBAAkB;EAClB,iBAAiB,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE;EAChE,iBAAiB,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE;;EAEvE,qBAAqB;EACrB,cAAc,YAAY,EAAE;;EAE5B,6BAA6B;EAC7B,qBAAqB,kBAAkB,EAAE;EACzC,eAAe,2BAA2B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;EACzG,eAAe,yBAAyB,EAAE;EAC1C,eAAe,2BAA2B,EAAE;EAC5C,oBAAoB,yBAAyB,EAAE,sBAAsB,EAAE;EACvE,qBAAqB,kBAAkB,EAAE;;EAEzC,sCAAsC;EACtC,sBAAsB,qCAAqC,EAAE,aAAa,EAAE,iBAAiB,EAAE;EAC/F,sBAAsB,WAAW,EAAE;EACnC,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;EACxE,2BAA2B,yBAAyB,EAAE,eAAe,EAAE;EACvE,0BAA0B,yBAAyB,EAAE,sBAAsB,EAAE;EAC7E,2BAA2B,2BAA2B,EAAE;EACxD,2BAA2B,yBAAyB,EAAE;;EAEtD,4BAA4B;EAC5B,oBAAoB,kBAAkB,EAAE;EACxC,eAAe,2BAA2B,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;EACzG,eAAe,2BAA2B,EAAE;;EAE5C,qCAAqC;EACrC,oBAAoB,0BAA0B,EAAE;EAChD,oBAAoB,yBAAyB,EAAE;EAC/C,uBAAuB,yBAAyB,EAAE,kBAAkB,EAAE;;EAEtE,0CAA0C;EAC1C,YAAY,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE;EAClE,YAAY,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE;;EAElE,mBAAmB;EACnB,YAAY,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,WAAW,EAAE;;EAElE,iDAAiD;EACjD,0BAA0B,0BAA0B,EAAE;;EAEtD,oBAAoB;EACpB,mBAAmB,0BAA0B,EAAE;EAC/C,uBAAuB,yBAAyB,EAAE;EAClD,sBAAsB,yBAAyB,EAAE,mBAAmB,EAAE;EACtE,sBAAsB,yBAAyB,EAAE;;EAEjD,8BAA8B;EAC9B,kBAAkB,yBAAyB,EAAE;EAC7C,kBAAkB,yBAAyB,EAAE;;EAE7C,wBAAwB;EACxB,gBAAgB,2BAA2B,EAAE;EAC7C,qBAAqB,2BAA2B,EAAE;;EAElD,yBAAyB;EACzB,sBAAsB,yBAAyB,EAAE;EACjD,sBAAsB,yBAAyB,EAAE;EACjD,sBAAsB,yBAAyB,EAAE;EACjD,0BAA0B,yBAAyB,EAAE;EACrD,0BAA0B,yBAAyB,EAAE;EACrD,0BAA0B,yBAAyB,EAAE;EACrD,0BAA0B,yBAAyB,EAAE;EACrD,0BAA0B,yBAAyB,EAAE;;EAErD,wCAAwC;EACxC,6EAA6E;EAC7E;IACE,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA,mCAAmC;EACnC,cAAc,wBAAwB,EAAE,gBAAgB,EAAE;;EAE1D,wBAAwB;EACxB,sEAAsE;EACtE,wBAAwB,mBAAmB,EAAE,yBAAyB,EAAE;;EAExE,uBAAuB;EACvB,2EAA2E;EAC3E,8BAA8B,gBAAgB,EAAE;;EAEhD,yBAAyB;EACzB,iFAAiF;EACjF,uBAAuB,mBAAmB,EAAE;AAC9C;;AAEA;;sBAEsB;AACtB;EACE,kFAAkF;EAClF,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,sBAAsB;EACtB,+BAA+B;EAC/B,wEAAwE;AAC1E;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;AACA,iCAAiC,6BAA6B,EAAE;AAChE,iCAAiC,sBAAsB,EAAE,gBAAgB,EAAE;;AAE3E,0DAA0D;AAC1D;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,iGAAiG;AACnG;AACA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE;;uEAEqE;EACrE,gCAAgC;EAChC,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;EACE;gEAC8D;EAC9D,2BAA2B;EAC3B,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;AAC3B;AACA,gCAAgC,2BAA2B,EAAE,sBAAsB,EAAE;AACrF,6CAA6C,qBAAqB,EAAE;AACpE;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,4BAA4B;EAC5B,sEAAsE;AACxE;AACA,kCAAkC,gCAAgC,EAAE,+BAA+B,EAAE;;AAErG,sDAAsD;AACtD;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,+BAA+B,IAAI,sCAAsC;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iEAAiE;EACjE,cAAc;AAChB;AACA,iCAAiC,iCAAiC,EAAE;AACpE;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;;;2DAG2D;AAC3D,2BAA2B,kBAAkB,EAAE;AAC/C;EACE,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB;4EAC0E;EAC1E,yDAAyD;AAC3D;AACA;EACE,OAAO,6CAA6C,EAAE;EACtD,OAAO,2CAA2C,KAAK;EACvD,OAAO,0CAA0C,KAAK;AACxD;AACA;EACE;kEACgE;EAChE,OAAO,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,iBAAiB,EAAE;EACpE,OAAO,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,iBAAiB,EAAE;AACtE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,4CAA4C;EAC5C,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;EACjC,iCAAiC;AACnC;AACA,oCAAoC,oCAAoC,EAAE;AAC1E;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,yDAAyD;AAC3D;AACA;EACE,WAAW,aAAa,EAAE,sBAAsB,EAAE;EAClD,WAAW,UAAU,KAAK,sBAAsB,EAAE;AACpD;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;AACA,mCAAmC,gBAAgB,EAAE;AACrD,mCAAmC,iBAAiB,EAAE;;AAEtD;;;;;iEAKiE;AACjE;EACE,kCAAkC;EAClC,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;kEAEkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM,mBAAmB,2CAA2C;EACpE,eAAe;EACf,iBAAiB,QAAQ,oDAAoD;AAC/E;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iEAAiE;AACnE;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA,oCAAoC,sBAAsB,EAAE;AAC5D,uCAAuC,oBAAoB,EAAE;AAC7D,oCAAoC,sBAAsB,EAAE;;AAE5D;;;;;8DAK8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR;;oFAEkF;EAClF,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;qEACqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,wDAAwD;EACxD,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wEAAwE;AAC1E;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,wBAAwB,MAAM,sCAAsC;EACpE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB,UAAU,8CAA8C;EAC7E,aAAa;AACf;AACA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,oHAAoH;EACpH,+EAA+E;EAC/E,mGAAmG;AACrG;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,uEAAuE;AACvE;EACE,oDAAoD;EACpD,sGAAsG;EACtG,8CAA8C;EAC9C,sBAAsB;AACxB;AACA;EACE,wDAAwD;EACxD,wGAAwG;EACxG,+CAA+C;AACjD;AACA;EACE,iDAAiD;AACnD;AACA;EACE,4DAA4D;EAC5D,yGAAyG;EACzG,uCAAuC;AACzC;AACA;EACE,wGAAwG;EACxG,8CAA8C;AAChD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,WAAW,sBAAsB,EAAE;AACrC;AACA;EACE,OAAO,aAAa,EAAE,sBAAsB,EAAE;EAC9C,OAAO,UAAU,KAAK,sBAAsB,EAAE;EAC9C,OAAO,UAAU,KAAK,sBAAsB,EAAE;AAChD;AACA;EACE,OAAO,qCAAqC,EAAE;EAC9C,OAAO,qCAAqC,EAAE;EAC9C,OAAO,qCAAqC,EAAE;AAChD;AACA;EACE,WAAW,mBAAmB,KAAK,2CAA2C,EAAE;EAChF,WAAW,sBAAsB,EAAE,2CAA2C,EAAE;AAClF;;AAEA;EACE,kBAAkB,aAAa,oDAAoD;EACnF,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB,QAAQ,yCAAyC;EACxE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;EACvB,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;AACA;4DAC4D;AAC5D;EACE,uBAAuB;EACvB,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iGAAiG;AACnG;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,uEAAuE;EACvE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,+EAA+E;AAC/E;;uCAEuC,6BAA6B,EAAE;;AAEtE,0EAA0E;AAC1E,aAAa,gCAAgC,EAAE;;AAE/C;EACE,kFAAkF;EAClF,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,wEAAwE;AAC1E;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;AACA,mCAAmC,sBAAsB,EAAE;;AAE3D;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,kCAAkC,oBAAoB,EAAE;AACxD,kCAAkC,sBAAsB,EAAE;AAC1D,kCAAkC,sBAAsB,EAAE;;AAE1D;;;;;;;;8CAQ8C;;AAE9C,iEAAiE;AACjE;;;;;;;;;;;;gCAYgC,2BAA2B,EAAE;;AAE7D,2CAA2C;AAC3C;;;;;;;;;0CAS0C,2BAA2B,EAAE;;AAEvE,+DAA+D;AAC/D;;;;;;6BAM6B,2BAA2B,EAAE;;AAE1D,2BAA2B;AAC3B;oCACoC,2BAA2B,EAAE;;AAEjE;0EAC0E;AAC1E;;;;;mCAKmC,6BAA6B,EAAE;;AAElE,mEAAmE;AACnE;kCACkC,uCAAuC,EAAE;;AAE3E,6EAA6E;AAC7E,wCAAwC,8BAA8B,EAAE;;AAExE,0EAA0E;AAC1E;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA,+BAA+B,qBAAqB,EAAE;;AAEtD,gFAAgF;AAChF;;;oDAGoD;AACpD,0BAA0B,wBAAwB,EAAE;AACpD,wBAAwB,cAAc,EAAE;AACxC;sCACsC,cAAc,EAAE;AACtD,wCAAwC,cAAc,EAAE;AACxD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB,EAAE,oBAAoB;EACvC,gCAAgC,EAAE,uBAAuB;EACzD,qCAAqC,EAAE,eAAe;EACtD,eAAe,EAAE,gBAAgB,EAAE,mBAAmB;EACtD,+CAA+C;AACjD;AACA,iCAAiC,eAAe,EAAE;AAClD,kDAAkD,wBAAwB,EAAE;AAC5E,sCAAsC,YAAY,EAAE,eAAe,EAAE;AACrE;EACE,uBAAuB,EAAE,oBAAoB,EAAE,2BAA2B;AAC5E;;AAEA,0EAA0E;;AAE1E;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,sEAAsE;AACtE;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C","sourcesContent":[".App {\n  text-align: center;\n}\n\n/* ── Mobile overrides moved to bottom of file (must come after base styles) ── */\n\n\n:root {\n  /* Brand greens (--td-green, --td-dark-green, --td-accent) are now defined\n     in styles/theme.css using BeHuman values. Don't redeclare them here. */\n  --td-positive-green: #2ea854;\n  --bg-light-gray: #f2f4f5;\n  --border-color: #e6e6e6;\n  --text-dark: #222222;\n  --text-medium: #666666;\n  --text-light: #6b6b6b; /* muted text — kept ≥4.5:1 (WCAG AA) on white/gray surfaces */\n  --bg-screen: white;\n  --bg-card: white;\n\n  /* ── Fluid type scale (clamp: min, preferred, max) ── */\n  --font-2xs:  clamp(0.5rem,   0.45rem + 0.2vw,  0.625rem);  /*  8-10px */\n  --font-xs:   clamp(0.625rem, 0.55rem + 0.25vw, 0.75rem);   /* 10-12px */\n  --font-sm:   clamp(0.75rem,  0.7rem  + 0.2vw,  0.875rem);  /* 12-14px */\n  --font-base: clamp(0.875rem, 0.8rem  + 0.25vw, 1rem);      /* 14-16px */\n  --font-lg:   clamp(1rem,     0.9rem  + 0.35vw, 1.25rem);   /* 16-20px */\n  --font-xl:   clamp(1.25rem,  1.1rem  + 0.5vw,  1.75rem);   /* 20-28px */\n  --font-2xl:  clamp(1.5rem,   1.2rem  + 0.8vw,  2.25rem);   /* 24-36px */\n  --font-3xl:  clamp(2rem,     1.5rem  + 1.2vw,  3rem);       /* 32-48px */\n}\n\n/* ── Skip navigation link (a11y) ── */\n.skip-link {\n  position: absolute;\n  top: -100%;\n  left: 0;\n  z-index: 9999;\n  padding: 0.75rem 1rem;\n  background: var(--td-green);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n}\n.skip-link:focus { top: 0; }\n\n/* ── Responsive media defaults ── */\nimg, video, svg { max-width: 100%; height: auto; }\n\n/* ── Global touch-target minimum (WCAG 2.5.8) ── */\n@media (pointer: coarse) {\n  button, a, [role=\"button\"], select { min-height: 2.75rem; min-width: 2.75rem; }\n}\n\nbody, html {\n  margin: 0;\n  padding: 0;\n  font-family: 'TD Graphik', 'Graphik', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  background-color: var(--bg-screen);\n  min-height: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  height: 100dvh;\n  overflow: hidden;\n  -webkit-tap-highlight-color: transparent;\n}\n\n#root, .App {\n  min-height: 100%;\n  min-height: 100dvh;\n  height: 100%;\n  height: 100dvh;\n}\n\n/* --- Layout Containers (mobile-first) --- */\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  height: 100dvh;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.login-page {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background:\n    radial-gradient(1200px 600px at 0% 0%, var(--td-green-light) 0%, transparent 60%),\n    radial-gradient(900px 500px at 100% 100%, var(--td-green-light) 0%, transparent 55%),\n    var(--bh-white);\n  color: var(--bh-black);\n  z-index: 9999;\n  padding: var(--space-md);\n}\n\n.login-box {\n  width: min(92vw, 400px);\n  padding: var(--space-lg);\n  border-radius: var(--radius-xl);\n  background: var(--bh-white);\n  border: 1px solid var(--bh-light-gray);\n  box-shadow: var(--shadow-xl);\n  text-align: left;\n}\n\n.login-brand {\n  font: var(--bh-h2);\n  letter-spacing: -0.02em;\n  color: var(--td-green);\n  margin-bottom: var(--space-md);\n}\n\n.login-box h1 {\n  margin: 0 0 var(--space-2xs);\n  font: var(--bh-h2);\n  color: var(--bh-black);\n}\n\n.login-subtitle {\n  margin: 0 0 var(--space-md);\n  font: var(--bh-body);\n  color: var(--bh-gray);\n}\n\n.login-box label {\n  display: block;\n  margin-top: var(--space-sm);\n  margin-bottom: var(--space-3xs);\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--bh-dark);\n}\n\n.login-submit {\n  margin-top: var(--space-md);\n  width: 100%;\n}\n\n.login-error {\n  margin-top: var(--space-2xs);\n  color: var(--td-red);\n  font: var(--bh-body-sm);\n}\n\n.login-notice {\n  margin-top: var(--space-2xs);\n  color: var(--td-green, #008a00);\n  font: var(--bh-body-sm);\n}\n\n.login-toggle-note {\n  margin-top: var(--space-md);\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n  text-align: center;\n}\n\n.login-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--td-green, #008a00);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n/* Mobile: phone-viewport fills the whole screen */\n.phone-viewport {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n  background-color: var(--bg-screen);\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Desktop: wrap app in a phone-frame widget ── */\n@media (min-width: 601px) {\n  body, html { background-color: #333; overflow: hidden; }\n  .app-container {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    min-height: 100dvh;\n    padding: 20px;\n    height: auto;\n  }\n  .phone-viewport {\n    width: 390px;\n    height: 844px;\n    flex: none;\n    border-radius: 30px;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.4);\n    border: 8px solid #111;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n/* ── Mobile demo pulldown tab: hidden by default, shown in media query below ── */\n.demo-pulldown-tab {\n  display: none;\n}\n\n.demo-nav-login-toggle {\n  margin: 10px 0 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.82rem;\n}\n\n.demo-nav-role {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  padding: 2px 7px;\n  border-radius: 4px;\n  line-height: 1;\n}\n.demo-nav-role.admin {\n  background: rgba(34,197,94,0.25);\n  color: #4ade80;\n}\n.demo-nav-role.guest {\n  background: rgba(250,204,21,0.22);\n  color: #facc15;\n}\n\n.demo-nav-login-btn {\n  border: 1px solid rgba(255,255,255,0.6);\n  background-color: rgba(0,0,0,0.3);\n  color: #fff;\n  border-radius: 6px;\n  padding: 4px 10px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.demo-nav-login-btn.active {\n  background-color: #00a86b;\n}\n\n\n/* ── Mobile demo drawer ────────────────────────────────────────────── */\n.demo-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1490;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.demo-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  max-width: 100%;\n  height: 100dvh;\n  max-height: 100dvh;\n  z-index: 1500;\n  border-radius: 0;\n  transform: translateY(-105%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 16px 14px max(env(safe-area-inset-bottom), 32px);\n  box-sizing: border-box;\n  background: rgba(18, 14, 32, 0.96);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-right: none;\n  border-bottom: none;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.1) transparent;\n}\n.demo-drawer::-webkit-scrollbar { width: 3px; }\n.demo-drawer::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 3px; }\n\n.demo-drawer.open {\n  transform: translateY(0);\n}\n\n.demo-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.demo-drawer-close {\n  background: rgba(255,255,255,0.08);\n  border: 1px solid rgba(255,255,255,0.1);\n  color: rgba(255,255,255,0.6);\n  border-radius: 6px;\n  width: 44px;\n  height: 44px;\n  font-size: var(--font-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.demo-drawer-close:hover {\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n}\n\n/* reuse demo-nav inner styles inside the drawer */\n.demo-drawer .demo-nav-grid,\n.demo-drawer .demo-nav-label,\n.demo-drawer .demo-nav-btn,\n.demo-drawer .demo-nav-full-btn,\n.demo-drawer .demo-nav-select,\n.demo-drawer .demo-nav-hr,\n.demo-drawer .demo-nav-title {\n  /* inherits styles from .demo-nav-* — no override needed */\n}\n\n.screen {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-screen);\n  padding-bottom: 62px; /* clear the bottom nav on desktop */\n  box-sizing: border-box;\n}\n\n.scroll-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(128,128,128,0.2) transparent;\n}\n.scroll-content::-webkit-scrollbar { width: 4px; }\n.scroll-content::-webkit-scrollbar-track { background: transparent; }\n.scroll-content::-webkit-scrollbar-thumb {\n  background: rgba(100,100,100,0.25);\n  border-radius: 4px;\n}\n.scroll-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(100,100,100,0.45);\n}\n.scroll-content {\n  scrollbar-color: rgba(100,100,100,0.25) transparent;\n}\n\n.gray-bg { background-color: var(--bg-light-gray); }\n.white-bg { background-color: var(--bg-card); }\n.positive-green { color: var(--td-positive-green); font-weight: 600; }\n\n/* --- Headers --- */\n\n.simple-header {\n  background-color: var(--td-green);\n  color: white;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.new-chat-button {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 4px;\n  font-size: var(--font-base);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.new-chat-button:hover {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.new-chat-button:active {\n  background-color: rgba(255, 255, 255, 0.25);\n}\n\n.back-icon { font-size: var(--font-2xl); cursor: pointer; }\n.header-title { margin: 0; font-size: var(--font-lg); font-weight: 500; color: white; }\n\n.chat-header-outer {\n  flex-direction: column;\n  align-items: stretch;\n  padding: 12px 16px 6px;\n}\n\n.chat-header-main-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-model-label {\n  font-size: var(--font-xs);\n  font-weight: 400;\n  text-align: center;\n  padding-top: 5px;\n  opacity: 0.65;\n  letter-spacing: 0.3px;\n  color: white;\n  line-height: 1;\n}\n.chat-title-text {\n  font-weight: 600;\n  opacity: 1;\n}\n.chat-title-sep {\n  opacity: 0.5;\n}\n.main-content {\n    padding: 4px 0 20px;\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none;  /* IE 10+ */\n}\n.main-content::-webkit-scrollbar { display: none; }\n\n.nav-list {\n    border-top: 1px solid var(--border-color);\n    border-bottom: 1px solid var(--border-color);\n}\n\n.nav-item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 16px 20px;\n    background: var(--bg-card);\n    border-bottom: 1px solid var(--border-color);\n    cursor: pointer;\n    color: var(--text-dark);\n    font-size: var(--font-lg);\n}\n.nav-item:last-child { border-bottom: none; }\n\n.nav-icon {\n    font-size: var(--font-xl);\n    margin-right: 15px;\n    color: var(--text-medium);\n}\n\n.home-promo-banner {\n  position: relative;\n  margin: var(--space-2xs) var(--space-sm) var(--space-md);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  height: 160px;\n  box-shadow: var(--shadow-lg);\n}\n\n.home-promo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.home-promo-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 14px 16px 16px;\n}\n\n.home-promo-top {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n}\n\n.home-promo-tag {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.75);\n  margin-bottom: 4px;\n}\n\n.home-promo-headline {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.3;\n  max-width: 180px;\n  text-align: right;\n}\n\n.home-promo-bottom {\n  display: flex;\n  justify-content: center;\n}\n\n.home-promo-btn {\n  background: var(--bh-white);\n  color: var(--td-green);\n  border: none;\n  padding: 8px 24px;\n  border-radius: var(--radius-full);\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  cursor: pointer;\n  min-height: 36px;\n  transition: background 200ms ease-in-out, color 200ms ease-in-out, box-shadow 200ms ease-in-out;\n}\n.home-promo-btn:hover {\n  background: var(--td-green);\n  color: var(--bh-white);\n  box-shadow: var(--shadow-green);\n}\n\n\n.bottom-links {\n    display: flex;\n    justify-content: space-around;\n    padding: 20px;\n    border-top: 1px solid var(--border-color);\n    color: var(--text-medium);\n}\n\n.bottom-link-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    gap: 4px;\n}\n.bottom-link-item span { font-size: var(--font-sm); }\n.vertical-divider { width: 1px; background-color: var(--border-color); height: 24px; }\n\n\n/* --- Screen 2: Accounts Specifics --- */\n\n.list-group-title {\n    padding: 15px 20px 5px;\n    font-size: var(--font-sm);\n    color: var(--text-medium);\n    font-weight: 500;\n}\n.list-group-title.compact { padding-top: 25px; padding-bottom: 10px; }\n\n.white-container { background: var(--bg-card); border-bottom: 1px solid var(--border-color); }\n\n.account-list-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid var(--border-color);\n    cursor: pointer;\n}\n.ali-left { min-width: 0; flex: 1; }\n.ali-name { font-weight: 500; font-size: var(--font-lg); text-align: left; color: var(--text-dark); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.ali-num { color: var(--text-medium); font-size: var(--font-base); margin-top: 4px; text-align: left; }\n.ali-right { display: flex; align-items: center; flex-shrink: 0; }\n.ali-currency { font-size: var(--font-sm); color: var(--text-medium); margin-right: 5px; }\n.ali-balance { font-size: var(--font-lg); font-weight: 500; margin-right: 10px; color: var(--text-dark); }\n.ali-arrow { color: var(--text-light); font-size: var(--font-xl); }\n\n.account-total-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 20px;\n    font-weight: 500;\n    background-color: var(--bg-card);\n    color: var(--text-dark);\n}\n.total-values { text-align: right; }\n.usd-subtotal { font-size: var(--font-base); color: var(--text-medium); margin-top: 5px; }\n\n.footer-disclaimer { padding: 20px; color: var(--text-medium); font-size: var(--font-sm); }\n.footer-disclaimer p { margin: 0 0 5px 0; }\n.footer-disclaimer a { display: block; color: var(--td-green); text-decoration: none; margin-bottom: 5px;}\n\n\n/* --- Screen 4: Chat Specifics --- */\n\n.chat-content-bg {\n  background-color: var(--bg-light-gray); /* Light gray-blue background used in chat apps */\n  padding: 20px 12px;        /* horizontal padding so user bubbles don't kiss the wall */\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-timestamp {\n  text-align: center;\n  color: var(--text-medium);\n  font-size: var(--font-sm);\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.chat-message-container {\n  display: flex;\n  margin-bottom: 10px;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.bot-message {\n  justify-content: flex-start;\n}\n\n.user-message {\n  justify-content: flex-end;\n}\n\n.bot-avatar {\n  width: 28px;\n  height: 28px;\n  background-color: var(--bg-card);\n  border: 1.5px solid var(--border-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--td-green);\n  font-size: var(--font-base);\n  flex-shrink: 0;\n}\n\n.chat-bubble {\n  max-width: 75%;\n  padding: 10px 14px;\n  border-radius: 18px;\n  font-size: var(--font-base);\n  line-height: 1.45;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.06);\n}\n\n.bot-message .chat-bubble {\n  background-color: var(--bg-card);\n  color: var(--text-dark);\n  border-bottom-left-radius: 4px;\n  text-align: left;\n  max-width: 100%;          /* let bot bubbles fill the wider wrapper */\n}\n\n.user-message .chat-bubble {\n  background-color: var(--td-green);\n  color: white;\n  border-bottom-right-radius: 4px;\n  text-align: left;\n}\n\n/* Chat Carousel */\n.chat-carousel-container {\n  display: flex;\n  justify-content: center;\n  overflow-x: auto;\n  gap: 15px;\n  padding: 10px 16px 20px 16px;\n  margin-bottom: 10px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.chat-carousel-container::-webkit-scrollbar { display: none; }\n\n.chat-carousel-card {\n  flex: 0 0 220px;\n  background-color: var(--bg-card);\n  padding: 22px 18px;\n  border-radius: 16px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.carousel-icon {\n  font-size: var(--font-3xl);\n  color: var(--td-green);\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: center;\n}\n.chat-carousel-card h3 {\n  margin: 0 0 8px 0;\n  font-size: var(--font-base);\n  font-weight: 600;\n  color: var(--text-dark);\n  text-align: center;\n}\n.chat-carousel-card p {\n  margin: 0;\n  font-size: var(--font-sm);\n  line-height: 1.5;\n  color: var(--text-medium);\n  text-align: center;\n}\n\n\n/* Chat Input Area */\n.chat-input-area {\n  background-color: var(--bg-card);\n  border-top: 1px solid var(--border-color);\n  padding: 15px 16px 25px; /* Extra padding for bottom safe area */\n}\n\n.suggestions-row {\n  display: flex;\n  overflow-x: auto;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 2px 0 4px;\n  /* Thin styled scrollbar so users know it's scrollable */\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-color) transparent;\n}\n.suggestions-row::-webkit-scrollbar {\n  height: 3px;\n}\n.suggestions-row::-webkit-scrollbar-track {\n  background: transparent;\n}\n.suggestions-row::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 2px;\n}\n\n.chat-suggestion-chip {\n  flex: 0 0 auto;\n  background-color: var(--bg-card);\n  border: 1px solid var(--td-green);\n  color: var(--td-green);\n  padding: 10px 18px;\n  border-radius: 25px;\n  font-size: var(--font-base);\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n.chat-suggestion-chip:hover { background-color: #f0f9f4; }\n\n.input-row {\n  display: flex;\n  align-items: center;\n  background-color: var(--bg-light-gray);\n  border-radius: 30px;\n  padding: 6px 6px 6px 20px;\n}\n\n.input-row input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: var(--font-lg);\n  outline: none;\n  color: var(--text-dark);\n}\n.input-row input::placeholder { color: var(--text-light); }\n\n.send-button {\n  width: 44px;\n  height: 44px;\n  background-color: var(--td-green);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xl);\n  cursor: pointer;\n  margin-left: 10px;\n  transition: background-color 0.2s;\n}\n.send-button:hover { background-color: var(--td-dark-green); }\n.send-button.stop-button:hover { background-color: var(--td-dark-green); }\n\n/* Thinking animation on stop button */\n.send-button.stop-button--thinking {\n  position: relative;\n}\n\n.send-button.stop-button--thinking .thinking-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 28px;\n  height: 28px;\n  border: 2px solid transparent;\n  border-top-color: white;\n  border-radius: 50%;\n  animation: thinking-spin 1.5s linear infinite;\n  pointer-events: none;\n}\n\n@keyframes thinking-spin {\n  0%   { transform: translate(-50%, -50%) rotate(0deg); }\n  100% { transform: translate(-50%, -50%) rotate(360deg); }\n}\n\n/* --- Demo Nav (Liquid Glass) --- */\n\n.demo-nav {\n  position: fixed;\n  bottom: 12px;\n  left: 12px;\n  width: 188px;\n  max-height: 92vh;\n  overflow-y: auto;\n  background: rgba(10, 10, 18, 0.22);\n  backdrop-filter: blur(24px) saturate(160%);\n  -webkit-backdrop-filter: blur(24px) saturate(160%);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.05);\n  padding: 10px 9px;\n  z-index: 1000;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.10) transparent;\n}\n.demo-nav::-webkit-scrollbar { width: 3px; }\n.demo-nav::-webkit-scrollbar-track { background: transparent; }\n.demo-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.14); border-radius: 3px; }\n\n.demo-nav-title {\n  margin: 0 0 7px;\n  font-size: var(--font-2xs);\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.38);\n}\n.demo-nav-build-info {\n  font-size: 9px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  color: rgba(255,255,255,0.22);\n  margin-bottom: 4px;\n}\n\n.demo-nav-label {\n  margin: 0 0 4px;\n  font-size: var(--font-2xs);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.38);\n}\n\n/* Sub-tier label (e.g. \"Free\", \"Paid\", \"Local\" under \"AI Backend\"). Sits\n   inline to the left of its row of buttons via .demo-nav-tier-row. */\n.demo-nav-sublabel {\n  margin: 0;\n  font-size: var(--font-2xs);\n  font-weight: 600;\n  color: rgba(255,255,255,0.55);\n  min-width: 38px;\n  flex-shrink: 0;\n}\n\n/* Horizontal sub-tier row: [label] [button-grid] in one line. Compact\n   vertical footprint vs. stacking label above buttons. */\n.demo-nav-tier-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 3px;\n}\n.demo-nav-tier-row .demo-nav-grid-2 {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.demo-nav hr {\n  border: none;\n  border-top: 1px solid rgba(255,255,255,0.08);\n  margin: 7px 0;\n}\n\n.demo-nav-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 3px;\n  margin-bottom: 0;\n}\n\n.demo-nav-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3px;\n}\n\n.demo-nav-btn {\n  background: rgba(255,255,255,0.07);\n  color: rgba(255,255,255,0.65);\n  border: 1px solid rgba(255,255,255,0.07);\n  border-radius: 7px;\n  padding: 4px 2px;\n  font-size: var(--font-2xs);\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: inherit;\n}\n.demo-nav-btn:hover {\n  background: rgba(255,255,255,0.14);\n  color: rgba(255,255,255,0.9);\n}\n.demo-nav-btn.active {\n  background: rgba(255,255,255,0.2);\n  color: #fff;\n  border-color: rgba(255,255,255,0.22);\n  font-weight: 600;\n}\n\n.demo-nav-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 0;\n}\n\n.demo-nav-select {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  font-size: var(--font-2xs);\n  padding: 3px 5px;\n  border-radius: 7px;\n  border: 1px solid rgba(255,255,255,0.12);\n  background: rgba(255,255,255,0.07);\n  color: rgba(255,255,255,0.8);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.demo-nav-select option,\n.demo-nav-select optgroup {\n  background: #1e1e2e;\n  color: #f0f0f0;\n}\n\n.demo-nav-full-btn {\n  width: 100%;\n  padding: 5px 6px;\n  border-radius: 8px;\n  border: 1px solid rgba(255,255,255,0.1);\n  font-size: var(--font-2xs);\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.03em;\n  font-family: inherit;\n  transition: opacity 0.12s;\n}\n.demo-nav-full-btn:hover { opacity: 0.85; }\n\n/* --- Theme Toggle (top-right float) --- */\n\n.theme-toggle-float {\n  position: fixed;\n  top: 14px;\n  right: 14px;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  background: rgba(10, 10, 18, 0.55);\n  backdrop-filter: blur(20px) saturate(160%);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 50px;\n  padding: 3px 5px;\n  gap: 2px;\n  box-shadow: 0 4px 18px rgba(0,0,0,0.35);\n}\n\n.theme-toggle-btn {\n  width: 28px;\n  height: 24px;\n  border-radius: 40px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-sm);\n  transition: background 0.18s;\n  background: transparent;\n}\n.theme-toggle-btn.active {\n  background: rgba(255,255,255,0.16);\n  box-shadow: inset 0 1px 2px rgba(0,0,0,0.2);\n}\n\n.profile-picker-float {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(10, 10, 18, 0.55);\n  backdrop-filter: blur(20px) saturate(160%);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 50px;\n  padding: 5px 11px 5px 8px;\n  box-shadow: 0 4px 18px rgba(0,0,0,0.35);\n  cursor: pointer;\n  font-size: var(--font-xs);\n  font-weight: 500;\n  color: rgba(255,255,255,0.75);\n  transition: background 0.15s, color 0.15s;\n  max-width: 140px;\n}\n.profile-picker-float:hover { background: rgba(10,10,18,0.75); color: #fff; }\n.profile-picker-float.loaded { color: #fff; border-color: rgba(255,255,255,0.18); }\n.profile-picker-float span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* --- Global Save Button --- */\n.global-save-btn {\n  position: fixed;\n  top: 86px; /* sits below the profile picker pill (~52 + pill height ~28 + 6px gap) */\n  right: 14px;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  background: rgba(10, 10, 18, 0.55);\n  backdrop-filter: blur(20px) saturate(160%);\n  -webkit-backdrop-filter: blur(20px) saturate(160%);\n  border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 50%;\n  box-shadow: 0 4px 18px rgba(0,0,0,0.35);\n  cursor: pointer;\n  color: rgba(255,255,255,0.75);\n  transition: background 0.15s, color 0.15s;\n}\n.global-save-btn:hover { background: rgba(10,10,18,0.75); color: #fff; }\n.global-save-btn.saving { opacity: 0.5; cursor: default; }\n.global-save-btn.saved { background: rgba(0,180,80,0.6); border-color: rgba(0,220,100,0.4); color: #fff; }\n.global-save-btn.error { background: rgba(220,50,50,0.6); border-color: rgba(255,80,80,0.4); color: #fff; }\n\n/* --- Profile Dropdown --- */\n.profile-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 180px;\n  background: rgba(18, 18, 28, 0.92);\n  backdrop-filter: blur(24px) saturate(160%);\n  -webkit-backdrop-filter: blur(24px) saturate(160%);\n  border: 1px solid rgba(255,255,255,0.12);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.45);\n  overflow: hidden;\n  z-index: 1201;\n}\n.profile-dropdown-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  padding: 9px 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  transition: background 0.12s;\n}\n.profile-dropdown-item:last-child { border-bottom: none; }\n.profile-dropdown-item:hover { background: rgba(255,255,255,0.08); }\n.profile-dropdown-item.active { background: rgba(255,255,255,0.12); }\n.profile-dropdown-label {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: rgba(255,255,255,0.9);\n  line-height: 1.3;\n}\n.profile-dropdown-sub {\n  font-size: var(--font-xs);\n  color: rgba(255,255,255,0.45);\n  margin-top: 1px;\n}\n\n/* --- Sidebar Styling --- */\n.sidebar-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 1000;\n  display: flex;\n}\n\n.sidebar-content {\n  width: 80%;\n  height: 100%;\n  background: var(--bg-card);\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0); }\n}\n\n.sidebar-scroll { flex: 1; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(128,128,128,0.2) transparent; }\n.sidebar-scroll::-webkit-scrollbar { width: 4px; }\n.sidebar-scroll::-webkit-scrollbar-track { background: transparent; }\n.sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }\n.sidebar-scroll::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }\n\n.sidebar-item {\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  color: var(--text-dark);\n  font-size: var(--font-base);\n  border-bottom: 0.5px solid var(--border-color);\n}\n\n.logout-item { background: var(--bg-light-gray); color: var(--text-light); border-bottom: 2px solid var(--border-color); }\n.sidebar-icon { font-size: var(--font-xl); margin-right: 15px; color: var(--text-medium); }\n.sidebar-divider { height: 20px; background: var(--bg-light-gray); border-bottom: 1px solid var(--border-color); }\n\n/* --- Locations Screen --- */\n.search-bar-container { background: var(--td-green); padding: 10px 15px; }\n.search-bar {\n  background: var(--bg-card);\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 4px;\n}\n.search-icon { color: var(--text-light); margin-right: 10px; }\n.search-bar input { border: none; outline: none; width: 100%; font-size: var(--font-base); background: transparent; color: var(--text-dark); }\n\n.map-container {\n  height: 250px;\n  background: var(--bg-light-gray);\n  overflow: hidden;\n  border-radius: 8px;\n  margin: 0 20px;\n}\n\n.map-container iframe,\n.map-container .leaflet-container {\n  width: 100%;\n  height: 100% !important;\n  border-radius: 8px;\n}\n\n.location-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 15px 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n.loc-info { flex: 1; display: flex; flex-direction: column; text-align: left; }\n.loc-address { font-weight: 600; font-size: var(--font-base); color: var(--text-dark); }\n.loc-city, .loc-status { font-size: var(--font-sm); color: var(--text-medium); margin-top: 2px; }\n.loc-status { color: var(--td-green); font-weight: 500; }\n.loc-dist { display: flex; align-items: center; color: var(--td-green); font-weight: 600; font-size: var(--font-base); margin-left: 15px; white-space: nowrap; }\n\n/* --- Receipt Screen --- */\n.receipt-header { background: var(--td-dark-green); color: white; padding: 15px 20px; display: flex; justify-content: space-between; align-items: center; }\n.receipt-success-block { background: var(--td-green); color: white; padding: 30px 20px; text-align: center; }\n.success-title { font-size: var(--font-2xl); margin: 0; font-weight: 400; }\n.success-subtitle { font-size: var(--font-lg); margin: 5px 0 15px 0; }\n.confirmation-num { font-size: var(--font-xs); opacity: 0.8; line-height: 1.4; }\n\n.receipt-details { padding: 20px; border-bottom: 1px solid var(--border-color); }\n.receipt-row { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 0.5px solid var(--border-color); font-size: var(--font-base); color: var(--text-dark); }\n.receipt-row:last-child { border-bottom: none; }\n.receipt-row span { color: var(--text-light); }\n\n.receipt-actions { display: flex; justify-content: space-around; padding: 20px 10px; }\n.receipt-action-btn { display: flex; flex-direction: column; align-items: center; text-align: center; max-width: 80px; cursor: pointer; }\n.ra-icon { width: 50px; height: 50px; border-radius: 50%; border: 1px solid var(--td-green); display: flex; align-items: center; justify-content: center; color: var(--td-green); font-size: var(--font-xl); margin-bottom: 8px; }\n.receipt-action-btn span { font-size: var(--font-xs); color: var(--text-medium); font-weight: 600; }\n\n/* --- Card Management Styling --- */\n.card-display-container {\n  padding: 40px 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.aeroplan-card {\n  width: 280px;\n  height: 170px;\n  border-radius: 12px;\n  box-shadow: 0 10px 20px rgba(0,0,0,0.2);\n  overflow: hidden;\n}\n\n.card-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n}\n\n.card-top { display: flex; justify-content: space-between; font-weight: bold; }\n.card-chip { width: 40px; height: 30px; background: #c0c0c0; border-radius: 4px; }\n.card-bottom { display: flex; flex-direction: column; gap: 5px; }\n.card-number { letter-spacing: 2px; font-size: var(--font-lg); }\n\n.card-quick-actions {\n  display: flex;\n  justify-content: space-around;\n  padding: 10px;\n}\n\n.cqa-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.cqa-icon {\n  width: 60px;\n  height: 60px;\n  background: var(--bg-card);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xl);\n  color: var(--text-dark);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.05);\n}\n\n.cqa-item span { font-size: var(--font-sm); color: var(--text-medium); }\n\n.pin-display {\n  text-align: center;\n  font-size: var(--font-3xl);\n  font-weight: bold;\n  letter-spacing: 15px;\n  margin-top: 50px;\n  color: var(--text-dark);\n}\n\n/* --- Security Screen Styling --- */\n.security-header { padding-bottom: 80px; }\n\n.security-quick-actions {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.sqa-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: white;\n  width: 80px;\n}\n\n.sqa-icon {\n  width: 50px;\n  height: 50px;\n  background: rgba(255,255,255,0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xl);\n  margin-bottom: 8px;\n}\n\n.sqa-item span { font-size: var(--font-xs); text-align: center; line-height: 1.2; }\n\n/* --- Toggle Switch & Frozen States --- */\n\n.toggle-btn {\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n/* When the freeze button is active */\n.active-frozen {\n  background-color: #e3f2fd !important; /* Light blue background */\n  color: #1976d2 !important; /* Blue icon color */\n  border: 2px solid #1976d2;\n  transform: scale(1.05);\n}\n\n/* Visual overlay for the card when frozen */\n.frozen-overlay {\n  position: relative;\n  opacity: 0.6;\n  filter: grayscale(80%);\n  transition: all 0.4s ease;\n}\n\n.frozen-overlay::after {\n  content: 'FROZEN';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(-15deg);\n  border: 3px solid white;\n  padding: 5px 15px;\n  font-weight: 900;\n  letter-spacing: 4px;\n  font-size: var(--font-xl);\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n.frozen-status-msg {\n  margin: 20px;\n  padding: 15px;\n  background-color: #fff3f3;\n  border: 1px solid #ffcdd2;\n  color: #d32f2f;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-sm);\n  font-weight: 500;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* --- In-App Call Styling --- */\n.call-header {\n  background: var(--td-green);\n  color: white;\n}\n\n.call-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 50px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.call-hero {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.call-avatar-container {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 20px;\n}\n\n.call-avatar {\n  width: 100%;\n  height: 100%;\n  background: var(--td-green);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.call-ripple {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  border-radius: 50%;\n  background: var(--td-green);\n  z-index: 1;\n  opacity: 0;\n}\n\n.call-ripple.animate {\n  animation: rippleEffect 2s infinite;\n}\n\n@keyframes rippleEffect {\n  0% { transform: scale(1); opacity: 0.4; }\n  100% { transform: scale(1.8); opacity: 0; }\n}\n\n.call-status { font-size: var(--font-xl); margin: 10px 0 5px; color: var(--text-dark); font-weight: 500; }\n.call-timer { color: var(--text-light); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell'; font-size: var(--font-lg); }\n\n.call-pre-check {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.check-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: var(--font-lg);\n  color: var(--text-medium);\n  font-weight: 400;\n}\n\n.call-primary-btn {\n  background: var(--td-green);\n  color: white;\n  border: none;\n  padding: 15px;\n  border-radius: 30px;\n  font-weight: bold;\n  margin-top: 20px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.2);\n}\n\n.call-disclaimer {\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  text-align: center;\n  margin-top: 15px;\n  line-height: 1.5;\n}\n\n.call-controls {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n}\n\n.control-row {\n  display: flex;\n  gap: 40px;\n}\n\n.control-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  color: var(--text-medium);\n  font-size: var(--font-sm);\n}\n\n.end-call-btn {\n  background: #d32f2f;\n  color: white;\n  border: none;\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  font-weight: bold;\n  font-size: var(--font-sm);\n  box-shadow: 0 4px 10px rgba(211,47,47,0.3);\n}\n\n/* --- Call Verification Styling --- */\n\n.security-status-hero {\n  padding: 40px 20px;\n  text-align: center;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.status-icon-ring {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 4px solid var(--border-color);\n}\n\n.safe-ring { color: var(--td-green); border-color: var(--td-green); background: var(--bg-card); }\n.scam-ring { color: #d32f2f; border-color: #d32f2f; background: var(--bg-card); animation: pulseRed 2s infinite; }\n\n@keyframes pulseRed {\n  0% { box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.4); }\n  70% { box-shadow: 0 0 0 15px rgba(211, 47, 47, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(211, 47, 47, 0); }\n}\n\n.status-main-text { font-size: var(--font-xl); font-weight: 700; margin-bottom: 10px; color: var(--text-dark); }\n.status-sub-text { font-size: var(--font-base); color: var(--text-medium); line-height: 1.5; padding: 0 20px; }\n\n.status-details-card { margin: 20px; padding: 20px; position: relative; }\n\n.status-badge {\n  position: absolute;\n  top: -12px;\n  right: 20px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  color: white;\n  font-size: var(--font-xs);\n  font-weight: 800;\n  letter-spacing: 0.5px;\n}\n\n.bg-safe { background: var(--td-green); }\n.bg-scam { background: #d32f2f; }\n\n.status-info-row { display: flex; justify-content: space-between; padding: 12px 0; border-bottom: 0.5px solid var(--border-color); font-size: var(--font-base); color: var(--text-dark); }\n.text-danger { color: #d32f2f; }\n\n.scam-action-box { padding: 20px; }\n.scam-action-box h3 { font-size: var(--font-lg); color: var(--text-dark); margin-bottom: 10px; }\n.scam-action-box ul { padding-left: 20px; font-size: var(--font-sm); color: var(--text-medium); }\n.scam-action-box li { margin-bottom: 8px; }\n\n.report-scam-btn {\n  width: 100%;\n  background: var(--td-dark-green);\n  color: white;\n  border: none;\n  padding: 15px;\n  border-radius: 8px;\n  font-weight: bold;\n  margin-top: 15px;\n}\n\n.demo-toggle-container { margin: 40px 20px; padding: 15px; border: 1px dashed var(--border-color); border-radius: 8px; text-align: center; }\n.demo-toggle-container p { font-size: var(--font-xs); color: var(--text-light); margin-bottom: 8px; }\n\n/* --- Home Screen Call Banner --- */\n.home-banner-wrapper {\n  padding: 0 15px;\n  margin-top: 10px;\n  z-index: 10;\n}\n\n.call-status-banner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  animation: slideDown 0.4s ease-out;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.csb-left { display: flex; align-items: center; gap: 15px; }\n\n/* Active State (Monzo/Starling Inspired) */\n.active-call-bg { background: white; border-left: 5px solid #008a0d; }\n.csb-avatar-pulse {\n  width: 40px; height: 40px; background: #008a0d; border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  animation: rippleGreen 2s infinite;\n}\n\n@keyframes rippleGreen {\n  0% { box-shadow: 0 0 0 0 rgba(0, 138, 13, 0.4); }\n  70% { box-shadow: 0 0 0 10px rgba(0, 138, 13, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(0, 138, 13, 0); }\n}\n\n/* Recent State */\n.recent-call-bg { background: var(--bg-card); border-left: 5px solid var(--text-light); }\n\n/* Safe/None State */\n.safe-call-bg { background: var(--bg-card); border: 1px solid var(--border-color); }\n.csb-icon-circle { width: 40px; height: 40px; background: var(--bg-light-gray); border-radius: 50%; display: flex; align-items: center; justify-content: center; }\n\n.csb-title { font-size: var(--font-base); font-weight: 700; color: var(--td-green); }\n.csb-title.dark-text { color: var(--text-dark); }\n.csb-subtitle { font-size: var(--font-xs); color: var(--text-medium); }\n.gray-text { color: var(--text-light); }\n\n/* --- Sidebar Toggle UI --- */\n.sidebar-toggle-row {\n  display: flex; justify-content: space-between; align-items: center;\n  padding: 15px 20px; border-bottom: 1px solid #eee;\n}\n.switch { position: relative; display: inline-block; width: 40px; height: 22px; }\n.switch input { opacity: 0; width: 0; height: 0; }\n.slider {\n  position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0;\n  background-color: #ccc; transition: .4s; border-radius: 34px;\n}\n.slider:before {\n  position: absolute; content: \"\"; height: 16px; width: 16px; left: 3px; bottom: 3px;\n  background-color: white; transition: .4s; border-radius: 50%;\n}\ninput:checked + .slider { background-color: #008a0d; }\ninput:checked + .slider:before { transform: translateX(18px); }\n\n/* --- Emergency Hang Up Button --- */\n\n.emergency-hangup-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #d32f2f; /* Standard emergency red */\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s active;\n  gap: 2px;\n  min-width: 70px;\n  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3);\n}\n\n.emergency-hangup-btn:active {\n  transform: scale(0.95);\n  background-color: #b71c1c;\n}\n\n.emergency-hangup-btn span {\n  font-size: var(--font-2xs);\n  font-weight: 900;\n  letter-spacing: 0.5px;\n}\n\n/* Ensure the banner content spreads out to make room for the button */\n.active-call-bg {\n  justify-content: space-between;\n  padding-right: 10px !important;\n}\n\n/* Subtle border to make the active state feel \"urgent\" */\n.active-call-bg {\n  border: 2px solid var(--td-green);\n  background: var(--bg-card);\n}\n\n/* --- Direct Deposit Details Styling --- */\n\n.deposit-hero-section {\n  background: var(--bg-card);\n  padding: 40px 20px;\n  text-align: center;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.deposit-status-pill {\n  display: inline-block;\n  background: var(--bg-light-gray);\n  color: var(--td-green);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: var(--font-xs);\n  font-weight: 800;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n}\n\n.deposit-hero-section h1 {\n  font-size: var(--font-3xl);\n  margin: 0;\n  font-weight: 700;\n}\n\n.deposit-sender-name {\n  font-size: var(--font-lg);\n  font-weight: 600;\n  color: var(--text-dark);\n  margin: 5px 0;\n}\n\n.deposit-timestamp {\n  font-size: var(--font-sm);\n  color: var(--text-light);\n}\n\n.detail-list-group {\n  margin-top: 20px;\n  padding: 0 20px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 18px 0;\n  border-bottom: 0.5px solid var(--border-color);\n  font-size: var(--font-base);\n}\n\n.detail-row:last-child { border-bottom: none; }\n.detail-row span { color: var(--text-medium); }\n.detail-row strong { color: var(--text-dark); text-align: right; max-width: 60%; }\n.text-small { font-size: var(--font-sm); font-family: monospace; }\n\n/* Ancillary Insights Card */\n.ancillary-info-card {\n  margin: 20px;\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.aic-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: var(--font-base);\n  margin-bottom: 10px;\n  color: var(--td-green);\n}\n\n.ancillary-info-card p {\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  margin: 0 0 10px 0;\n}\n\n.next-deposit-alert {\n  display: flex;\n  justify-content: space-between;\n  background: var(--bg-card);\n  padding: 10px;\n  border-radius: 8px;\n  font-size: var(--font-sm);\n  color: var(--text-dark);\n}\n\n.deposit-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px;\n}\n\n.secondary-action-btn {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  padding: 12px;\n  border-radius: 8px;\n  font-weight: 600;\n  color: var(--text-dark);\n  font-size: var(--font-base);\n}\n\n/* --- Spending Analysis Styling --- */\n\n.spending-summary-card {\n  background: var(--bg-card);\n  padding: 30px 20px 20px;\n  text-align: center;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.total-spend-amount {\n  font-size: var(--font-3xl);\n  font-weight: 700;\n  margin: 0;\n  color: var(--text-dark);\n}\n\n.spend-subtitle {\n  color: var(--text-medium);\n  margin: 5px 0 25px;\n}\n\n.frequency-toggle-container {\n  display: flex;\n  background: var(--bg-light-gray);\n  padding: 4px;\n  border-radius: 20px;\n  margin: 0 auto;\n  max-width: 300px;\n}\n\n.freq-toggle-btn {\n  flex: 1;\n  border: none;\n  background: none;\n  padding: 8px;\n  border-radius: 16px;\n  font-size: var(--font-sm);\n  font-weight: 500;\n  color: var(--text-medium);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.freq-toggle-btn.active {\n  background: var(--bg-card);\n  color: var(--td-green);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.chart-container {\n  padding: 25px 20px;\n  margin-top: 20px;\n}\n\n.chart-title {\n  margin: 0 0 30px;\n  font-size: var(--font-lg);\n  color: var(--text-dark);\n}\n\n.bar-chart {\n  display: flex;\n  justify-content: space-around;\n  height: 200px;\n  align-items: flex-end;\n}\n\n.chart-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.bar-track {\n  width: 16px;\n  height: 150px;\n  background: var(--bg-light-gray);\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n}\n\n.bar-fill {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--td-green);\n  border-radius: 8px;\n  transition: height 0.5s ease-out;\n}\n\n.bar-label-top {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--td-green);\n  margin-bottom: 8px;\n}\n\n.bar-label-bottom {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 12px;\n}\n\n.insights-container {\n  padding: 25px 20px;\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n\n.insight-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.insight-title {\n  font-size: var(--font-lg);\n  font-weight: 600;\n}\n\n.insight-body {\n  color: var(--text-medium);\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n\n.insight-tip-box {\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  padding: 15px;\n  border-radius: 8px;\n  font-size: var(--font-sm);\n  color: var(--td-green);\n}\n\n/* --- Stacked Chart UI --- */\n.chart-card {\n  margin: 15px;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 30px;\n}\n\n.chart-legend {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  gap: 4px;\n}\n\n.legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n}\n\n.stacked-bar-chart {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  height: 200px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.bar-track-stacked {\n  width: 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column-reverse; /* Stacks categories from bottom up */\n  background: var(--bg-light-gray);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.bar-segment {\n  width: 100%;\n  transition: height 0.3s ease;\n}\n\n/* --- Bottom Toggles --- */\n.frequency-toggle-container-bottom {\n  display: flex;\n  background: var(--bg-light-gray);\n  padding: 4px;\n  border-radius: 12px;\n  margin-top: 25px;\n}\n\n\n.insight-text {\n  font-size: var(--font-base);\n  color: var(--text-dark);\n  margin-bottom: 8px;\n}\n\n.status-indicator-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: var(--font-sm);\n  font-weight: 500;\n}\n\n/* Navigation Bar */\n/* --- Bottom Nav (Instagram-style tab bar) --- */\n\n.bottom-nav {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 62px;\n  background: var(--bg-card);\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0 4px;\n  z-index: 100;\n}\n\n.bottom-nav .nav-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  color: var(--text-light);\n  font-size: var(--font-xs);\n  font-weight: 500;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px 0;\n  transition: color 0.15s;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.bottom-nav .nav-item:hover { color: var(--text-medium); }\n\n.bottom-nav .nav-item.active {\n  color: var(--td-green);\n  font-weight: 600;\n}\n\n\n.bottom-nav .nav-item { position: relative; }\n\n/* Pulsing dot on a nav tab whose background work (IVA agent pipeline) is in flight. */\n.nav-busy-dot {\n  position: absolute;\n  top: -2px;\n  right: -5px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--td-green, #2FBF00);\n  box-shadow: 0 0 0 2px var(--bg-card, #fff);\n  animation: nav-busy-pulse 1.2s ease-in-out infinite;\n}\n@keyframes nav-busy-pulse {\n  0%, 100% { opacity: 1;   transform: scale(1);   }\n  50%      { opacity: 0.4; transform: scale(0.7); }\n}\n\n/* --- Chat FAB (Floating Action Button) ---\n   Drawer-tab pattern: idle is a thin green sliver flush with the right edge;\n   on hover it expands to a full clickable button revealing the icon. */\n.chat-fab {\n  position: absolute;\n  bottom: 74px;\n  right: 0;                                         /* flush against right edge */\n  width: 18px;                                      /* slim sliver in idle state */\n  height: 56px;\n  background: linear-gradient(135deg, var(--td-green), var(--td-dark-green));\n  border: none;\n  color: var(--bh-black);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0;\n  z-index: 200;\n  box-shadow: -3px 3px 12px rgba(0,0,0,0.25);       /* shadow biased to the left */\n  overflow: hidden;\n  transition:\n    width 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),\n    padding 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),\n    box-shadow 0.2s,\n    background 0.2s;\n  animation: chat-fab-slide-in 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.chat-fab:hover {\n  width: 64px;                                      /* expand to reveal full button */\n  padding-left: 12px;\n  box-shadow: -6px 4px 22px rgba(0,0,0,0.42);\n}\n\n.chat-fab:active { transform: scale(0.96); }\n\n@keyframes chat-fab-slide-in {\n  0%   { transform: translateX(80px); opacity: 0; }\n  60%  { transform: translateX(-4px); opacity: 1; }\n  100% { transform: translateX(0);    opacity: 1; }\n}\n\n.chat-fab--open {\n  background: linear-gradient(135deg, #e53935, #b71c1c);\n}\n\n.chat-fab-icon {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;                              /* hidden in slim idle state */\n  transition: opacity 0.18s ease, transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n.chat-fab:hover .chat-fab-icon { opacity: 1; }\n\n.chat-fab--open .chat-fab-icon {\n  transform: rotate(90deg);\n}\n\n/* Pulse ring on idle */\n.chat-fab-pulse {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: var(--td-green);\n  opacity: 0;\n  animation: chat-fab-pulse 2.8s ease-out infinite;\n  pointer-events: none;\n}\n\n@keyframes chat-fab-pulse {\n  0%   { transform: scale(1);   opacity: 0.55; }\n  65%  { transform: scale(1.7); opacity: 0;    }\n  100% { transform: scale(1.7); opacity: 0;    }\n}\n\n/* --- Chat Modal Overlay ---\n   Slides in from the right edge of the viewport (drawer pattern) instead\n   of up from the bottom (sheet pattern). The chat header back button still\n   navigates; the slim left-edge drag handle is a tap-to-close affordance\n   that maps to the slide-out direction. */\n.chat-modal-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  background: var(--bg-screen);\n  z-index: 190;\n  overflow: hidden;\n  display: none;\n  flex-direction: row;          /* row layout: handle on left, chat fills rest */\n  transform: translateX(102%);  /* off-screen right when closed */\n  visibility: hidden;\n  box-shadow: -8px 0 32px rgba(0,0,0,0.28);  /* shadow on the left edge */\n}\n/* Keep in DOM for slide animation after first toggle */\n.chat-modal-overlay.chat-modal--shown {\n  display: flex;\n}\n/* Animate slide; delay visibility on close so slide-out completes first */\n.chat-modal-overlay.chat-modal--ready {\n  transition: transform 0.38s cubic-bezier(0.4,0,0.2,1), visibility 0s 0.38s;\n}\n/* Open state: visible + slid in; visibility is instant on open */\n.chat-modal-overlay.chat-modal--open {\n  transform: translateX(0);\n  visibility: visible;\n  transition: transform 0.38s cubic-bezier(0.4,0,0.2,1), visibility 0s 0s;\n}\n\n/* Slim left-edge drag handle — tap to close, mirroring the slide-in\n   direction. Vertical bar sits flush against the left edge. */\n.chat-modal-drag-handle {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 100%;\n  background: var(--bg-card);\n  border-right: 1px solid var(--border-color);\n  cursor: pointer;\n  padding: 0;\n}\n\n.chat-modal-handle-bar {\n  width: 4px;\n  height: 36px;\n  background: var(--border-color);\n  transition: background 0.15s;\n}\n\n.chat-modal-drag-handle:hover .chat-modal-handle-bar {\n  background: var(--text-light);\n}\n\n/* Modal chat screen fills the overlay — remove nav padding since modal covers nav */\n.chat-screen--modal {\n  flex: 1;\n  overflow: hidden;\n  border-radius: 0;\n  padding-bottom: 0 !important;\n}\n\n/* Screens that use bottom nav need bottom padding so content isn't hidden */\n.screen-with-nav {\n  padding-bottom: 62px;\n}\n\n/* --- Profile Screen --- */\n\n.profile-hero {\n  position: relative;\n  background: linear-gradient(145deg, var(--td-green), var(--td-dark-green));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 20px 24px;\n  flex-shrink: 0;\n}\n\n.profile-hero-actions {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  gap: 8px;\n}\n.profile-hero-action {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255,255,255,0.18);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms ease;\n}\n.profile-hero-action:hover  { background: rgba(255,255,255,0.30); }\n.profile-hero-action:active { background: rgba(255,255,255,0.38); }\n\n/* Settings screen: use themed tokens so the cards follow light/dark theme.\n   The base .bh-* tokens are hardcoded white/black and never switch, which\n   left the dark (purple) theme with white boxes + washed-out text. These\n   scoped overrides beat the base .bh-form-card rule on specificity. */\n.settings-screen.bh-flow { background: var(--bg-light-gray); }\n.settings-screen .bh-form-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n}\n.settings-screen .bh-info-box {\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  color: var(--text-medium);\n}\n\n.profile-avatar-ring {\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  border: 3px solid rgba(255,255,255,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n\n.profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xl);\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: 0.5px;\n}\n\n.profile-hero-name  { font-size: var(--font-xl); font-weight: 700; color: #fff; margin-bottom: 3px; text-align: center; }\n.profile-hero-sub   { font-size: var(--font-sm); color: rgba(255,255,255,0.8); margin-bottom: 2px; text-align: center; }\n.profile-hero-email { font-size: var(--font-xs); color: rgba(255,255,255,0.65); margin-bottom: 2px; }\n.profile-hero-since { font-size: var(--font-xs); color: rgba(255,255,255,0.5); margin-top: 4px; }\n\n.profile-section { padding: 16px 14px 0; }\n\n.profile-section-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-medium);\n  margin-bottom: 8px;\n  padding-left: 2px;\n}\n\n.profile-section-label {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-light);\n  padding: 0 0 6px;\n}\n\n.profile-card {\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.profile-balance-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border-color);\n}\n.profile-balance-row:last-child { border-bottom: none; }\n.profile-balance-label { font-size: var(--font-sm); color: var(--text-dark); }\n.profile-balance-val   { font-size: var(--font-sm); font-weight: 600; }\n\n.profile-net-worth {\n  border-radius: 0;\n  margin: 0;\n}\n\n.profile-settings-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border-color);\n  gap: 8px;\n}\n.profile-settings-row:last-child { border-bottom: none; }\n\n.profile-contact-cta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);\n  border-radius: 10px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.profile-contact-cta:active { opacity: 0.85; }\n.profile-contact-icon-wrap {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  flex-shrink: 0;\n}\n.profile-contact-text { flex: 1; min-width: 0; }\n.profile-contact-label { font-size: var(--font-sm); font-weight: 700; color: #fff; }\n.profile-contact-sub   { font-size: var(--font-xs); color: rgba(255,255,255,0.8); margin-top: 2px; }\n\n.profile-settings-row-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.profile-settings-icon { color: var(--td-green); flex-shrink: 0; display: flex; }\n.profile-settings-label { font-size: var(--font-sm); color: var(--text-dark); }\n\n.profile-settings-row-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.profile-settings-value { font-size: var(--font-sm); color: var(--text-medium); max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n.profile-backend-chips {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.profile-chip {\n  padding: 3px 9px;\n  border-radius: 20px;\n  border: 1px solid var(--chip-color, var(--td-green));\n  background: transparent;\n  color: var(--chip-color, var(--td-green));\n  font-size: var(--font-xs);\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s, color 0.15s;\n}\n.profile-chip.active {\n  background: var(--chip-color, var(--td-green));\n  color: #fff;\n}\n\n/* Progress bar — used by DashboardScreen for pinned-goal progress */\n.progress-bar-bg { height: 8px; background: var(--border-color); border-radius: 4px; margin: 15px 0; overflow: hidden; }\n.progress-fill { height: 100%; background: var(--td-green); transition: width 1s ease-in-out; }\n\n/* --- Insights Screen Styling --- */\n\n.ins-scroll { padding: 12px 14px 80px; gap: 12px; display: flex; flex-direction: column; }\n\n.ins-card {\n  background: var(--bg-card);\n  border-radius: 14px;\n  padding: 14px 16px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n\n.ins-card-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 2px;\n}\n.ins-card-title { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); flex: 1; }\n.ins-card-sub   { font-size: var(--font-xs); color: var(--text-light); }\n\n.ins-donut-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 10px;\n}\n\n.ins-legend { flex: 1; display: flex; flex-direction: column; gap: 5px; }\n.ins-legend-row { display: flex; align-items: center; gap: 6px; }\n.ins-legend-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }\n.ins-legend-label { font-size: var(--font-sm); color: var(--text-medium); flex: 1; }\n.ins-legend-val   { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }\n\n.ins-chips-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.ins-chip {\n  background: var(--bg-card);\n  border-radius: 14px;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.ins-chip-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n.ins-chip-icon {\n  width: 30px; height: 30px;\n  border-radius: 8px;\n  display: flex; align-items: center; justify-content: center;\n  flex-shrink: 0;\n}\n.ins-chip-label { font-size: var(--font-xs); color: var(--text-light); text-transform: uppercase; letter-spacing: 0.4px; line-height: 1.3; }\n.ins-chip-value { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }\n.ins-chip-sub   { font-size: var(--font-xs); color: var(--text-medium); }\n\n/* On desktop the phone-viewport is a fixed 844px frame; flex: 1 handles height */\n/* --- CHART STYLES (recharts) --- */\n.rchart-container {\n  margin-top: 12px;\n  padding: 10px 4px 6px;\n  background: var(--bg-light-gray);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.rchart-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 8px 6px;\n}\n\n/* --- CSV EXPORT ICON --- */\n/* Compact icon button — uses FaFileCsv with a \"Download as CSV\" tooltip.\n   Inside .chart-with-export the icon is absolutely positioned in the\n   chart container's top-left padding area so it sits inline with the\n   chart canvas (below the title) WITHOUT pushing the chart sideways.\n   In the table-only case (no chart) the rule defaults apply and the\n   icon flows above the markdown table. */\n.chart-with-export {\n  position: relative;\n  margin-top: 8px;\n}\n.chart-with-export-body { width: 100%; }\n\n.chart-export-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  color: var(--td-green);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0.78;\n  transition: opacity 150ms ease-in-out, color 150ms ease-in-out, background 150ms ease-in-out;\n}\n.chart-export-btn:hover {\n  opacity: 1;\n  color: var(--td-dark-green);\n  background: var(--td-green-light);\n}\n.chart-export-btn:focus-visible {\n  outline: 2px solid var(--td-green);\n  outline-offset: 2px;\n}\n\n/* Float the icon at the chart container's top-right corner, vertically\n   centered on the chart title row — gives the chart a clean header row\n   (title on the left, action on the right) instead of stealing space\n   from the canvas. */\n.chart-with-export .chart-export-btn {\n  position: absolute;\n  top: 16px;     /* centers the 28px button on the ~16px title at top of container */\n  right: 4px;    /* inside the chart container's right padding */\n  z-index: 2;\n}\n\n/* --- RETRY STYLES --- */\n.failed-bubble {\n  border: 1px solid #ffcccc !important;\n  background: #fff8f8 !important;\n}\n\n.retry-button {\n  display: inline-block;\n  margin-top: 8px;\n  padding: 4px 12px;\n  background: none;\n  border: 1px solid #008a0d;\n  color: #008a0d;\n  border-radius: 12px;\n  font-size: var(--font-sm);\n  cursor: pointer;\n  line-height: 1.4;\n}\n\n.retry-button:hover {\n  background: #f0faf0;\n}\n\n/* --- CHAT PIN BUTTON --- */\n.chat-pin-btn {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 5px;\n  padding: 3px 10px;\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  cursor: pointer;\n  align-self: flex-start;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.chat-pin-btn:hover {\n  background: var(--bg-light-gray);\n  color: var(--text-medium);\n}\n\n.chat-pin-btn.pinned {\n  background: var(--td-green);\n  border-color: var(--td-green);\n  color: white;\n}\n\n/* --- ADVISOR CTA (in-chat escalation banner) --- */\n.advisor-cta-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n  margin-top: 8px;\n  padding: 10px 12px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-left: 3px solid #448889;\n  border-radius: 12px;\n}\n\n.advisor-cta-icon {\n  color: #448889;\n  flex-shrink: 0;\n}\n\n.advisor-cta-text {\n  flex: 1;\n  min-width: 0;\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  line-height: 1.4;\n}\n\n.advisor-cta-connect {\n  flex-shrink: 0;\n  padding: 5px 14px;\n  border: none;\n  border-radius: 14px;\n  background: #448889;\n  color: #fff;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.advisor-cta-connect:hover {\n  filter: brightness(1.08);\n}\n\n.advisor-cta-dismiss {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border: none;\n  background: none;\n  color: var(--text-light);\n  cursor: pointer;\n}\n\n.advisor-cta-dismiss:hover {\n  color: var(--text-medium);\n}\n\n/* --- DASHBOARD SCREEN --- */\n.dashboard-screen {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-screen);\n}\n\n.dashboard-header {\n  padding: 20px 20px 14px;\n  background: var(--td-green);\n  color: white;\n}\n\n.dashboard-header h2 {\n  margin: 0;\n  font-size: var(--font-xl);\n  font-weight: 700;\n}\n\n.dashboard-header p {\n  margin: 4px 0 0;\n  font-size: var(--font-sm);\n  opacity: 0.85;\n}\n\n.dashboard-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(128,128,128,0.2) transparent;\n}\n.dashboard-scroll::-webkit-scrollbar { width: 4px; }\n.dashboard-scroll::-webkit-scrollbar-track { background: transparent; }\n.dashboard-scroll::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }\n.dashboard-scroll::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }\n\n.dashboard-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 40px 24px;\n  text-align: center;\n  color: var(--text-light);\n}\n\n.dashboard-empty-icon {\n  font-size: var(--font-3xl);\n  margin-bottom: 14px;\n  opacity: 0.5;\n}\n\n.dashboard-empty h3 {\n  margin: 0 0 8px;\n  font-size: var(--font-lg);\n  color: var(--text-medium);\n}\n\n.dashboard-empty p {\n  margin: 0;\n  font-size: var(--font-base);\n  line-height: 1.5;\n}\n\n/* Dashboard cards */\n.dashboard-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  overflow: hidden;\n  color: var(--text-dark);\n}\n\n.dashboard-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.dashboard-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dashboard-card-timestamp {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n}\n\n.dashboard-card-label {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.dashboard-card-unpin {\n  background: none;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 4px 8px;\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  cursor: pointer;\n}\n\n.dashboard-card-unpin:hover {\n  background: var(--bg-light-gray);\n  color: var(--text-medium);\n}\n\n.dashboard-card-body {\n  padding: 12px 14px;\n}\n\n/* Goal widget inside dashboard card */\n.goal-widget {\n  margin-top: 10px;\n  padding: 12px;\n  background: var(--bg-light-gray);\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n}\n\n.goal-widget-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.goal-widget-name {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.goal-widget-target-label {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  margin-top: 2px;\n}\n\n.goal-widget-badge {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  background: var(--td-green);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.goal-widget-bar-track {\n  height: 10px;\n  background: var(--border-color);\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 6px;\n}\n\n.goal-widget-bar-fill {\n  height: 100%;\n  background: var(--td-green);\n  border-radius: 6px;\n  transition: width 0.6s ease;\n}\n\n.goal-widget-amounts {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n}\n\n.goal-widget-current {\n  font-weight: 700;\n  color: var(--td-green);\n}\n\n.goal-widget-footer {\n  margin-top: 6px;\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  text-align: center;\n}\n\n/* --- CHAT HISTORY SCREEN --- */\n.chat-history-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 24px;\n  text-align: center;\n  color: var(--text-light);\n}\n\n.chat-history-empty-icon {\n  font-size: var(--font-3xl);\n  margin-bottom: 14px;\n  opacity: 0.45;\n}\n\n.chat-history-empty h3 {\n  margin: 0 0 8px;\n  font-size: var(--font-lg);\n  color: var(--text-medium);\n}\n\n.chat-history-empty p {\n  margin: 0;\n  font-size: var(--font-base);\n  line-height: 1.5;\n}\n\n.chat-history-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.chat-history-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  cursor: pointer;\n}\n\n.chat-history-card-header:hover {\n  background: var(--bg-light-gray);\n}\n\n.chat-history-card-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.chat-history-preview {\n  font-size: var(--font-base);\n  font-weight: 500;\n  color: var(--text-dark);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 3px;\n}\n\n.chat-history-info {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n}\n\n.chat-history-resume-btn {\n  background: var(--td-green);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 5px 10px;\n  font-size: var(--font-sm);\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.chat-history-resume-btn:hover {\n  opacity: 0.85;\n}\n\n.chat-history-chevron {\n  color: var(--text-light);\n  font-size: var(--font-xl);\n  flex-shrink: 0;\n}\n\n.chat-history-thread {\n  border-top: 1px solid var(--border-color);\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 400px;\n  overflow-y: auto;\n  background: var(--bg-light-gray);\n}\n\n.chat-history-msg {\n  display: flex;\n}\n\n.chat-history-msg.user {\n  justify-content: flex-end;\n}\n\n.chat-history-msg.bot {\n  justify-content: flex-start;\n}\n\n.chat-history-bubble {\n  max-width: 78%;\n  padding: 8px 12px;\n  border-radius: 14px;\n  font-size: var(--font-sm);\n  line-height: 1.45;\n  color: var(--text-dark);\n}\n\n.chat-history-msg.user .chat-history-bubble {\n  background: var(--td-green);\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.chat-history-msg.bot .chat-history-bubble {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-bottom-left-radius: 4px;\n}\n\n.chat-history-msg.bot .chat-history-bubble p {\n  margin: 0 0 6px;\n}\n\n.chat-history-msg.bot .chat-history-bubble p:last-child {\n  margin: 0;\n}\n\n.chat-history-subtitle {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* --- CHAT SUMMARY DIVIDER --- */\n.chat-summary-divider {\n  margin: 16px 12px;\n  border: 1px dashed var(--border-color);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--bg-light-gray);\n}\n\n.chat-summary-label {\n  font-size: var(--font-2xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-medium);\n  padding: 5px 12px;\n  background: var(--border-color);\n  display: block;\n}\n\n.chat-summary-content {\n  padding: 10px 14px;\n  font-size: var(--font-sm);\n  color: var(--text-dark);\n}\n\n.chat-summary-content p { margin: 0 0 4px; }\n.chat-summary-content p:last-child { margin: 0; }\n.chat-summary-content ul, .chat-summary-content ol { margin: 4px 0; padding-left: 18px; }\n.chat-summary-content li { margin-bottom: 3px; }\n\n/* --- SPENDING TRENDS SCREEN --- */\n.st-hero {\n  background: var(--td-green);\n  padding: 20px 20px 16px;\n  text-align: center;\n  color: white;\n}\n.st-period-label { margin: 0 0 4px; font-size: var(--font-sm); opacity: 0.8; text-transform: uppercase; letter-spacing: 0.5px; }\n.st-total { margin: 0 0 4px; font-size: var(--font-3xl); font-weight: 700; line-height: 1.1; }\n.st-delta { margin: 0; font-size: var(--font-sm); }\n.st-delta.pos { color: #a8f0c6; }\n.st-delta.neg { color: #ffd0c0; }\n\n.st-toggle-row {\n  display: flex;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  padding: 10px 16px;\n  gap: 8px;\n}\n.st-toggle-btn {\n  flex: 1;\n  padding: 7px 0;\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  background: none;\n  color: var(--text-medium);\n  font-size: var(--font-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.st-toggle-btn.active {\n  background: var(--td-green);\n  border-color: var(--td-green);\n  color: white;\n}\n\n.st-chart-card {\n  background: var(--bg-card);\n  padding: 16px 12px 8px;\n  margin: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n}\n.st-chart {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  height: 140px;\n}\n.st-bar-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  justify-content: flex-end;\n  gap: 4px;\n}\n.st-bar-track {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n.st-bar-stack {\n  width: 70%;\n  min-width: 8px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 4px 4px 0 0;\n  overflow: hidden;\n  transition: height 0.4s ease;\n}\n.st-bar-seg { min-height: 2px; }\n.st-bar-label {\n  font-size: var(--font-2xs);\n  color: var(--text-light);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  text-align: center;\n}\n\n.st-breakdown-card {\n  background: var(--bg-card);\n  padding: 14px 16px;\n  margin: 0 12px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n}\n.st-breakdown-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  color: var(--text-light);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px;\n}\n.st-breakdown-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.st-cat-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }\n.st-cat-label { width: 62px; font-size: var(--font-sm); color: var(--text-dark); flex-shrink: 0; }\n.st-cat-bar-bg { flex: 1; height: 6px; background: var(--bg-light-gray); border-radius: 3px; overflow: hidden; }\n.st-cat-bar-fill { height: 100%; border-radius: 3px; transition: width 0.4s ease; }\n.st-cat-pct { width: 28px; font-size: var(--font-sm); color: var(--text-medium); text-align: right; flex-shrink: 0; }\n.st-cat-amt { width: 52px; font-size: var(--font-sm); color: var(--text-medium); text-align: right; flex-shrink: 0; }\n\n\n/* --- ICON BUTTON TOOLTIPS --- */\n.new-chat-button {\n  position: relative;\n}\n.new-chat-button[title]:hover::after {\n  content: attr(title);\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.78);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: var(--font-xs);\n  font-weight: 500;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 200;\n}\n\n/* --- MARKDOWN TABLE STYLES --- */\n.chat-bubble table,\n.dashboard-card-body table {\n  border-collapse: collapse;\n  width: 100%;\n  font-size: var(--font-sm);\n  margin: 8px 0;\n}\n.chat-bubble table th,\n.chat-bubble table td,\n.dashboard-card-body table th,\n.dashboard-card-body table td {\n  border: 1px solid var(--border-color);\n  padding: 5px 8px;\n  text-align: left;\n}\n.chat-bubble table th,\n.dashboard-card-body table th {\n  background: var(--bg-light-gray);\n  font-weight: 600;\n  color: var(--text-dark);\n}\n.chat-bubble table tr:nth-child(even),\n.dashboard-card-body table tr:nth-child(even) {\n  background: var(--bg-light-gray);\n}\n\n\n/* --- VISUALIZATION SCREEN --- */\n.viz-screen { background: #0f0f11; }\n\n.viz-header { background: #17171a !important; border-bottom: 1px solid #2a2a2f; }\n.viz-header .back-icon,\n.viz-header .header-title { color: #f0ede8 !important; }\n\n.viz-content { background: #0f0f11; }\n\n.viz-profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 20px 16px 16px;\n  border-bottom: 1px solid #2a2a2f;\n  gap: 12px;\n}\n\n.viz-label {\n  font-size: var(--font-2xs);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: #7a7a82;\n  margin-bottom: 4px;\n}\n\n.viz-name {\n  font-size: var(--font-2xl);\n  font-weight: 700;\n  color: #f0ede8;\n  line-height: 1.1;\n}\n\n.viz-subtitle { font-size: var(--font-xs); color: #7a7a82; margin-top: 5px; }\n\n.viz-period { font-size: var(--font-xs); color: #f0ede8; letter-spacing: 0.05em; }\n.viz-txn-count { font-size: var(--font-xs); color: #7a7a82; margin-top: 3px; }\n\n.viz-stat-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  padding: 16px;\n}\n\n.viz-stat-card {\n  background: #17171a;\n  border: 1px solid #2a2a2f;\n  border-radius: 6px;\n  padding: 14px 12px;\n  position: relative;\n  overflow: hidden;\n}\n.viz-stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 2px;\n}\n.viz-yellow::before { background: #e8c547; }\n.viz-green::before  { background: #7ec8a4; }\n.viz-red::before    { background: #e87c6a; }\n.viz-blue::before   { background: #7aaee8; }\n\n.viz-stat-label {\n  font-size: var(--font-2xs);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #7a7a82;\n  margin-bottom: 6px;\n}\n.viz-stat-value { font-size: var(--font-xl); font-weight: 700; color: #f0ede8; line-height: 1; }\n.viz-stat-sub { font-size: var(--font-xs); color: #7a7a82; margin-top: 5px; line-height: 1.3; }\n\n.viz-chart-card {\n  background: #17171a;\n  border: 1px solid #2a2a2f;\n  border-radius: 6px;\n  padding: 16px;\n  margin: 0 16px 12px;\n}\n.viz-chart-title { font-size: var(--font-base); font-weight: 600; color: #f0ede8; margin-bottom: 2px; }\n.viz-chart-sub {\n  font-size: var(--font-2xs);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #7a7a82;\n  margin-bottom: 14px;\n}\n\n.viz-insights {\n  padding: 4px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.viz-insight {\n  background: #17171a;\n  border: 1px solid #2a2a2f;\n  border-radius: 6px;\n  padding: 14px;\n}\n.viz-insight-icon { font-size: var(--font-lg); margin-bottom: 6px; }\n.viz-insight-title {\n  font-size: var(--font-xs);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #e8c547;\n  margin-bottom: 6px;\n}\n.viz-insight-body { font-size: var(--font-sm); color: #7a7a82; line-height: 1.65; }\n.viz-insight-body strong { color: #f0ede8; }\n\n.viz-footer {\n  margin: 0 16px 28px;\n  padding-top: 14px;\n  border-top: 1px solid #2a2a2f;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: var(--font-2xs);\n  letter-spacing: 0.08em;\n  color: #7a7a82;\n}\n\n/* BUDGET RULE SCREEN (70-20-10) */\n\n.budget-banner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 16px 14px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n.budget-banner-name { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }\n.budget-banner-sub  { font-size: var(--font-xs); color: var(--text-medium); margin-top: 3px; text-transform: uppercase; letter-spacing: 0.06em; }\n.budget-banner-income { font-size: var(--font-2xl); font-weight: 700; color: var(--td-green); white-space: nowrap; }\n.budget-banner-mo { font-size: var(--font-sm); font-weight: 400; color: var(--text-medium); }\n\n.budget-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-medium);\n  margin-bottom: 6px;\n}\n\n.budget-rule-card {\n  background: var(--bg-card);\n  border-radius: 10px;\n  margin: 0 12px 10px;\n  padding: 14px 15px;\n  border-left: 3px solid var(--border-color);\n}\n.budget-rule-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.budget-rule-label { font-size: var(--font-sm); font-weight: 700; }\n.budget-rule-target-pct { font-size: var(--font-xs); font-weight: 400; color: var(--text-medium); }\n.budget-rule-desc { font-size: var(--font-xs); color: var(--text-medium); margin-top: 3px; line-height: 1.4; }\n.budget-rule-status {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  padding: 3px 9px;\n  border-radius: 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.budget-bar-track {\n  position: relative;\n  height: 10px;\n  background: var(--border-color);\n  border-radius: 5px;\n  overflow: visible;\n  margin-bottom: 6px;\n}\n.budget-bar-fill {\n  height: 100%;\n  border-radius: 5px;\n  transition: width 0.8s ease-in-out;\n}\n.budget-bar-marker {\n  position: absolute;\n  top: -5px;\n  bottom: -5px;\n  width: 2px;\n  background: var(--text-dark);\n  border-radius: 2px;\n  opacity: 0.45;\n}\n.budget-bar-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: var(--font-sm);\n}\n\n.budget-insight {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: var(--bg-card);\n  border-radius: 8px;\n  padding: 11px 13px;\n  margin-bottom: 8px;\n  border-left: 3px solid var(--border-color);\n}\n.budget-insight-icon { font-size: var(--font-lg); flex-shrink: 0; margin-top: 1px; }\n.budget-insight-text { font-size: var(--font-sm); color: var(--text-medium); line-height: 1.55; }\n\n/* ── Voice Bot Screen ─────────────────────────────────────────────────────── */\n@keyframes vb-pulse {\n  0%   { transform: scale(1);    opacity: 0.6; }\n  50%  { transform: scale(1.18); opacity: 0.15; }\n  100% { transform: scale(1);    opacity: 0; }\n}\n@keyframes vb-ring {\n  0%   { transform: scale(0.95); opacity: 0.7; }\n  100% { transform: scale(1.6);  opacity: 0; }\n}\n@keyframes vb-wave {\n  0%, 100% { height: 6px;  }\n  50%       { height: 22px; }\n}\n@keyframes vb-thinking {\n  0%, 80%, 100% { transform: scale(0); opacity: 0.3; }\n  40%           { transform: scale(1); opacity: 1;   }\n}\n@keyframes vb-fade-in {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0);   }\n}\n\n.vb-screen {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-screen);\n  overflow: hidden;\n  padding-bottom: 0 !important;\n}\n.vb-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px 10px;\n  background: var(--td-green);\n  flex-shrink: 0;\n}\n.vb-header-title {\n  font-size: var(--font-lg);\n  font-weight: 700;\n  color: #fff;\n  flex: 1;\n  text-align: center;\n}\n.vb-header-action {\n  background: none;\n  border: none;\n  color: rgba(255,255,255,0.85);\n  font-size: var(--font-xs);\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 6px;\n  white-space: nowrap;\n}\n.vb-header-action.active { color: #fff; font-weight: 700; }\n\n.vb-history {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(128,128,128,0.2) transparent;\n}\n.vb-history::-webkit-scrollbar { width: 4px; }\n.vb-history::-webkit-scrollbar-track { background: transparent; }\n.vb-history::-webkit-scrollbar-thumb { background: rgba(128,128,128,0.2); border-radius: 4px; }\n.vb-history::-webkit-scrollbar-thumb:hover { background: rgba(128,128,128,0.4); }\n.vb-bubble {\n  max-width: 82%;\n  padding: 9px 13px;\n  border-radius: 16px;\n  font-size: var(--font-sm);\n  line-height: 1.5;\n  animation: vb-fade-in 0.25s ease;\n  flex-shrink: 0;\n}\n.vb-bubble.user {\n  align-self: flex-end;\n  background: var(--td-green);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n.vb-bubble.bot {\n  align-self: flex-start;\n  background: var(--bg-card);\n  color: var(--text-dark);\n  border: 1px solid var(--border-color);\n  border-bottom-left-radius: 4px;\n  text-align: left;\n}\n.vb-bubble.vb-bubble-wide {\n  max-width: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ── Agent Flow Card ─────────────────────────────────────── */\n.agent-card {\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  background: var(--bg-card);\n  border: 2px solid var(--td-green);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.25);\n  animation: vb-fade-in 0.3s ease;\n}\n.agent-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: var(--td-green);\n  color: #fff;\n}\n.agent-robot-icon {\n  font-size: var(--font-2xl);\n  line-height: 1;\n  flex-shrink: 0;\n}\n@keyframes agent-pulse {\n  0%,100% { transform: scale(1); }\n  50%      { transform: scale(1.2); filter: brightness(1.4); }\n}\n.agent-robot-pulse { animation: agent-pulse 1s ease-in-out infinite; }\n.agent-card-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #fff;\n  margin-bottom: 2px;\n}\n.agent-card-command {\n  font-size: var(--font-sm);\n  color: rgba(255,255,255,0.85);\n  font-style: italic;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.agent-badge {\n  margin-left: auto;\n  flex-shrink: 0;\n  font-size: var(--font-xs);\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: 20px;\n  letter-spacing: 0.3px;\n}\n.agent-badge-running { background: rgba(255,255,255,0.25); color: #fff; }\n.agent-badge-done    { background: rgba(255,255,255,0.25); color: #fff; }\n\n.agent-steps {\n  padding: 10px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n/* Steps are only added to DOM when revealed — vb-fade-in fires automatically */\n.agent-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: var(--font-sm);\n  color: var(--text-dark);\n  animation: vb-fade-in 0.3s ease;\n}\n.agent-step-status {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--td-green);\n  color: #fff;\n  font-size: var(--font-xs);\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.agent-step-emoji { font-size: var(--font-base); flex-shrink: 0; }\n\n@keyframes agent-spin { to { transform: rotate(360deg); } }\n.agent-step-spinner {\n  display: inline-block;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  border: 2px solid rgba(255,255,255,0.4);\n  border-top-color: #fff;\n  animation: agent-spin 0.6s linear infinite;\n}\n\n.agent-stub-footer {\n  padding: 8px 14px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-light-gray);\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  text-align: center;\n  animation: vb-fade-in 0.3s ease;\n}\n.vb-bubble-label {\n  font-size: var(--font-xs);\n  opacity: 0.55;\n  margin-bottom: 3px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.vb-orb-area {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 18px 0 12px;\n  background: var(--bg-screen);\n  border-top: 1px solid var(--border-color);\n}\n.vb-status {\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  margin-bottom: 16px;\n  letter-spacing: 0.3px;\n  min-height: 18px;\n}\n.vb-status.listening { color: #ef4444; font-weight: 600; }\n.vb-status.thinking  { color: var(--td-green); font-weight: 600; }\n.vb-status.speaking  { color: #f59e0b; font-weight: 600; }\n\n/* Mic button + rings */\n.vb-mic-wrap {\n  position: relative;\n  width: 88px;\n  height: 88px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.vb-ring {\n  position: absolute;\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  background: transparent;\n  border: 2px solid var(--td-green);\n  animation: vb-ring 1.4s ease-out infinite;\n  pointer-events: none;\n}\n.vb-ring:nth-child(2) { animation-delay: 0.35s; }\n.vb-ring:nth-child(3) { animation-delay: 0.70s; }\n\n.vb-mic-btn {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-2xl);\n  transition: transform 0.15s, box-shadow 0.15s;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.18);\n}\n.vb-mic-btn:active { transform: scale(0.94); }\n.vb-stop-btn {\n  position: absolute;\n  bottom: -10px;\n  right: -10px;\n  background: var(--text-medium);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n  z-index: 2;\n}\n.vb-stop-btn:hover { background: var(--text-dark); }\n.vb-mic-btn.idle      { background: var(--td-green); color: #fff; }\n.vb-mic-btn.vb-mic-stop { background: var(--td-green); color: #fff; }\n.vb-mic-btn.listening { background: #ef4444; color: #fff; box-shadow: 0 4px 20px rgba(239,68,68,0.4); }\n.vb-mic-btn.thinking  { background: var(--bg-card); color: var(--text-medium); cursor: default; }\n.vb-mic-btn.speaking  { background: #f59e0b; color: #fff; }\n\n/* Thinking dots */\n.vb-dots { display: flex; gap: 5px; align-items: center; }\n.vb-thinking-row { display: flex; gap: 6px; align-items: center; padding: 4px 0; }\n.vb-dot {\n  width: 7px; height: 7px; border-radius: 50%;\n  background: var(--text-medium);\n  animation: vb-thinking 1.2s infinite ease-in-out;\n}\n.vb-dot:nth-child(1) { animation-delay: 0s;    }\n.vb-dot:nth-child(2) { animation-delay: 0.2s;  }\n.vb-dot:nth-child(3) { animation-delay: 0.4s;  }\n\n/* Speaker wave bars */\n.vb-wave { display: flex; gap: 3px; align-items: center; height: 24px; }\n.vb-bar {\n  width: 4px; border-radius: 3px;\n  background: #f59e0b;\n  animation: vb-wave 0.7s ease-in-out infinite;\n}\n.vb-bar:nth-child(1) { animation-delay: 0s;    }\n.vb-bar:nth-child(2) { animation-delay: 0.1s;  }\n.vb-bar:nth-child(3) { animation-delay: 0.2s;  }\n.vb-bar:nth-child(4) { animation-delay: 0.1s;  }\n.vb-bar:nth-child(5) { animation-delay: 0s;    }\n\n.vb-transcript {\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  font-style: italic;\n  margin-top: 12px;\n  min-height: 18px;\n  text-align: center;\n  padding: 0 20px;\n  max-width: 280px;\n}\n.vb-hint {\n  font-size: var(--font-xs);\n  color: var(--text-light, #aaa);\n  margin-top: 8px;\n  text-align: center;\n}\n.vb-no-support {\n  text-align: center;\n  padding: 40px 24px;\n  color: var(--text-medium);\n  font-size: var(--font-sm);\n  line-height: 1.6;\n}\n\n/* ============================================================\n   EMAIL MONEY TRANSFER + BILL PAYMENT — shared & screen styles\n   ============================================================ */\n\n/* Shared section card */\n.emt-section {\n  background: var(--bg-card);\n  border-radius: 12px;\n  margin: 0 14px 12px;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n}\n.emt-section-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-light);\n  padding: 10px 14px 6px;\n}\n\n/* Account selector rows (used by AccountTransferScreen radio list) */\n.emt-account-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  cursor: pointer;\n  box-sizing: border-box;\n  border-top: 1px solid var(--border-color);\n  transition: background 160ms ease;\n}\n.emt-account-row:first-of-type { border-top: none; }\n/* Translucent tint (not the solid light-green token) so the row text stays\n   readable in both light and dark themes. */\n.emt-account-row.selected { background: rgba(47, 191, 0, 0.14); }\n.emt-account-info { flex: 1; min-width: 0; }\n.emt-account-name { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }\n.emt-account-num  { font-size: var(--font-xs); color: var(--text-light); margin-top: 2px; }\n.emt-account-right { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }\n.emt-account-balance { font-size: var(--font-sm); font-weight: 600; color: var(--td-green); white-space: nowrap; }\n.emt-radio {\n  width: 20px; height: 20px; border-radius: 50%;\n  border: 2px solid var(--border-color); flex-shrink: 0;\n  box-sizing: border-box; transition: border-color 160ms ease;\n}\n.emt-radio.on {\n  border-color: var(--td-green);\n  background: radial-gradient(circle, var(--td-green) 0 5px, transparent 6px);\n}\n\n/* Field label (legacy uppercase-overline used inside emt-section) */\n.emt-field { padding: 0 14px 12px; border-top: 1px solid var(--border-color); padding-top: 10px; }\n.emt-field:first-of-type { border-top: none; }\n.emt-label {\n  display: flex; align-items: center;\n  font-size: var(--font-xs); font-weight: 600; color: var(--text-medium);\n  margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.05em;\n}\n.emt-error { font-size: var(--font-xs); color: #ef4444; margin-top: 4px; }\n\n/* Amount input */\n.emt-amount-wrapper {\n  display: flex; align-items: center; gap: 8px;\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 8px 14px;\n  margin: 0 14px;\n  transition: border-color 0.15s;\n}\n.emt-amount-wrapper:focus-within { border-color: var(--td-green); }\n.emt-amount-wrapper.error { border-color: #ef4444; }\n.emt-currency-symbol { font-size: var(--font-xl); font-weight: 700; color: var(--text-medium); }\n.emt-amount-input {\n  flex: 1; background: none; border: none; outline: none;\n  font-size: var(--font-2xl); font-weight: 700; color: var(--text-dark);\n  font-family: inherit; min-width: 0;\n}\n.emt-amount-input::placeholder { color: var(--text-light); }\n.emt-currency-code { font-size: var(--font-sm); font-weight: 600; color: var(--text-light); align-self: flex-end; padding-bottom: 4px; }\n\n/* Quick amount pills (legacy — new EMT uses .bh-quick-amounts) */\n.emt-quick-amounts { display: flex; gap: 6px; padding: 10px 14px 14px; flex-wrap: wrap; }\n\n/* Textarea */\n.emt-textarea {\n  width: 100%; box-sizing: border-box;\n  background: var(--bg-light-gray); border: 1px solid var(--border-color);\n  border-radius: 8px; padding: 10px 12px; font-size: var(--font-sm);\n  color: var(--text-dark); font-family: inherit; outline: none; resize: none;\n  margin: 0 0 4px;\n}\n.emt-textarea:focus { border-color: var(--td-green); }\n.emt-textarea::placeholder { color: var(--text-light); }\n\n/* Primary & ghost buttons */\n.emt-primary-btn {\n  display: flex; align-items: center; justify-content: center;\n  width: calc(100% - 28px); margin: 8px 14px 4px;\n  padding: 14px; border-radius: 10px; border: none;\n  background: var(--td-green); color: #fff;\n  font-size: var(--font-base); font-weight: 700; cursor: pointer; font-family: inherit;\n  transition: opacity 0.15s;\n}\n.emt-primary-btn:hover { opacity: 0.88; }\n.emt-ghost-btn {\n  display: block; width: calc(100% - 28px); margin: 0 14px 16px;\n  padding: 12px; border-radius: 10px;\n  border: 1px solid var(--border-color); background: transparent;\n  color: var(--text-medium); font-size: var(--font-base); font-weight: 600;\n  cursor: pointer; font-family: inherit; transition: border-color 0.12s;\n}\n.emt-ghost-btn:hover { border-color: var(--text-medium); }\n\n/* Review screen */\n.emt-review-amount {\n  font-size: var(--font-3xl); font-weight: 800; text-align: center;\n  color: var(--text-dark); padding: 28px 0 16px;\n}\n.emt-review-row {\n  display: flex; align-items: flex-start; justify-content: space-between;\n  padding: 11px 14px; border-top: 1px solid var(--border-color);\n}\n.emt-review-row:first-of-type { border-top: none; }\n.emt-review-label { font-size: var(--font-sm); color: var(--text-light); flex-shrink: 0; width: 70px; padding-top: 1px; }\n.emt-review-value { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); text-align: right; line-height: 1.4; }\n.emt-notice {\n  margin: 0 14px 14px; padding: 10px 12px;\n  background: var(--bg-light-gray); border-radius: 8px;\n  border-left: 3px solid var(--td-green);\n  font-size: var(--font-xs); color: var(--text-medium); line-height: 1.5;\n}\n\n/* Success state */\n.emt-success-body {\n  flex: 1; display: flex; flex-direction: column;\n  align-items: center; justify-content: center;\n  padding: 32px 24px; text-align: center;\n}\n.emt-success-circle {\n  width: 80px; height: 80px; border-radius: 50%;\n  background: rgba(106,85,247,0.1);\n  display: flex; align-items: center; justify-content: center;\n  margin-bottom: 18px;\n}\n.emt-success-title { font-size: var(--font-xl); font-weight: 800; color: var(--text-dark); margin-bottom: 8px; }\n.emt-success-amount { font-size: var(--font-3xl); font-weight: 800; color: var(--td-green); }\n.emt-success-sub { font-size: var(--font-base); color: var(--text-medium); margin-top: 4px; }\n.emt-success-eta {\n  margin-top: 16px; padding: 8px 16px; border-radius: 20px;\n  background: var(--bg-light-gray); border: 1px solid var(--border-color);\n  font-size: var(--font-sm); color: var(--text-medium);\n}\n\n/* ---- Bill Payment specific ---- */\n\n.bp-search-bar {\n  display: flex; align-items: center; gap: 8px;\n  background: var(--bg-card); border-bottom: 1px solid var(--border-color);\n  padding: 8px 14px; flex-shrink: 0;\n}\n.bp-search-input {\n  flex: 1; background: var(--bg-light-gray); border: 1px solid var(--border-color);\n  border-radius: 8px; padding: 8px 12px; font-size: var(--font-sm);\n  color: var(--text-dark); font-family: inherit; outline: none;\n}\n.bp-search-input::placeholder { color: var(--text-light); }\n.bp-search-input:focus { border-color: var(--td-green); }\n\n.bp-payee-row {\n  display: flex; align-items: center; gap: 12px;\n  padding: 13px 16px; background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  cursor: pointer; transition: background 0.1s;\n}\n.bp-payee-row:hover { background: var(--bg-light-gray); }\n.bp-payee-logo-sm { font-size: var(--font-xl); flex-shrink: 0; width: 28px; text-align: center; }\n.bp-payee-row-name { flex: 1; font-size: var(--font-base); font-weight: 500; color: var(--text-dark); }\n\n.bp-payee-banner {\n  display: flex; align-items: center; gap: 12px;\n  background: var(--bg-card); border-bottom: 1px solid var(--border-color);\n  border-radius: 12px; margin: 14px 14px 0;\n  padding: 14px; border: 1px solid var(--border-color);\n}\n.bp-payee-logo { font-size: var(--font-2xl); flex-shrink: 0; }\n.bp-payee-banner-name { font-size: var(--font-base); font-weight: 700; color: var(--text-dark); }\n.bp-payee-banner-cat  { font-size: var(--font-xs); color: var(--text-light); margin-top: 2px; }\n.bp-change-btn {\n  margin-left: auto; padding: 5px 12px; border-radius: 6px;\n  background: var(--bg-light-gray); border: 1px solid var(--border-color);\n  font-size: var(--font-sm); font-weight: 600; color: var(--td-green); cursor: pointer; font-family: inherit;\n}\n\n.bp-date-row {\n  display: flex; justify-content: space-between; align-items: center;\n  padding: 12px 14px;\n}\n.bp-date-label { font-size: var(--font-sm); font-weight: 600; color: var(--text-dark); }\n.bp-date-value { font-size: var(--font-sm); color: var(--text-medium); }\n\n/* --- Services Hub Screen --- */\n.services-screen .simple-header { justify-content: flex-start; }\n\n.services-icon-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px 8px;\n  padding: 16px 12px;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.services-icon-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 0;\n  font-family: inherit;\n}\n\n.services-icon-tile:disabled { opacity: 0.45; cursor: default; }\n\n.services-icon-circle {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.18);\n  transition: transform 0.15s;\n}\n\n.services-icon-tile:not(:disabled):active .services-icon-circle { transform: scale(0.92); }\n\n.services-icon-tile span {\n  font-size: var(--font-xs);\n  font-weight: 500;\n  color: var(--text-dark);\n  text-align: center;\n  line-height: 1.3;\n}\n\n.services-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-light);\n  padding: 16px 16px 8px;\n}\n\n.services-featured-list {\n  background: var(--bg-card);\n  border-radius: 12px;\n  margin: 0 12px 16px;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n}\n\n.services-featured-item {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-color);\n  transition: background 0.1s;\n}\n\n.services-featured-item:last-child { border-bottom: none; }\n.services-featured-item:hover { background: var(--bg-light-gray); }\n\n.services-featured-text { flex: 1; }\n.services-featured-title { font-size: var(--font-base); font-weight: 600; color: var(--text-dark); }\n.services-featured-sub   { font-size: var(--font-sm); color: var(--text-medium); margin-top: 2px; }\n\n/* ============================================================\n   ACCOUNT TRANSFER SCREEN  (.acct-transfer-)\n   ============================================================ */\n.acct-transfer-ref {\n  font-size: var(--font-sm);\n  color: var(--text-light);\n  margin-top: 8px;\n  letter-spacing: 0.04em;\n}\n\n/* ============================================================\n   MOBILE DEPOSIT SCREEN  (.mob-deposit-)\n   ============================================================ */\n.mob-deposit-capture-row {\n  display: flex;\n  gap: 12px;\n  padding: 0 14px 14px;\n}\n.mob-deposit-capture-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 2px dashed var(--border-color);\n  border-radius: 12px;\n  padding: 20px 8px;\n  cursor: pointer;\n  background: var(--bg-light-gray);\n  transition: border-color 0.15s, background 0.15s;\n}\n.mob-deposit-capture-box.done {\n  border-color: var(--td-green);\n  background: rgba(0,138,62,0.06);\n}\n.mob-deposit-capture-box.error { border-color: #e53e3e; }\n.mob-deposit-capture-label {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-dark);\n  text-align: center;\n}\n.mob-deposit-capture-sub {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  text-align: center;\n}\n.mob-deposit-availability {\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  margin-top: 6px;\n  background: var(--bg-light-gray);\n  border-radius: 8px;\n  padding: 8px 16px;\n}\n\n/* ============================================================\n   CROSS-BORDER SCREEN  (.cross-border-)\n   ============================================================ */\n.cross-border-rate-banner {\n  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 100%);\n  color: white;\n  padding: 18px 20px;\n  text-align: center;\n}\n.cross-border-rate-label {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.85;\n  margin-bottom: 4px;\n}\n.cross-border-rate-value {\n  font-size: var(--font-xl);\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n.cross-border-rate-time {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xs);\n  opacity: 0.75;\n}\n.cross-border-balances {\n  display: flex;\n  gap: 12px;\n  padding: 14px 14px 4px;\n}\n.cross-border-balance-card {\n  flex: 1;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 14px;\n  text-align: center;\n}\n.cross-border-balance-cur {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--td-green);\n  text-transform: uppercase;\n}\n.cross-border-balance-name {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin: 3px 0;\n}\n.cross-border-balance-amt {\n  font-size: var(--font-lg);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.cross-border-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-light);\n  padding: 14px 14px 6px;\n}\n.cross-border-service-row {\n  display: flex;\n  align-items: center;\n  padding: 13px 14px;\n  border-top: 1px solid var(--border-color);\n  cursor: pointer;\n}\n.cross-border-service-row:first-child { border-top: none; }\n.cross-border-service-name {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-dark);\n}\n.cross-border-service-sub {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 2px;\n}\n.cross-border-soon-badge {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  color: var(--text-medium);\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 3px 8px;\n  white-space: nowrap;\n}\n.cross-border-swap-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 16px 14px 12px;\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 4px;\n}\n.cross-border-cur-pill {\n  background: var(--bg-light-gray);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 8px 20px;\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n  min-width: 60px;\n  text-align: center;\n}\n.cross-border-swap-btn {\n  background: var(--td-green);\n  border: none;\n  border-radius: 50%;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.cross-border-quote-result {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  padding: 10px 16px 8px;\n  background: rgba(0,138,62,0.06);\n  margin: 0 16px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(0,138,62,0.2);\n}\n.cross-border-quote-label {\n  font-size: var(--font-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-medium);\n}\n.cross-border-quote-value {\n  font-size: var(--font-xl);\n  font-weight: 700;\n  color: var(--td-green);\n}\n.cross-border-quote-note {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  text-align: center;\n}\n\n/* ============================================================\n   AUTO SERVICES SCREEN  (.auto-svc-)\n   ============================================================ */\n.auto-svc-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-light);\n  padding: 14px 14px 6px;\n}\n.auto-svc-vehicle-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 12px 12px 0 0;\n  margin: 0 14px;\n  padding: 16px 14px;\n  border-bottom: none;\n}\n.auto-svc-vehicle-icon {\n  width: 48px;\n  height: 48px;\n  background: rgba(0,138,62,0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.auto-svc-vehicle-name {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.auto-svc-vehicle-sub {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 3px;\n}\n.auto-svc-insurer-row {\n  display: flex;\n  align-items: center;\n  padding: 14px 14px 10px;\n  border-bottom: 1px solid var(--border-color);\n}\n.auto-svc-insurer-name {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.auto-svc-insurer-sub {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 2px;\n}\n.auto-svc-outline-btn {\n  display: block;\n  width: calc(100% - 28px);\n  margin: 4px 14px 14px;\n  padding: 11px;\n  background: transparent;\n  border: 1.5px solid var(--td-green);\n  border-radius: 10px;\n  color: var(--td-green);\n  font-size: var(--font-base);\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n}\n.auto-svc-contact-row {\n  display: flex;\n  align-items: flex-start;\n  padding: 14px;\n}\n.auto-svc-finance-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 100%);\n  border-radius: 12px;\n  margin: 6px 14px 0;\n  padding: 18px 16px;\n  cursor: pointer;\n}\n.auto-svc-finance-title {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: white;\n}\n.auto-svc-finance-sub {\n  font-size: var(--font-sm);\n  color: rgba(255,255,255,0.8);\n  margin-top: 3px;\n}\n\n/* ============================================================\n   PRE-AUTHORIZED PAYMENTS SCREEN  (.pre-auth-)\n   ============================================================ */\n.pre-auth-summary-bar {\n  display: flex;\n  align-items: center;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  padding: 14px 0;\n  margin-bottom: 8px;\n}\n.pre-auth-summary-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n}\n.pre-auth-summary-val {\n  font-size: var(--font-lg);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.pre-auth-summary-label {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.pre-auth-summary-divider {\n  width: 1px;\n  height: 30px;\n  background: var(--border-color);\n}\n.pre-auth-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-light);\n  padding: 10px 14px 6px;\n}\n.pre-auth-row {\n  display: flex;\n  align-items: center;\n  padding: 13px 14px;\n  border-top: 1px solid var(--border-color);\n  gap: 12px;\n}\n.pre-auth-row:first-child { border-top: none; }\n.pre-auth-icon-wrap {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.pre-auth-info { flex: 1; min-width: 0; }\n.pre-auth-merchant {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-dark);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.pre-auth-meta {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.pre-auth-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 5px;\n  flex-shrink: 0;\n}\n.pre-auth-amount {\n  font-size: var(--font-sm);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.pre-auth-manage-chip {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  color: var(--td-green);\n  background: rgba(0,138,62,0.1);\n  border: 1px solid rgba(0,138,62,0.25);\n  border-radius: 12px;\n  padding: 3px 9px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.pre-auth-manage-chip.pending {\n  color: #f5a623;\n  background: rgba(245,166,35,0.1);\n  border-color: rgba(245,166,35,0.3);\n}\n.pre-auth-popover {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.14);\n  z-index: 10;\n  overflow: hidden;\n  min-width: 120px;\n}\n.pre-auth-popover-item {\n  display: block;\n  width: 100%;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  border-top: 1px solid var(--border-color);\n  font-size: var(--font-sm);\n  font-weight: 500;\n  color: var(--text-dark);\n  text-align: left;\n  cursor: pointer;\n}\n.pre-auth-popover-item:first-child { border-top: none; }\n.pre-auth-popover-item.danger { color: #e53e3e; }\n.pre-auth-popover-item:hover { background: var(--bg-light-gray); }\n.pre-auth-add-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 28px);\n  margin: 14px 14px 4px;\n  padding: 13px;\n  background: transparent;\n  border: 1.5px dashed var(--border-color);\n  border-radius: 12px;\n  font-size: var(--font-base);\n  font-weight: 600;\n  color: var(--td-green);\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n.pre-auth-add-btn:hover {\n  background: rgba(0,138,62,0.05);\n  border-color: var(--td-green);\n}\n\n/* ============================================================\n   PORTFOLIO SCREEN  (.port-)\n   ============================================================ */\n\n/* Hero value banner */\n.port-hero {\n  background: linear-gradient(135deg, var(--td-dark-green) 0%, var(--td-green) 60%, var(--td-accent) 100%);\n  padding: 12px 16px 14px;\n  text-align: center;\n}\n.port-hero-label {\n  font-size: var(--font-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(255,255,255,0.7);\n  margin-bottom: 4px;\n}\n.port-hero-value {\n  font-size: var(--font-2xl);\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.5px;\n  margin-bottom: 6px;\n}\n.port-hero-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.port-daily-badge {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 20px;\n  font-size: var(--font-sm);\n  font-weight: 600;\n}\n.port-daily-badge.badge-up   { background: rgba(255,255,255,0.22); color: #c8ffd8; }\n.port-daily-badge.badge-down { background: rgba(255,80,80,0.25);   color: #ffc8c8; }\n.port-alltime-badge {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 20px;\n  font-size: var(--font-xs);\n  font-weight: 500;\n  background: rgba(255,255,255,0.12);\n  color: rgba(255,255,255,0.8);\n}\n.port-hero-profile {\n  font-size: var(--font-xs);\n  color: rgba(255,255,255,0.6);\n  margin-top: 8px;\n}\n\n/* Range selector */\n.port-range-row {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n.port-range-btn {\n  flex: 1;\n  padding: 4px 0;\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  background: transparent;\n  color: var(--text-medium);\n  font-size: var(--font-xs);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.port-range-btn.active {\n  background: var(--td-green);\n  color: #fff;\n  border-color: var(--td-green);\n}\n\n/* Section label */\n.port-section-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: var(--text-light);\n  padding: 12px 14px 6px;\n}\n\n/* Account cards — horizontal scroll */\n.port-acct-scroll {\n  display: flex;\n  gap: 10px;\n  padding: 0 14px 14px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.port-acct-scroll::-webkit-scrollbar { display: none; }\n.port-acct-card {\n  flex: 0 0 130px;\n  background: var(--bg-card);\n  border-radius: 10px;\n  border-top: 3px solid var(--td-green);\n  padding: 12px 12px 10px;\n}\n.port-acct-label {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 5px;\n}\n.port-acct-value {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n  margin-bottom: 6px;\n}\n.port-acct-room {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border-top: 1px solid var(--border-color);\n  padding-top: 6px;\n}\n.port-acct-room-label {\n  font-size: var(--font-2xs);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-light);\n}\n.port-acct-room-val {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-medium);\n}\n.port-acct-strategy {\n  font-size: var(--font-xs);\n  color: var(--text-light);\n  margin-top: 6px;\n  line-height: 1.3;\n}\n\n/* Holdings list */\n.port-holding-row {\n  display: flex;\n  align-items: center;\n  padding: 12px 14px;\n  border-top: 1px solid var(--border-color);\n  gap: 10px;\n}\n.port-holding-row:first-child { border-top: none; }\n.port-holding-ticker-wrap { flex: 1; min-width: 0; }\n.port-holding-ticker {\n  font-size: var(--font-sm);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.port-holding-name {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.port-holding-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n  flex-shrink: 0;\n}\n.port-holding-value {\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--text-dark);\n}\n.port-holding-gain {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  border-radius: 4px;\n  padding: 1px 5px;\n}\n.port-holding-gain.gain-up   { color: #4caf7d; background: rgba(76,175,80,0.12); }\n.port-holding-gain.gain-down { color: #e57373; background: rgba(229,115,115,0.12); }\n\n/* Section label row with \"View details\" link */\n.port-section-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px 6px;\n}\n.port-section-link {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  color: var(--td-green);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* ============================================================\n   REGISTERED ACCOUNTS SCREEN  (.ra-)\n   ============================================================ */\n\n/* Summary banner */\n.ra-summary-banner {\n  display: flex;\n  align-items: center;\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n  padding: 14px 0;\n}\n.ra-summary-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n}\n.ra-summary-val {\n  font-size: var(--font-lg);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.ra-summary-lbl {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.ra-summary-divider {\n  width: 1px;\n  height: 30px;\n  background: var(--border-color);\n}\n\n/* Tax callout strip */\n.ra-tax-callout {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  background: rgba(126,200,164,0.1);\n  border: 1px solid rgba(126,200,164,0.25);\n  border-radius: 10px;\n  margin: 10px 12px;\n  padding: 11px 12px;\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  line-height: 1.5;\n}\n\n/* Account card */\n.ra-card {\n  background: var(--bg-card);\n  border-radius: 12px;\n  margin: 0 12px 10px;\n  border-top: 3px solid var(--td-green);\n  overflow: hidden;\n}\n.ra-card-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 13px 14px 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  gap: 8px;\n}\n.ra-card-left { flex: 1; min-width: 0; }\n.ra-card-label {\n  font-size: var(--font-base);\n  font-weight: 700;\n  letter-spacing: 0.03em;\n}\n.ra-card-full-label {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ra-card-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.ra-card-value {\n  font-size: var(--font-base);\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.ra-card-gain {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n.ra-card-gain.gain-up   { color: #4caf7d; background: rgba(76,175,80,0.12); }\n.ra-card-gain.gain-down { color: #e57373; background: rgba(229,115,115,0.12); }\n\n/* Tax benefit badge (below header, always visible) */\n.ra-tax-badge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: var(--font-xs);\n  font-weight: 600;\n  padding: 4px 14px 10px;\n}\n\n/* Card expanded body */\n.ra-card-body {\n  padding: 0 14px 14px;\n  border-top: 1px solid var(--border-color);\n}\n\n/* Contribution room bar */\n.ra-room-wrap { margin-top: 12px; margin-bottom: 10px; }\n.ra-room-labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 6px;\n}\n.ra-room-track {\n  height: 8px;\n  border-radius: 4px;\n  background: var(--bg-light-gray);\n  display: flex;\n  overflow: hidden;\n}\n.ra-room-fill-used, .ra-room-fill-ytd, .ra-room-fill-avail {\n  height: 100%;\n  transition: width 0.4s ease;\n}\n.ra-room-legend {\n  display: flex;\n  gap: 10px;\n  margin-top: 5px;\n  flex-wrap: wrap;\n}\n.ra-room-legend span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n}\n.ra-legend-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n/* Annual / lifetime limits chips */\n.ra-limits-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.ra-limit-chip {\n  flex: 1;\n  background: var(--bg-light-gray);\n  border-radius: 8px;\n  padding: 7px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n.ra-limit-lbl { font-size: var(--font-xs); color: var(--text-medium); text-transform: uppercase; letter-spacing: 0.04em; }\n.ra-limit-val { font-size: var(--font-sm); font-weight: 700; color: var(--text-dark); }\n\n/* Deadline */\n.ra-deadline {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  background: rgba(122,174,232,0.1);\n  border: 1px solid rgba(122,174,232,0.25);\n  border-radius: 8px;\n  padding: 9px 11px;\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n.ra-deadline.urgent {\n  background: rgba(232,124,106,0.1);\n  border-color: rgba(232,124,106,0.3);\n  color: #e87c6a;\n}\n\n/* Tax detail */\n.ra-tax-detail {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: var(--font-sm);\n  color: var(--text-medium);\n  line-height: 1.5;\n  margin-bottom: 12px;\n}\n\n/* Holdings within account */\n.ra-holdings-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-light);\n  margin-bottom: 6px;\n}\n.ra-holding-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 5px;\n}\n.ra-holding-ticker {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  color: var(--text-dark);\n  width: 52px;\n  flex-shrink: 0;\n}\n.ra-holding-name {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ra-holding-bar-wrap {\n  width: 60px;\n  height: 5px;\n  background: var(--bg-light-gray);\n  border-radius: 3px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.ra-holding-bar {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.4s ease;\n}\n.ra-holding-pct {\n  font-size: var(--font-xs);\n  font-weight: 600;\n  color: var(--text-medium);\n  width: 30px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n/* Key facts */\n.ra-facts-title {\n  font-size: var(--font-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-light);\n  margin: 10px 0 6px;\n}\n.ra-fact-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin-bottom: 5px;\n}\n.ra-fact-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n.ra-fact-text {\n  font-size: var(--font-xs);\n  color: var(--text-medium);\n  line-height: 1.5;\n}\n\n/* CTA row */\n.ra-cta-row {\n  display: flex;\n  justify-content: center;\n  padding: 10px 12px 4px;\n}\n.ra-cta-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--font-sm);\n  font-weight: 600;\n  color: var(--td-green);\n  background: none;\n  border: 1px solid var(--td-green);\n  border-radius: 20px;\n  padding: 8px 20px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.ra-cta-btn:hover { background: rgba(0,138,62,0.08); }\n\n/* ═══════════════════════════════════════════════════════════════════\n   MOBILE OVERRIDES — must stay at end of file to win cascade battles\n   ═══════════════════════════════════════════════════════════════════ */\n@media (max-width: 600px) {\n\n  /* iOS: prevent body bounce scroll, fill dynamic viewport */\n  html, body { overflow: hidden; height: 100dvh; }\n\n  /* Safe area insets for notched iPhones (viewport-fit=cover) */\n  .phone-viewport {\n    padding-top: env(safe-area-inset-top);\n    padding-bottom: env(safe-area-inset-bottom);\n    box-sizing: border-box;\n  }\n  .bottom-nav {\n    padding-bottom: max(env(safe-area-inset-bottom), 8px);\n  }\n\n  /* Hide all desktop-only floating chrome */\n  .demo-nav, .theme-toggle-float, .global-save-btn, .version-label { display: none !important; }\n\n  /* Demo pulldown tab: TOP-CENTER, small tab pinned to the top edge */\n  .demo-pulldown-tab {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    position: fixed;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 9999;\n    height: 16px;\n    padding: 0 10px;\n    border-radius: 0 0 8px 8px;\n    background: rgba(30, 20, 60, 0.92);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    border: 1px solid rgba(255,255,255,0.15);\n    border-top: none;\n    color: rgba(255,255,255,0.75);\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    cursor: grab;\n    touch-action: none;      /* let pointer-drag work on touch without scrolling */\n    user-select: none;\n  }\n  .demo-pulldown-tab:active { background: rgba(30,20,60,0.75); cursor: grabbing; }\n  /* Double-tap collapses it to a small line handle hugging the top edge — a\n     minimal footprint, but still large enough to find and tap to restore. */\n  .demo-pulldown-tab.collapsed {\n    height: 8px;\n    padding: 0;\n    width: 60px;\n    min-height: 0;\n    border: none;\n    border-radius: 0 0 4px 4px;\n    background: rgba(30, 20, 60, 0.6);\n    opacity: 0.7;\n  }\n\n  .scroll-content { padding: 0 12px; }\n\n  /* Screen: bottom padding clears the 62px nav */\n  .screen { padding-bottom: 62px; }\n\n  /* ── Headers ── */\n  .simple-header { height: 52px; padding: 0 16px; flex-shrink: 0; }\n  .back-icon     { font-size: var(--font-xl); width: 22px; height: 22px; }\n\n  /* ── Bottom nav ── */\n  .bottom-nav { height: 62px; }\n\n  /* ── Account list items ── */\n  .account-list-item { padding: 14px 16px; }\n  .ali-name    { font-size: var(--font-base); white-space: normal; overflow: visible; text-overflow: clip; }\n  .ali-num     { font-size: var(--font-sm); }\n  .ali-balance { font-size: var(--font-base); }\n  .list-group-title { font-size: var(--font-sm); padding: 12px 16px 6px; }\n  .account-total-row { padding: 14px 16px; }\n\n  /* ── Services hub: 4-column grid ── */\n  .services-icon-grid { grid-template-columns: repeat(4, 1fr); gap: 12px 6px; padding: 12px 8px; }\n  .services-icon-tile { width: 100%; }\n  .services-icon-circle { width: 52px; height: 52px; border-radius: 14px; }\n  .services-icon-tile span { font-size: var(--font-xs); margin-top: 4px; }\n  .services-section-label { font-size: var(--font-xs); padding: 12px 12px 6px; }\n  .services-featured-title { font-size: var(--font-base); }\n  .services-featured-sub   { font-size: var(--font-sm); }\n\n  /* ── Transaction items ── */\n  .transaction-item { padding: 12px 16px; }\n  .ti-merchant { font-size: var(--font-base); white-space: normal; overflow: visible; text-overflow: clip; }\n  .ti-amount   { font-size: var(--font-base); }\n\n  /* ── Account/Credit hero header ── */\n  .hero-balance h1  { font-size: var(--font-2xl); }\n  .hero-balance p   { font-size: var(--font-sm); }\n  .tabs-container .tab { font-size: var(--font-sm); padding: 10px 14px; }\n\n  /* ── Credit / Security quick actions ── */\n  .cqa-icon { width: 44px; height: 44px; font-size: var(--font-xl); }\n  .sqa-icon { width: 40px; height: 40px; font-size: var(--font-lg); }\n\n  /* ── Chat FAB ── */\n  .chat-fab { width: 52px; height: 52px; bottom: 74px; right: 12px; }\n\n  /* ── Prevent iOS input zoom (must be ≥16px) ── */\n  input, select, textarea { font-size: 16px !important; }\n\n  /* ── Portfolio ── */\n  .port-hero-value { font-size: var(--font-2xl); }\n  .port-holding-ticker { font-size: var(--font-sm); }\n  .port-holding-name  { font-size: var(--font-xs); white-space: normal; }\n  .port-holding-value { font-size: var(--font-sm); }\n\n  /* ── Registered accounts ── */\n  .ra-card-value  { font-size: var(--font-lg); }\n  .ra-card-label  { font-size: var(--font-sm); }\n\n  /* ── Goals / cards ── */\n  .goal-card h3 { font-size: var(--font-base); }\n  .goal-stats strong { font-size: var(--font-base); }\n\n  /* ── Profile screen ── */\n  .profile-hero-name  { font-size: var(--font-xl); }\n  .profile-hero-sub   { font-size: var(--font-sm); }\n  .profile-hero-email { font-size: var(--font-sm); }\n  .profile-section-title  { font-size: var(--font-xs); }\n  .profile-balance-label  { font-size: var(--font-sm); }\n  .profile-balance-val    { font-size: var(--font-sm); }\n  .profile-settings-label { font-size: var(--font-sm); }\n  .profile-settings-value { font-size: var(--font-sm); }\n\n  /* ── Chat / Swipe suggestion chips ── */\n  /* Keep single-row horizontal scroll on mobile — wrapping fills the screen. */\n  .suggestions-row {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    gap: 6px;\n  }\n\n  /* ── SwipeScreen advisor card ── */\n  .swipe-card { width: calc(100% - 32px); max-width: 340px; }\n\n  /* ── Budget banner ── */\n  /* Large income figures with white-space:nowrap can push past 375px. */\n  .budget-banner-income { white-space: normal; font-size: var(--font-xl); }\n\n  /* ── Admin screen ── */\n  /* Ensure any wide content in admin panels scrolls rather than overflows. */\n  .admin-screen .bh-form-card { overflow-x: auto; }\n\n  /* ── EMT / Transfer ── */\n  /* Account balance badge: allow wrapping to second line on very narrow screens. */\n  .emt-account-balance { white-space: normal; }\n}\n\n/* ── ChatScreen BeHuman reskin (CSS-only, no JSX changes) ─────────────\n   Targets .chat-screen so other screens that use .simple-header etc.\n   are not affected. */\n.chat-screen .simple-header {\n  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);\n  color: var(--bh-white);\n  box-shadow: var(--shadow-md);\n}\n.chat-screen .new-chat-button {\n  background: rgba(0, 0, 0, 0.18);\n  border: 1px solid rgba(0, 0, 0, 0.18);\n  color: var(--bh-white);\n  border-radius: var(--radius-md);\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;\n}\n.chat-screen .new-chat-button:hover {\n  background: rgba(0, 0, 0, 0.28);\n  border-color: rgba(0, 0, 0, 0.28);\n}\n.chat-screen .chat-model-label { color: rgba(255,255,255,0.85); }\n.chat-screen .chat-title-text  { color: var(--bh-white); font-weight: 700; }\n\n/* Suggestion pills — closer to BeHuman QuickReply style */\n.chat-screen .chat-suggestion-chip {\n  background: var(--bh-white);\n  border: 1.5px solid var(--bh-light-gray);\n  color: var(--bh-black);\n  font-weight: 600;\n  font-size: var(--font-sm);\n  border-radius: var(--radius-full);\n  padding: 8px 16px;\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out, color 200ms ease-in-out;\n}\n.chat-screen .chat-suggestion-chip:hover {\n  background: var(--td-green-light);\n  border-color: var(--td-green);\n  color: var(--td-green);\n}\n\n/* Input bar — clean white pill with light border */\n.chat-screen .chat-input-area {\n  /* Match the scroll-content gray above so the surfaces flow, but add a\n     clear divider line + a soft shadow so the functional bar (suggestions\n     and textbox) reads as its own region rather than a continuation. */\n  background: var(--bg-light-gray);\n  border-top: 1px solid var(--border-color);\n  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);\n}\n.chat-screen .input-row {\n  /* Flip the textbox pill to white so it floats on top of the gray\n     surround — opposite of the original (gray pill on white). */\n  background: var(--bh-white);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  padding: 6px 6px 6px 18px;\n}\n.chat-screen .input-row input { font-size: var(--font-base); color: var(--bh-black); }\n.chat-screen .input-row input::placeholder { color: var(--bh-gray); }\n.chat-screen .send-button {\n  background: var(--td-green);\n  color: var(--bh-black);\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-full);\n  box-shadow: var(--shadow-sm);\n  transition: background 200ms ease-in-out, box-shadow 200ms ease-in-out;\n}\n.chat-screen .send-button:hover { background: var(--td-dark-green); box-shadow: var(--shadow-green); }\n\n/* Voice mode UI inside ChatScreen (Option A merger) */\n.chat-screen .new-chat-button.active {\n  background: var(--bh-black);\n  border-color: var(--bh-black);\n  color: var(--bh-white);\n}\n\n.chat-screen .mic-button {\n  width: 44px;\n  height: 44px;\n  background: var(--bh-light-gray);\n  color: var(--bh-black);\n  border: none;\n  border-radius: var(--radius-md);   /* buttons rounded per May 2026 rule */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-xl);\n  cursor: pointer;\n  margin-right: 6px;\n  transition: background 200ms ease-in-out, color 200ms ease-in-out;\n  flex-shrink: 0;\n}\n.chat-screen .mic-button:hover { background: var(--td-green-light); }\n.chat-screen .mic-button.active {\n  background: var(--td-red);\n  color: var(--bh-white);\n  animation: chat-mic-pulse 1.6s ease-out infinite;\n}\n/* Visual cue while the user is holding the mic — a circular green ring\n   closes in over ~600ms, telegraphing conversation mode is about to open.\n   Rendered via a ::before pseudo so the ring is a true circle even though\n   the mic button itself is a (potentially squared) tile. */\n.chat-screen .mic-button { position: relative; }\n.chat-screen .mic-button.long-pressing {\n  background: var(--td-green-light);\n  color: var(--td-green);\n}\n.chat-screen .mic-button.long-pressing::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  border: 2px solid var(--td-green);\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  /* Ring starts at 600 ms into the hold; conversation mode fires at 3000 ms.\n     That leaves 2400 ms for the animation to run — set duration to match. */\n  animation: chat-mic-longpress-ring 2.4s ease-out forwards;\n}\n@keyframes chat-mic-pulse {\n  0%   { box-shadow: 0 0 0 0   rgba(211, 47, 47, 0.55); }\n  70%  { box-shadow: 0 0 0 10px rgba(211, 47, 47, 0);    }\n  100% { box-shadow: 0 0 0 0   rgba(211, 47, 47, 0);    }\n}\n@keyframes chat-mic-longpress-ring {\n  /* Circle starts large and faint, contracts to wrap the button as the\n     hold completes — visual countdown toward conversation mode. */\n  0%   { width: 84px; height: 84px; opacity: 0.25; border-width: 2px; }\n  100% { width: 50px; height: 50px; opacity: 0.95; border-width: 3px; }\n}\n\n.chat-voice-status {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2xs);\n  font: var(--bh-body-sm);\n  color: var(--td-red);\n  padding: 0 var(--space-2xs) var(--space-2xs);\n  background: transparent;\n}\n.chat-voice-status.speaking {\n  color: var(--td-amber);\n  background: rgba(245, 158, 11, 0.08);\n  padding: var(--space-3xs) var(--space-2xs);\n  border-radius: var(--radius-full);\n  transition: background 0.15s ease;\n}\n.chat-voice-status.speaking:hover { background: rgba(245, 158, 11, 0.16); }\n.chat-voice-dot {\n  width: 8px;\n  height: 8px;\n  background: currentColor;\n  display: inline-block;\n  animation: chat-voice-dot-pulse 1.2s ease-in-out infinite;\n}\n@keyframes chat-voice-dot-pulse {\n  0%, 100% { opacity: 0.45; transform: scale(0.85); }\n  50%      { opacity: 1;    transform: scale(1.15); }\n}\n\n/* Per-message timestamp under each bubble (kit pattern). */\n.chat-message-time {\n  display: block;\n  margin-top: 4px;\n  font: var(--bh-caption);\n  color: var(--bh-gray);\n  letter-spacing: 0;\n}\n.bot-message  .chat-message-time { text-align: left; }\n.user-message .chat-message-time { text-align: right; }\n\n/* ── Bot reply: flat (no bubble fill) so long answers feel document-like.\n   User messages keep the green bubble defined earlier.\n   align-self: stretch overrides the wrapper's flex-start so the bubble\n   gets full wrapper width — required for ChartWrapper's recharts\n   container to have a defined width to render into. Without it, charts\n   collapse to 0×0 and the table-replacement vanishes silently. */\n.chat-bubble.chat-bubble--flat {\n  background: transparent !important;\n  color: var(--text-dark);\n  border: none;\n  box-shadow: none;\n  padding: 4px 0;\n  width: 100%;\n  max-width: 100%;\n  align-self: stretch;\n  border-bottom-left-radius: 0;\n}\n\n/* ── Per-bot-message action toolbar — copy / thumbs up / thumbs down.\n   ChatGPT-style: subtle gray icons, lights up on hover, active state for\n   the current feedback choice. Sits flush-left under the reply. */\n.chat-msg-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;                  /* tight cluster — no gap between buttons */\n  margin-top: 2px;\n  margin-left: -4px;       /* visually align icons with the message left edge */\n}\n.chat-msg-action {\n  background: transparent;\n  border: none;\n  color: var(--bh-gray);\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: color 150ms ease-in-out, background 150ms ease-in-out;\n}\n.chat-msg-action:hover {\n  color: var(--bh-black);\n  background: var(--bh-light-gray);\n}\n.chat-msg-action.is-active        { color: var(--td-green); }\n.chat-msg-action.is-active.is-danger { color: var(--td-red); }\n.chat-msg-action.is-success       { color: var(--td-green); }\n\n/* ── Conversation Mode (full-screen voice surface) ─────────────────────\n   On-brand BeHuman rebuild: Premium Green base (matches the Investing\n   high-net-worth aesthetic), bh-* typography tokens throughout, hero\n   pattern using bh-flow-hero conventions, BH primitive-style controls.\n   Lives over the chat surface; voice hooks are shared with ChatScreen so\n   exit returns to chat with all turns preserved in history. */\n.conv-mode {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(800px 500px at 50% 30%, rgba(47, 191, 0, 0.06) 0%, transparent 70%),\n    linear-gradient(180deg, var(--td-premium) 0%, var(--bh-black) 65%, #0a0a0a 100%);\n  color: var(--bh-white);\n  display: flex;\n  flex-direction: column;\n  z-index: 200;\n}\n\n/* Hero row — borrows the bh-flow-hero pattern (back button + centered\n   eyebrow title) but transparent over the premium dark background. */\n.conv-mode-header {\n  display: flex;\n  align-items: center;\n  padding: var(--space-md) var(--space-md) var(--space-sm);\n  flex-shrink: 0;\n}\n.conv-mode-back {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  color: var(--bh-white);\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;\n}\n.conv-mode-back:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.32);\n}\n.conv-mode-title {\n  flex: 1;\n  text-align: center;\n  font: var(--bh-overline);     /* BH eyebrow — uppercase + weighted */\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--td-gold);         /* premium accent — pairs with td-premium bg */\n  opacity: 0.85;\n}\n.conv-mode-spacer { width: 40px; }\n\n.conv-mode-stage {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-md);\n  padding: var(--space-md);\n  text-align: center;\n}\n\n.conv-mode-orb {\n  position: relative;\n  width: 220px;\n  height: 220px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n.conv-mode-orb:disabled { cursor: not-allowed; }\n\n.conv-mode-orb-core {\n  position: absolute;\n  inset: 30px;\n  border-radius: 50%;\n  /* Defaults are overridden by state variants below. */\n  background: radial-gradient(circle at 30% 30%, var(--td-green) 0%, var(--td-dark-green) 70%, var(--td-premium) 100%);\n  box-shadow: 0 0 60px rgba(47, 191, 0, 0.35), inset 0 0 40px rgba(0, 0, 0, 0.25);\n  transition: transform 600ms ease-in-out, box-shadow 600ms ease-in-out, background 600ms ease-in-out;\n}\n.conv-mode-orb-pulse {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: rgba(47, 191, 0, 0.18);\n  pointer-events: none;\n  opacity: 0;\n}\n\n/* State variants — orb mood matches the BH accent palette per phase. */\n.conv-mode.is-idle .conv-mode-orb-core {\n  /* Premium dim — feels in-tier with the background */\n  background: radial-gradient(circle at 30% 30%, rgba(207, 189, 145, 0.35) 0%, rgba(0, 43, 26, 0.6) 80%);\n  box-shadow: 0 0 30px rgba(207, 189, 145, 0.08);\n  transform: scale(0.92);\n}\n.conv-mode.is-listening .conv-mode-orb-core {\n  /* Shield green — the chart-1 accent, signals \"active\" */\n  background: radial-gradient(circle at 30% 30%, #66e02b 0%, var(--td-shield) 60%, var(--td-premium) 100%);\n  animation: conv-pulse 1.4s ease-in-out infinite;\n}\n.conv-mode.is-listening .conv-mode-orb-pulse {\n  animation: conv-ring-pulse 1.4s ease-out infinite;\n}\n.conv-mode.is-thinking .conv-mode-orb-core {\n  /* Lavender → purple — accent palette, calm but processing */\n  background: radial-gradient(circle at 30% 30%, var(--td-lavender) 0%, var(--td-purple) 70%, #1a0c2e 100%);\n  animation: conv-spin 3s linear infinite;\n}\n.conv-mode.is-speaking .conv-mode-orb-core {\n  background: radial-gradient(circle at 30% 30%, #66e02b 0%, var(--td-shield) 60%, var(--td-premium) 100%);\n  animation: conv-wave 0.9s ease-in-out infinite;\n}\n\n@keyframes conv-pulse {\n  0%, 100% { transform: scale(1); }\n  50%      { transform: scale(1.06); }\n}\n@keyframes conv-ring-pulse {\n  0%   { opacity: 0.55; transform: scale(0.85); }\n  70%  { opacity: 0;    transform: scale(1.15); }\n  100% { opacity: 0;    transform: scale(1.15); }\n}\n@keyframes conv-spin {\n  0%   { transform: rotate(0deg)   scale(0.98); }\n  50%  { transform: rotate(180deg) scale(1.02); }\n  100% { transform: rotate(360deg) scale(0.98); }\n}\n@keyframes conv-wave {\n  0%, 100% { transform: scale(1);    box-shadow: 0 0 60px rgba(47, 191, 0, 0.35); }\n  50%      { transform: scale(1.04); box-shadow: 0 0 90px rgba(47, 191, 0, 0.55); }\n}\n\n.conv-mode-status {\n  font: var(--bh-h2);            /* hero-card-title size — prominent on the surface */\n  color: var(--bh-white);\n  letter-spacing: -0.01em;\n  margin-top: var(--space-sm);\n}\n\n.conv-mode-transcript {\n  max-width: 480px;\n  font: var(--bh-body-lg);       /* readable body across the empty stage */\n  color: rgba(255, 255, 255, 0.7);\n  font-style: italic;\n  line-height: 1.5;\n}\n\n.conv-mode-hint {\n  max-width: 380px;\n  padding: var(--space-sm) var(--space-md);\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  font: var(--bh-body-sm);\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.conv-mode-controls {\n  display: flex;\n  gap: var(--space-2xs);\n  justify-content: center;\n  padding: var(--space-md);\n  flex-shrink: 0;\n}\n/* Outline-on-dark — sibling spirit to bh-btn-outline-dark, but inverted\n   colors so the buttons read on the premium dark surface. */\n.conv-mode-control {\n  background: transparent;\n  color: var(--bh-white);\n  border: 1.5px solid rgba(255, 255, 255, 0.22);\n  padding: 12px 20px;\n  font: var(--bh-body);\n  font-weight: 700;\n  min-height: 44px;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2xs);\n  cursor: pointer;\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out, color 200ms ease-in-out;\n}\n.conv-mode-control:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n.conv-mode-control--primary {\n  /* Pulls --btn-primary so it matches every other primary CTA app-wide */\n  background: var(--btn-primary);\n  color: var(--bh-black);\n  border-color: var(--btn-primary);\n}\n.conv-mode-control--primary:hover {\n  background: var(--btn-primary-hover);\n  border-color: var(--btn-primary-hover);\n  box-shadow: var(--shadow-green);\n}\n\n/* The orb is a deliberate circle — exempt from the global sharp-corner rule. */\n.phone-viewport .conv-mode-orb,\n.phone-viewport .conv-mode-orb-core,\n.phone-viewport .conv-mode-orb-pulse { border-radius: 50% !important; }\n\n/* ── VoiceBot BeHuman reskin (CSS-only) ─────────────────────────────── */\n.vb-screen { background: var(--bh-light-gray); }\n\n.vb-screen .vb-header {\n  background: linear-gradient(135deg, var(--td-green) 0%, var(--td-dark-green) 100%);\n  box-shadow: var(--shadow-md);\n  padding: var(--space-2xs) var(--space-sm);\n}\n.vb-screen .vb-header-title {\n  font: var(--bh-h3);\n  color: var(--bh-white);\n  letter-spacing: -0.01em;\n}\n.vb-screen .vb-header-action {\n  background: rgba(0,0,0,0.18);\n  border: 1px solid rgba(0,0,0,0.18);\n  color: var(--bh-white);\n  border-radius: var(--radius-md);\n  padding: 6px 10px;\n  font: var(--bh-caption);\n  font-weight: 600;\n  transition: background 200ms ease-in-out, border-color 200ms ease-in-out;\n}\n.vb-screen .vb-header-action:hover {\n  background: rgba(0,0,0,0.28);\n  border-color: rgba(0,0,0,0.28);\n}\n.vb-screen .vb-header-action.active {\n  background: var(--bh-black);\n  border-color: var(--bh-black);\n  color: var(--bh-white);\n}\n.vb-screen .vb-header .back-icon { color: var(--bh-white); }\n\n.vb-screen .vb-bubble {\n  font: var(--bh-body-sm);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n.vb-screen .vb-bubble.user {\n  background: var(--td-green);\n  color: var(--bh-black);\n}\n.vb-screen .vb-bubble.bot {\n  background: var(--bh-white);\n  color: var(--bh-black);\n  border: 1px solid var(--bh-light-gray);\n}\n\n.vb-screen .vb-orb-area {\n  background: var(--bh-white);\n  border-top: 1px solid var(--bh-light-gray);\n}\n.vb-screen .vb-status.listening { color: var(--td-red); }\n.vb-screen .vb-status.thinking  { color: var(--td-green); }\n.vb-screen .vb-status.speaking  { color: var(--td-amber); }\n\n/* ── BeHuman radius rules (May 2026) ───────────────────────────────────\n   Updated guideline:\n   - Rounded edges OK for: buttons, input fields, checkboxes, cards, tab items.\n   - Sharp edges REQUIRED for: component surfaces, navigation items, dividers,\n     holding shapes, image containers.\n   See styles/Guidelines.md for the full rules. The bh-* primitive tokens\n   handle the \"rounded\" categories automatically (radius-md/lg/xl). The rules\n   below force \"sharp\" categories to 0 since many of them inherited rounded\n   styling from legacy CSS or shared tokens. */\n\n/* Component surfaces / heroes / holding shapes — never rounded */\n.phone-viewport .bh-flow-hero,\n.phone-viewport .bh-flow-hero.dark,\n.phone-viewport .bh-flow-hero.tall,\n.phone-viewport .bh-balance-hero,\n.phone-viewport .bh-flow-body,\n.phone-viewport .scroll-content,\n.phone-viewport .home-scroll,\n.phone-viewport .account-details-scroll,\n.phone-viewport .account-details-content,\n.phone-viewport .simple-header,\n.phone-viewport .chat-header-outer,\n.phone-viewport .vb-screen .vb-header,\n.phone-viewport .profile-hero { border-radius: 0 !important; }\n\n/* Navigation items — bottom nav, sidebar */\n.phone-viewport .bottom-nav,\n.phone-viewport .bottom-nav .nav-item,\n.phone-viewport .sidebar-overlay,\n.phone-viewport .sidebar-content,\n.phone-viewport .sidebar-item,\n.phone-viewport .sidebar-divider,\n.phone-viewport .nav-list,\n.phone-viewport .nav-item,\n.phone-viewport .bh-home-topbar,\n.phone-viewport .bh-home-banner-wrapper { border-radius: 0 !important; }\n\n/* Image containers — promo banners, card images, photo wells */\n.phone-viewport .home-promo-banner,\n.phone-viewport .home-promo-img,\n.phone-viewport .home-promo-overlay,\n.phone-viewport .card-display-container,\n.phone-viewport .aeroplan-card,\n.phone-viewport .card-image,\n.phone-viewport .card-chip { border-radius: 0 !important; }\n\n/* Dividers and hairlines */\n.phone-viewport .vertical-divider,\n.phone-viewport .list-group-title { border-radius: 0 !important; }\n\n/* Focal-point icons that intentionally stay circular (status ring, avatars,\n   success checkmark — kit allows \"items that don't fit\" to be circles). */\n.phone-viewport .status-icon-ring,\n.phone-viewport .profile-avatar,\n.phone-viewport .csb-avatar-pulse,\n.phone-viewport .call-avatar,\n.phone-viewport .call-avatar-container,\n.phone-viewport .bh-success-icon { border-radius: 50% !important; }\n\n/* Chat FAB drawer-tab: rounded on the LEFT only, flat right edge */\n.phone-viewport .chat-fab,\n.phone-viewport .chat-fab-pulse { border-radius: 28px 0 0 28px !important; }\n\n/* App-icon squircle on the Services screen tiles — iOS app-icon convention */\n.phone-viewport .services-icon-circle { border-radius: 14px !important; }\n\n/* High-net-worth Investing screen — recolor green-themed legacy classes */\n.port-screen .port-range-btn.active {\n  background: var(--td-gold);\n  color: var(--bh-black);\n  border-color: var(--td-gold);\n}\n.port-screen .port-acct-card { border-top-width: 3px; }\n\n/* ── Admin panel ──────────────────────────────────────────────────────────── */\n/* Out-of-card descriptive text sits on the dark screen background → keep it\n   light. Text INSIDE the cards is on a white .bh-form-card in every theme, so\n   it must be a fixed dark colour (in dark mode --text-dark resolves to a light\n   colour, which was illegible on the white card). */\n.admin-screen .bh-muted { color: var(--text-light); }\n.admin-screen .bh-row { color: #1c1c28; }\n.admin-screen .bh-form-card,\n.admin-screen .bh-form-card .bh-row { color: #1c1c28; }\n.admin-screen .bh-form-card .bh-muted { color: #5a5f6a; }\n.admin-screen .bh-pill-btn {\n  display: inline-flex; align-items: center; gap: 5px;\n  padding: 6px 12px; border-radius: 999px;\n  background: var(--bg-light-gray); color: var(--text-dark);\n  border: 1px solid var(--border-color); cursor: pointer;\n  font-size: 13px; font-weight: 600; white-space: nowrap;\n  transition: filter .12s ease, opacity .12s ease;\n}\n.admin-screen .bh-pill-btn svg { font-size: 15px; }\n.admin-screen .bh-pill-btn:hover:not(:disabled) { filter: brightness(0.96); }\n.admin-screen .bh-pill-btn:disabled { opacity: 0.5; cursor: default; }\n.admin-screen .bh-pill-btn.danger {\n  background: transparent; color: var(--td-red); border-color: var(--td-red);\n}\n\n/* ── Change-password screen ─────────────────────────────────────────── */\n\n.change-password-screen .bh-flow-body {\n  padding: var(--space-md);\n}\n\n.change-password-screen .cp-subtitle {\n  display: block;\n  text-align: left;\n  font: var(--bh-body-sm);\n  color: var(--text-light);\n  margin: 0 0 var(--space-md);\n}\n\n.change-password-screen label {\n  display: block;\n  text-align: left;\n  font: var(--bh-body-sm);\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-top: var(--space-md);\n  margin-bottom: var(--space-3xs);\n}\n\n/* Remove top margin from the first label so the form starts cleanly */\n.change-password-screen form label:first-child {\n  margin-top: 0;\n}\n\n.change-password-screen .bh-btn-primary,\n.change-password-screen .bh-btn-secondary {\n  width: 100%;\n}\n\n.change-password-screen .bh-btn-primary {\n  margin-top: var(--space-md);\n}\n\n.change-password-screen .bh-btn-secondary {\n  margin-top: var(--space-sm);\n  color: var(--btn-secondary-outline);\n  border-color: var(--btn-secondary-outline);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
